webpackJsonp([0],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
		contextContent: function contextContent() {
				if (this.props.page_type == '503') {
						if (this.props.has_status_page == 'no') {
								return React.createElement(
										'p',
										null,
										'Go back to the previous page and try again.',
										React.createElement('br', null),
										'If you think something is broken, report a problem.'
								);
						} else if (this.props.has_status_page == 'non-customer') {
								return React.createElement(
										'p',
										null,
										'Check our status page for more information. Report a problem if you think we are unaware of the issue.'
								);
						} else {
								return React.createElement(
										'p',
										null,
										'Our status page is currently reporting a status of ',
										React.createElement(
												'strong',
												{ id: 'replace-with-fetched-data' },
												React.createElement(
														'em',
														null,
														'will fetch from status page...'
												)
										),
										'.'
								);
						}
				} else if (this.props.page_type == 'maintenance') {
						if (this.props.has_status_page == 'no') {
								return React.createElement(
										'p',
										null,
										'Sorry for the inconvenience. We\u2019ll be back up and running as fast as possible.'
								);
						} else if (this.props.has_status_page == 'non-customer') {
								return React.createElement(
										'div',
										null,
										React.createElement(
												'p',
												null,
												'Sorry for the inconvenience. We\u2019ll be back up and running as fast as possible.'
										),
										React.createElement(
												'p',
												null,
												'Check our status page for more information.'
										)
								);
						} else {
								return React.createElement(
										'div',
										null,
										React.createElement(
												'p',
												null,
												'This scheduled maintenance period is for ',
												React.createElement('br', null),
												React.createElement(
														'span',
														{ id: 'replace-with-fetched-data' },
														React.createElement(
																'em',
																null,
																'will fetch maintenance period...'
														)
												)
										),
										React.createElement(
												'p',
												null,
												'Check our status page for more information.'
										)
								);
						}
				}
		}
};

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tooltip__ = __webpack_require__(93);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Checkbox.prototype, "helpText", {
        get: function () {
            return this.props.helpText ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "help-block" }, this.props.helpText)) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "renderDisabledNotificationExplanation", {
        get: function () {
            var _a = this.props, disabled = _a.disabled, disabledReason = _a.disabledReason;
            if (!disabled) {
                return;
            }
            if (!disabledReason) {
                return;
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_tooltip__["a" /* default */], { title: this.props.disabledReason || '' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: function (e) { return e.preventDefault(); } }, "Why is this disabled?")));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "isChecked", {
        get: function () {
            if (typeof this.props.checked === 'boolean') {
                var _a = this.props, disabled = _a.disabled, retainCheckedState = _a.retainCheckedState, checked = _a.checked;
                return disabled ? (retainCheckedState ? checked : false) : checked;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.render = function () {
        var style = { marginRight: '10px' };
        if (this.props.disabled) {
            style.textDecoration = 'line-through';
            style.color = '#d1d1d1';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "controls" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "checkbox" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: this.props.name, value: "0" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", name: this.props.name, defaultChecked: this.props.defaultChecked, checked: this.isChecked, disabled: this.props.disabled, onChange: this.props.onChange, value: "1" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: style }, this.props.label),
                this.renderDisabledNotificationExplanation),
            this.helpText));
    };
    return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["default"] = (Checkbox);


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = __webpack_require__(232);
var ItemsCollection = __webpack_require__(233);
var Footer = __webpack_require__(235);

var cx = __webpack_require__(4);

var ItemsSelector = function (_React$Component) {
  _inherits(ItemsSelector, _React$Component);

  function ItemsSelector(props) {
    _classCallCheck(this, ItemsSelector);

    var _this = _possibleConstructorReturn(this, (ItemsSelector.__proto__ || Object.getPrototypeOf(ItemsSelector)).call(this, props));

    _this.selectItems = function (el, opts) {

      _this.state.items.forEach(function (item) {
        if (item.group) {
          item.showChildren = false;
          item.children.forEach(function (child) {
            child.selected = opts.items.indexOf(child.id) !== -1;
            item.showChildren = item.showChildren || child.selected;
          });
        } else {
          item.selected = opts.items.indexOf(item.id) !== -1;
        }
      });

      _this.setState(_this.state);
    };

    _this.toggleItems = function (items, forceValue) {
      if (!items || items.length === 0) return;
      if (forceValue !== true && forceValue !== false) forceValue = null;
      items = Array.isArray(items) ? items : new Array(items);

      items.forEach(function (item) {
        var index = void 0;
        if (item.group_id) {
          // this is a child component, so we need to find the group and target its items
          index = _this.state.items.findIndex(function (i) {
            return i.id === item.group_id;
          });
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _this.state.items[index].children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var child = _step.value;

              if (child.id === item.id) {
                child.selected = forceValue || !child.selected;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          // standard component
          index = _this.state.items.findIndex(function (i) {
            return i.id === item.id;
          });
          _this.state.items[index].selected = !_this.state.items[index].selected;
        }
        _this.setState(_this.state, _this.props.onToggle.bind(undefined, _this.state.items));
        _this._dispatchEvent();
      }, _this);
    };

    _this.clearAllItems = function () {
      _this.state.items.forEach(function (item) {
        if (item.children.length > 0) {
          item.children.forEach(function (child) {
            child.selected = false;
          });
        } else {
          item.selected = false;
        }
      });

      _this.setState(_this.state, _this.props.onToggle.bind(undefined, _this.state.items));
    };

    _this.togglePresentSelector = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
      _this.setState({ visible: !_this.state.visible });
    };

    _this.submit = function () {
      if (_this.props.submitTo) {
        window.location = _this.props.submitTo + _this._getSelectedIds().join(',');
      } else {
        _this.setState({ visible: !_this.state.visible });
      }
    };

    _this.state = {
      items: [],
      visible: !props.presentSelectorClickTargetId,
      hasGroupedItems: false
    };
    return _this;
  }

  _createClass(ItemsSelector, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._dispatchEvent();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _jquery2.default)(document.body).on('items-selector-choose', this.selectItems);
      this.setState({ items: this.structureItemsForDisplay(this.props.items) });
      if (this.props.toggleAllclickTargetId) {
        document.getElementById(this.props.toggleAllclickTargetId).addEventListener('click', this.toggleAllItems.bind(this));
      }
      if (this.props.presentSelectorClickTargetId) {
        document.getElementById(this.props.presentSelectorClickTargetId).addEventListener('click', this.togglePresentSelector.bind(this));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _jquery2.default)(document.body).off('items-selector-choose', this.selectItems);
      if (this.props.toggleAllclickTargetId) {
        document.getElementById(this.props.toggleAllclickTargetId).removeEventListener('click', this.toggleAllItems.bind(this));
      }
      if (this.props.presentSelectorClickTargetId) {
        document.getElementById(this.props.presentSelectorClickTargetId).removeEventListener('click', this.togglePresentSelector.bind(this));
      }
    }
  }, {
    key: 'structureItemsForDisplay',


    /**
     * Since our items come in as a flat list, we need to build the nested structure for grouped hierarchies
     * @returns {Array}
     */
    value: function structureItemsForDisplay(flatItems) {
      var _this2 = this;

      var items = [];

      var hasGroupedItems = false;

      flatItems.forEach(function (groupedItem) {
        groupedItem.children = flatItems.filter(function (item) {
          return item.group_id === groupedItem.id;
        });
        var childSelected = false;

        groupedItem.children.forEach(function (child) {
          hasGroupedItems = true;
          child.selected = _this2.props.preselectedItemIds.indexOf(child.id) > -1;
          if (child.selected) {
            childSelected = true;
          }
        }, _this2);

        // We want to ensure group parents are not being selected.
        if (groupedItem.children.length <= 0) {
          groupedItem.selected = _this2.props.preselectedItemIds.indexOf(groupedItem.id) > -1;
        }

        groupedItem.showChildren = childSelected;
        if (!groupedItem.group_id) {
          items.push(groupedItem);
        }
      }, this);

      this.setState({ hasGroupedItems: hasGroupedItems });

      return items;
    }

    /**
     * Toggle one or many items' selected state.  If forceValue is passed, set all items to that value.
     * @param items
     * @param {boolean} forceValue
     */

  }, {
    key: 'toggleAllItems',


    /**
     * Toggle all items' selected state
     */
    value: function toggleAllItems() {
      var groupedItemCount = 0;
      var selectedCount = 0;

      this.state.items.forEach(function (groupedItem) {
        if (groupedItem.children.length > 0) {
          groupedItem.children.forEach(function (child) {
            groupedItemCount++;
            if (child.selected) selectedCount++;
          });
        } else {
          groupedItemCount++;
          if (groupedItem.selected) selectedCount++;
        }
      });

      var newValue = selectedCount !== groupedItemCount;
      this.state.items.forEach(function (groupedItem) {
        if (groupedItem.children.length > 0) {
          groupedItem.children.forEach(function (child) {
            child.selected = newValue;
          });
        } else {
          groupedItem.selected = newValue;
        }
      });

      this.setState(this.state, this.props.onToggle.bind(undefined, this.state.items));
      this._dispatchEvent();
    }
  }, {
    key: 'selectedItems',


    /**
     * Currently selected items.
     * @returns {Array}
     */
    value: function selectedItems() {
      var selectedItems = [];
      this.state.items.forEach(function (item) {
        if (item.children.length > 0) {
          // It's a group!
          item.children.forEach(function (child) {
            if (child.selected) selectedItems.push(child);
          });
        } else if (item.selected) {
          // It's a flat item
          selectedItems.push(item);
        }
      });
      return selectedItems;
    }
  }, {
    key: 'hiddenField',
    value: function hiddenField() {
      var componentValues = this.selectedItems().map(function (item) {
        return item.id;
      }).join(',');

      return _react2.default.createElement('input', {
        type: 'hidden',
        id: this.props.hiddenFieldId,
        name: this.props.hiddenFieldName,
        value: componentValues });
    }
  }, {
    key: '_getSelectedIds',
    value: function _getSelectedIds() {
      return this.selectedItems().map(function (item) {
        return item.id;
      });
    }
  }, {
    key: '_dispatchEvent',
    value: function _dispatchEvent() {
      // This crap is because we only need to do this on pages that
      // are listening with jQuery.
      if (typeof jQuery !== 'undefined') {
        (0, _jquery2.default)(document.body).trigger('items-selector-changed', { selectedIds: this._getSelectedIds() });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: cx('grouped-items-selector', 'border-color', this.props.className),
          style: { display: !this.state.visible ? 'none' : null } },
        _react2.default.createElement(Header, { show: this.props.showHeader }),
        _react2.default.createElement(ItemsCollection, {
          items: this.state.items,
          toggleItems: this.toggleItems,
          hasGroupedItems: this.state.hasGroupedItems }),
        this.props.hiddenFieldName ? this.hiddenField() : null,
        _react2.default.createElement(Footer, {
          show: this.props.showFooter,
          onSubmit: this.submit,
          onClose: this.togglePresentSelector,
          onClear: this.clearAllItems })
      );
    }
  }]);

  return ItemsSelector;
}(_react2.default.Component);

ItemsSelector.propTypes = {
  className: _propTypes2.default.string, // class name applied to the container div
  hiddenFieldId: _propTypes2.default.string, // id attached to the hidden input
  hiddenFieldName: _propTypes2.default.string, // name attached to the hidden input
  items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired, // A collection of items to display.  Minimum required field is `name`
  onClose: _propTypes2.default.func, // a function that will be invoked when the modal is closed
  onToggle: _propTypes2.default.func, // a function that will be invoked when an item is toggled
  preselectedItemIds: _propTypes2.default.oneOfType([// A collection of preselected item ids
  _propTypes2.default.string, _propTypes2.default.array]),
  presentSelectorClickTargetId: _propTypes2.default.string, // We'll attach a listener to the supplied id that toggles visibility
  showHeader: _propTypes2.default.bool, // boolean to determine header visibility
  showFooter: _propTypes2.default.bool, // boolean to determine footer visibility
  submitTo: _propTypes2.default.func, // i honestly have no idea what this is.
  toggleAllclickTargetId: _propTypes2.default.string // handle for the toggle all switch, external to the component.
};
ItemsSelector.defaultProps = {
  className: null,
  hiddenFieldName: null,
  hiddenFieldId: null,
  onClose: new Function(),
  onToggle: new Function(),
  preselectedItemIds: [],
  presentSelectorClickTargetId: null,
  showHeader: false,
  showFooter: false,
  submitTo: new Function(),
  toggleAllclickTargetId: null
};


module.exports = ItemsSelector;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(21);

var _lodash2 = _interopRequireDefault(_lodash);

var _base = __webpack_require__(72);

var _base2 = _interopRequireDefault(_base);

var _querystring = __webpack_require__(254);

var _querystring2 = _interopRequireDefault(_querystring);

var _url = __webpack_require__(139);

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiRoutes = {};

/**
 * For every route in ROUTES_BY_NAME, ApiRoutes will have two methods, `<ROUTE NAME>_url` and `<ROUTE NAME>_path`.
 * Each will take parameters. If a parameter matches a route parameter, the route parameter is substituted for the
 * parameter value. The remaining parameters are serialized to a query string. Not providing the route parameters
 * will result in a runtime error.
 *
 * Example:
 * The route "resource_subchild_action": "/resource/:resourceId/subchild/:subchildId/action" will generate two
 * methods on ApiRoutes, `resource_subchild_action_url` and `resource_subchild_action_path`. Therefore, calling
 * `resource_subchild_action_path({resourceId: 'foo', subchildId: 'bar', search: 'query'})` would return the string
 * `"/resource/foo/subchild/bar/action?search=query"`, and
 * `resource_subchild_action_path({resourceId: 'foo', search: 'query'})` would throw a runtime error.
 */
var ROUTES_BY_NAME = {
  page_incidents: '/v1/pages/:pageCode/incidents',
  page_subscribers: '/v1/pages/:pageCode/subscribers.json',
  page_subscribers_count: '/v1/pages/:pageCode/subscribers/count.json',
  page_subscribers_histogram_by_state: '/v1/pages/:pageCode/subscribers/histogram_by_state.json',
  page_subscribers_reactivate: '/v1/pages/:pageCode/subscribers/reactivate',
  page_subscribers_unsubscribe: '/v1/pages/:pageCode/subscribers/unsubscribe',
  page_subscribers_resend_confirmation: '/v1/pages/:pageCode/subscribers/resend_confirmation',
  page_subscriber_resend_confirmation: '/v1/pages/:pageCode/subscribers/:subscriberCode/resend_confirmation'
};

/**
 * Consumes `params` to fill in route parameters.
 *
 * @param {Object} params The parameters to consume. Consumed parameters are removed from this object.
 * @param {String} path The route path to rewrite.
 * @returns {String} The rewritten path
 * @throws {Error} If a route parameter is not provided in `params`.
 */
var substituteParamsInPath = function substituteParamsInPath(params, path) {
  var routeParamRegex = /:(\w+)/;
  var match = routeParamRegex.exec(path);
  var newPath = path;
  while (match != null) {
    var fullMatch = match[0];
    var paramName = match[1];
    if (params && Object.prototype.hasOwnProperty.call(params, paramName)) {
      newPath = newPath.replace(fullMatch, encodeURIComponent(params[paramName]));
      delete params[paramName];
    } else {
      throw new Error('You must provide a ' + paramName);
    }

    match = routeParamRegex.exec(newPath);
  }
  return newPath;
};

Object.getOwnPropertyNames(ROUTES_BY_NAME).forEach(function (routeName) {
  ApiRoutes[routeName + '_path'] = function (params) {
    var newParams = _lodash2.default.clone(params);
    var newPath = substituteParamsInPath(newParams, ROUTES_BY_NAME[routeName]);
    if (Object.keys(newParams).length) {
      return newPath + '?' + _querystring2.default.encode(newParams);
    }
    return newPath;
  };

  ApiRoutes[routeName + '_url'] = function (params) {
    var newParams = _lodash2.default.clone(params);
    var newPath = substituteParamsInPath(newParams, ROUTES_BY_NAME[routeName]);
    return _url2.default.format({
      protocol: _base2.default.api_protocol,
      hostname: _base2.default.api_host,
      port: _base2.default.api_port,
      pathname: newPath,
      query: newParams
    });
  };
});

exports.default = ApiRoutes;


module.exports = ApiRoutes;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = __webpack_require__(72);

var _base2 = _interopRequireDefault(_base);

var _request = __webpack_require__(73);

var _request2 = _interopRequireDefault(_request);

var _api_routes = __webpack_require__(112);

var _api_routes2 = _interopRequireDefault(_api_routes);

var _url = __webpack_require__(139);

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Subscriber = function (_Base) {
  _inherits(Subscriber, _Base);

  function Subscriber(attributes) {
    _classCallCheck(this, Subscriber);

    attributes.routes = {
      show: function show(options) {
        return Routes.page_subscribers_url.bind(null, {
          subscriber_id: options.id,
          page_id: attributes.item_id,
          host: _base2.default.api_host,
          port: _base2.default.api_port
        });
      }
    };

    return _possibleConstructorReturn(this, (Subscriber.__proto__ || Object.getPrototypeOf(Subscriber)).call(this, attributes));
  }

  _createClass(Subscriber, [{
    key: '_serializableObject',
    value: function _serializableObject() {
      return {
        email: this.email,
        phone_number: this.phone_number,
        phone_display: this.phone_display,
        endpoint: this.endpoint,
        created_at: this.created_at,
        updated_at: this.updated_at
      };
    }
  }], [{
    key: 'searchRoute',
    value: function searchRoute(options) {
      if (!options.page_id) throw new Error('You must provide a page_id');
      return _api_routes2.default.page_subscribers_url({ pageCode: options.page_id });
    }
  }, {
    key: 'showRoute',
    value: function showRoute(pageCode, subscriberCode) {
      if (!pageCode) throw new Error('You must provide a pageCode');
      var url = _url2.default.parse(Routes.page_subscriber_url(pageCode, { id: subscriberCode }));
      url.search = null;
      url.query = null;
      return _url2.default.format(url);
    }
  }, {
    key: 'search',
    value: function search(queryOptions) {
      var url = void 0;
      if (queryOptions.url) {
        url = queryOptions.url;
      } else {
        url = _api_routes2.default.page_subscribers_url({ pageCode: queryOptions.page_id });
      }

      return _request2.default.get({
        url: url,
        data: { q: queryOptions.query, sort_field: 'relevance' }
      }).then(function (response) {
        var results = response;
        return results.map(function (result) {
          var subscriber = new Subscriber(result);
          subscriber.highlights = result.highlight;
          return subscriber;
        });
      });
    }
  }, {
    key: 'getPage',
    value: function getPage(params) {
      return _request2.default.get({ url: _api_routes2.default.page_subscribers_url(params) });
    }
  }, {
    key: 'getCount',
    value: function getCount(params) {
      return _request2.default.get({ url: _api_routes2.default.page_subscribers_count_url(params) });
    }
  }, {
    key: 'getHistogramByState',
    value: function getHistogramByState(params) {
      return _request2.default.get({ url: _api_routes2.default.page_subscribers_histogram_by_state_url(params) });
    }
  }, {
    key: 'unsubscribeSubscribers',
    value: function unsubscribeSubscribers(pageCode, jsonBody) {
      return _request2.default.post({
        url: _api_routes2.default.page_subscribers_unsubscribe_url({ pageCode: pageCode }),
        data: JSON.stringify(jsonBody),
        dataType: 'json',
        contentType: 'application/json'
      });
    }
  }, {
    key: 'reactivateSubscribers',
    value: function reactivateSubscribers(pageCode, jsonBody) {
      return _request2.default.post({
        url: _api_routes2.default.page_subscribers_reactivate_url({ pageCode: pageCode }),
        data: JSON.stringify(jsonBody),
        dataType: 'json',
        contentType: 'application/json'
      });
    }
  }, {
    key: 'resendConfirmationSubscribers',
    value: function resendConfirmationSubscribers(pageCode, subscriberCodes) {
      var jsonBody = { subscribers: subscriberCodes };
      return _request2.default.post({
        url: _api_routes2.default.page_subscribers_resend_confirmation_url({ pageCode: pageCode }),
        data: JSON.stringify(jsonBody),
        dataType: 'json',
        contentType: 'application/json'
      });
    }
  }, {
    key: 'resendConfirmation',
    value: function resendConfirmation(pageCode, subscriberCode) {
      return _request2.default.post({
        url: _api_routes2.default.page_subscriber_resend_confirmation_url({ pageCode: pageCode, subscriberCode: subscriberCode })
      });
    }
  }]);

  return Subscriber;
}(_base2.default);

exports.default = Subscriber;


module.exports = Subscriber;

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_calendar__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_layer__ = __webpack_require__(129);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var momentDurationFormatSetup = __webpack_require__(115);
momentDurationFormatSetup(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);


var styles = __webpack_require__(142);
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.hideCalendar = function () {
            _this.setState({ showCalendar: false });
        };
        _this.showCalendar = function () {
            _this.setState({ showCalendar: true });
        };
        _this.selectValue = function (val) {
            var date = _this.props.selectedDate.clone();
            date.year(val.year);
            date.month(val.month - 1); // moment months are 0 indexed (0 = Jan)
            date.date(val.day);
            _this.hideCalendar();
            _this.props.onChange(date);
        };
        _this.changeValue = function (val) {
            _this.setState({
                month: val.month,
                year: val.year,
            });
        };
        _this.toggleCalendar = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({
                showCalendar: !_this.state.showCalendar,
            });
        };
        _this.calendar = function () {
            return !_this.state.showCalendar ? (undefined) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.calendarWrapper },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_calendar___default.a, { onBlur: _this.hideCalendar, onSelect: _this.selectValue, onChange: _this.changeValue, month: _this.state.month, year: _this.state.year, selected: [_this.state.selectedDate.format('YYYY-MM-DD')] })));
        };
        _this.handleEsc = function (event) {
            if (event.key === 'Escape') {
                _this.hideCalendar();
            }
        };
        _this.handleClickOutside = function (event) {
            if (_this.state.showCalendar) {
                var domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_this);
                if (!domNode ||
                    (event.target instanceof Node && !domNode.contains(event.target))) {
                    _this.hideCalendar();
                }
            }
        };
        _this.validation = function () {
            if (!_this.props.isValid) {
                return null;
            }
        };
        _this.onFocus = function (event) {
            if (event.target) {
                event.target.select();
            }
        };
        _this.onBlur = function (event) {
            _this.setState({ inputValue: _this.props.selectedDate.format('YYYY-MM-DD') });
        };
        _this.onChange = function (event) {
            var inputValue = event.target.value;
            _this.setState({ inputValue: inputValue });
            if (inputValue.match(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/)) {
                var date = __WEBPACK_IMPORTED_MODULE_2_moment_timezone__(inputValue, 'YYYY-MM-DD');
                if (!date.isValid()) {
                    return;
                }
                _this.props.onChange(date);
            }
        };
        _this.id = "datePickerid" + new Date().getTime();
        _this.state = {
            showCalendar: false,
            selectedDate: props.selectedDate,
            month: props.selectedDate.month() + 1,
            year: props.selectedDate.year(),
            inputValue: props.selectedDate.format('YYYY-MM-DD'),
        };
        return _this;
    }
    DatePicker.prototype.componentWillReceiveProps = function (props) {
        if (props.selectedDate) {
            this.setState({
                selectedDate: props.selectedDate,
                inputValue: props.selectedDate.format('YYYY-MM-DD'),
            });
        }
    };
    DatePicker.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside, true);
        document.addEventListener('keydown', this.handleEsc);
    };
    DatePicker.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside, true);
        document.removeEventListener('keydown', this.handleEsc);
    };
    DatePicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.datePicker },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_layer__["a" /* default */], { position: "bottom left", content: this.calendar(), autoFlip: false },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: this.id, className: styles.prepend },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa fa-calendar" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: this.id, name: this.props.name, className: __WEBPACK_IMPORTED_MODULE_3_classnames__('date-input', styles.dateInput), disabled: this.props.disabled, value: this.state.inputValue, onClick: this.toggleCalendar, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur }),
                    this.validation()))));
    };
    DatePicker.defaultProps = {
        disabled: false,
    };
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLORS_BY_NAME", function() { return COLORS_BY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEX_REGEX", function() { return HEX_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RGB_REGEX", function() { return RGB_REGEX; });
var COLORS_BY_NAME = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    'indianred ': '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
};
var HEX_REGEX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
var RGB_REGEX = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i;
var Color = /** @class */ (function () {
    /**
     * Take a hex string, an rgb/a string, color name or an object.
     * validate it and normalize to an rgba object
     * @param {string|object} colorStringOrObject
     * @returns {Color}
     */
    function Color(props) {
        var color;
        if (props instanceof Color) {
            color = props;
        }
        else if (typeof props === 'string') {
            color =
                Color.parseHex(props) ||
                    Color.parseRgb(props) ||
                    Color.parseColorName(props);
        }
        else {
            color = props;
        }
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        this.a = color.a || 1;
    }
    /**
     * Normalize 3 and 6 digit hex color strings
     * @param {String} hex string with single or double digit components
     * @returns String
     */
    Color.normalizeHexString = function (hex) {
        var newHex = '';
        if ((hex.indexOf('#') === 0 && hex.length === 4) || hex.length === 3) {
            for (var i = 0; i < hex.length; i += 1) {
                if (hex[i] !== '#')
                    newHex += hex[i] + hex[i];
            }
        }
        else {
            newHex = hex;
        }
        return newHex;
    };
    /**
     * Convert valid 6 or 3 character hex (less the hash) to a Color instance
     * Since we're converting from hex, alpha will always be 1.
     * @param {string} hex
     * @param {float} [opacity=1]
     * @returns {Color}
     */
    Color.parseHex = function (hex, opacity) {
        if (opacity === void 0) { opacity = 1; }
        var result = HEX_REGEX.exec(Color.normalizeHexString(hex));
        if (result === null)
            return null;
        return new Color({
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: opacity,
        });
    };
    /**
     * Convert a valid rgb/a string to a Color instance.
     * @param {string} string - rgb(1, 2, 3), rgba(1, 2, 3, 0.4), etc.
     * @returns {Color}
     */
    Color.parseRgb = function (value) {
        var result = RGB_REGEX.exec(value);
        if (result === null)
            return null;
        return new Color({
            r: parseInt(result[1], 10),
            g: parseInt(result[2], 10),
            b: parseInt(result[3], 10),
            a: result[4] ? parseInt(result[4], 10) : 1,
        });
    };
    /**
     * Is a given hex color string valid?
     * @param {String} hex string
     * @return {Boolean}
     */
    Color.hexIsValid = function (hex) {
        var pattern = HEX_REGEX;
        return pattern.test(Color.normalizeHexString(hex));
    };
    /**
     * Parse a color name and return a Color instance
     * @param {String} name
     * @return {Color}
     */
    Color.parseColorName = function (name) {
        if (typeof COLORS_BY_NAME[name.toLowerCase()] === 'undefined') {
            throw new Error('could not parse input');
        }
        return new Color(COLORS_BY_NAME[name.toLowerCase()]);
    };
    Color.componentToHex = function (value) {
        var hex = value.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    };
    Color.prototype.toHex = function () {
        return ("#" + Color.componentToHex(this.r) + Color.componentToHex(this.g) + Color.componentToHex(this.b)).toUpperCase();
    };
    Object.defineProperty(Color.prototype, "hex", {
        get: function () {
            return this.toHex();
        },
        enumerable: true,
        configurable: true
    });
    Color.prototype.toRgb = function () {
        return "rgb(" + [this.r, this.g, this.b].join(', ') + ")";
    };
    Object.defineProperty(Color.prototype, "rgb", {
        get: function () {
            return this.toRgb();
        },
        enumerable: true,
        configurable: true
    });
    Color.prototype.toRgba = function () {
        return "rgba(" + [this.r, this.g, this.b, this.a].join(', ') + ")";
    };
    Object.defineProperty(Color.prototype, "rgba", {
        get: function () {
            return this.toRgba();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Lightens the current color value by x%
     * @param {Number} value
     * @returns {Color}
     */
    Color.prototype.lighten = function (value) {
        this.r =
            Math.ceil(this.r * value + this.r) <= 255
                ? Math.ceil(this.r * value + this.r)
                : 255;
        this.g =
            Math.ceil(this.g * value + this.g) <= 255
                ? Math.ceil(this.g * value + this.g)
                : 255;
        this.b =
            Math.ceil(this.b * value + this.b) <= 255
                ? Math.ceil(this.b * value + this.b)
                : 255;
        return this;
    };
    /**
     * Darkens the current color value by x%
     * @param {Number} value
     * @returns {Color}
     */
    Color.prototype.darken = function (value) {
        this.r =
            Math.floor(this.r - this.r * value) >= 0
                ? Math.floor(this.r - this.r * value)
                : 255;
        this.g =
            Math.floor(this.g - this.g * value) >= 0
                ? Math.floor(this.g - this.g * value)
                : 255;
        this.b =
            Math.floor(this.b - this.b * value) >= 0
                ? Math.floor(this.b - this.b * value)
                : 255;
        return this;
    };
    return Color;
}());
/* harmony default export */ __webpack_exports__["default"] = (Color);


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(4);

var Item = function (_React$Component) {
  _inherits(Item, _React$Component);

  function Item() {
    _classCallCheck(this, Item);

    return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
  }

  _createClass(Item, [{
    key: 'checkbox',
    value: function checkbox() {
      var classes = ['fa', 'pull-right'];
      if (this.props.item.selected) {
        classes = cx(classes, 'fa-check-square-o');
      } else {
        classes = cx(classes, 'fa-square-o', 'color-secondary');
      }
      return React.createElement('i', { className: classes });
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['grouped-item', 'border-color', this.props.className];
      if (this.props.item.selected) classes.push('active');

      return React.createElement(
        'div',
        { className: cx(classes),
          onClick: this.props.toggle.bind(null, this.props.item) },
        React.createElement(
          'span',
          null,
          this.props.item.name
        ),
        React.createElement(
          'span',
          { style: { display: 'none' } },
          this.props.item.id
        ),
        this.checkbox()
      );
    }
  }]);

  return Item;
}(React.Component);

module.exports = Item;

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./app/javascript/utils/string_utils.ts
function underScore(input) {
    var result = input.replace(/([A-Z])/g, function ($1) { return ("_" + $1).toLowerCase(); });
    if (result.startsWith('_')) {
        result = result.substr(1);
    }
    return result;
}

// CONCATENATED MODULE: ./app/javascript/components/form.tsx
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var form_Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Form.prototype, "method", {
        get: function () {
            if (['put', 'patch'].includes(this.props.method.toLowerCase())) {
                return 'post';
            }
            return this.props.method;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form, "authenticityToken", {
        get: function () {
            var tags = document.getElementsByTagName('meta');
            for (var i = 0; i < tags.length; i += 1) {
                var tag = tags[i];
                if (tag.name === 'csrf-token') {
                    return tag.content;
                }
            }
            return;
        },
        enumerable: true,
        configurable: true
    });
    Form.prototype.appendFor = function (inputs) {
        var form_for = underScore(this.props.for);
        for (var i = 0; i < inputs.length; i += 1) {
            var input = inputs[i];
            if (!['utf8', '_method', 'authenticity_token'].includes(input.name) &&
                input.type !== 'submit') {
                input.name = form_for + "[" + input.name + "]";
            }
        }
    };
    Form.prototype.updateInputNames = function () {
        if (this.props.skipPrepend || !this.props.for || !this.form) {
            return;
        }
        this.appendFor(this.form.getElementsByTagName('input'));
        this.appendFor(this.form.getElementsByTagName('select'));
        this.appendFor(this.form.getElementsByTagName('textarea'));
    };
    Form.prototype.componentDidMount = function () {
        this.updateInputNames();
    };
    Form.prototype.render = function () {
        var _this = this;
        return (react["createElement"]("form", { ref: function (ref) { return ref && (_this.form = ref); }, action: this.props.action, method: this.method, onSubmit: this.props.onSubmit, acceptCharset: "UTF-8", className: this.props.className, id: this.props.id },
            react["createElement"]("input", { type: "hidden", name: "utf8", value: "\u0213" }),
            react["createElement"]("input", { type: "hidden", name: "_method", value: this.props.method }),
            react["createElement"]("input", { type: "hidden", name: "authenticity_token", value: Form.authenticityToken }),
            this.props.children));
    };
    Form.defaultProps = {
        method: 'POST',
        onSubmit: function () { },
    };
    return Form;
}(react["Component"]));
/* harmony default export */ var components_form = __webpack_exports__["default"] = (form_Form);


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(4);
var _ = __webpack_require__(21);
var ControlGroup = __webpack_require__(178);

var label = __webpack_require__(66).label;

var TextArea = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea(props) {
    _classCallCheck(this, TextArea);

    var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

    _this.displayName = 'TextArea';
    return _this;
  }

  _createClass(TextArea, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        ControlGroup,
        { className: this.props.className, style: this.props.style, label: this.props.label, helpBlockText: this.props.helpBlockText },
        React.createElement('textarea', { className: this.props.textareaClass,
          name: this.props.name,
          value: this.props.value,
          defaultValue: this.props.defaultValue,
          onChange: this.props.onChange,
          required: this.props.required,
          placeholder: this.props.placeholder,
          style: _.merge({ width: '100%' }, this.props.textareaStyle) })
      );
    }
  }]);

  return TextArea;
}(React.Component);

TextArea.defaultProps = {
  required: false,
  placeholder: null
};

module.exports = TextArea;

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Method; });
/* harmony export (immutable) */ __webpack_exports__["b"] = notify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var Method;
(function (Method) {
    Method["SHOW"] = "show";
    Method["DEFERRED"] = "deferred";
})(Method || (Method = {}));
var Notify = /** @class */ (function () {
    function Notify(props) {
        var _this = this;
        this.el = document.createElement('div');
        this.show = function () {
            _this.el.className = __WEBPACK_IMPORTED_MODULE_0_classnames__('cpt-notification', 'show', _this.props.cssClass);
            _this.el.innerText = _this.props.message;
            document.body.appendChild(_this.el);
            if (_this.props.autoHide) {
                setTimeout(_this.hide, _this.props.delay);
            }
        };
        this.hide = function () {
            try {
                document.body.removeChild(_this.el);
            }
            catch (e) {
                // Doesn't matter if we fail to remove the node -- if it's not there, the message is already hidden.
            }
        };
        // This function just sets the cookies for the 'old' jQuery code to render.  We don't handle it.
        this.deferred = function () {
            document.cookie = "HRBnotify=" + _this.props.message + "; path=/";
            document.cookie = "HRBnotifyclass=" + _this.props.cssClass + "; path=/";
            return null;
        };
        this.props = props;
        switch (this.props.method) {
            case Method.DEFERRED:
                this.deferred();
                return;
            case Method.SHOW:
                this.show();
                return;
        }
    }
    return Notify;
}());
function notify(message, opts) {
    var defaults = __assign({ message: message, id: "notify-" + Math.ceil(Math.random() * 1000000), delay: 5000, cssClass: 'info', method: Method.SHOW, autoHide: true }, opts);
    return new Notify(defaults);
}


/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"datePicker":"_37dhPcwUWNUMfjKk238SpJ","prepend":"_1ynIwyU7HA1N84_llUl_0j","calendarWrapper":"_2WNUopTqqg2FWW8BTuqHMR"};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  MODAL_PREFIX: 'modal-confirmation-'
};

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(5);

var STORAGE_KEY = 'statuspage.api.token';
var NEW_SESSION_COOKIE = 'statuspage_new_session';

var SessionStore = function () {
  function SessionStore() {
    _classCallCheck(this, SessionStore);

    // If this is a new session, clear out the session cache, to avoid weird session race conditions
    if (this._newSessionCookieSet()) {
      this.clear();
      this._clearNewSessionCookie();
    }
  }

  /**
   * Returns a session token
   * If the local sessionStorage doesn't have a token in memory,
   * get one from the remote session endpoint and return that.
   * @returns {Promise}
   */


  _createClass(SessionStore, [{
    key: 'get',
    value: function get() {
      var token = this._fetchLocalToken();
      if (token) {
        return Promise.resolve(token);
      } else {
        return this._fetchRemoteToken();
      }
    }

    /**
     * Clears the sessionStorage object.
     */

  }, {
    key: 'clear',
    value: function clear() {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }

    /**
     * Check to see if the new session cookie is set
     */

  }, {
    key: '_newSessionCookieSet',
    value: function _newSessionCookieSet() {
      var cookie = document.cookie.split('; ').filter(function (str) {
        return ~str.indexOf(NEW_SESSION_COOKIE);
      })[0];
      if (cookie && cookie.split('=')[1] === 'true') {
        return true;
      } else {
        return false;
      }
    }

    /**
     * Clears the new session cookie
     */

  }, {
    key: '_clearNewSessionCookie',
    value: function _clearNewSessionCookie() {
      document.cookie = NEW_SESSION_COOKIE + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    /**
     * Makes a get request for a current session token
     * If a token is successfully returned, store it in sessionStorage.
     * Otherwise, reject the error.
     * @returns {Promise}
     */

  }, {
    key: '_fetchRemoteToken',
    value: function _fetchRemoteToken() {
      var _this = this;

      return new Promise(function (resolve, reject) {

        $.ajax({
          contentType: 'application/json',
          url: Routes.current_session_path({ format: 'json' }),
          success: function success(response) {
            var token = response.user.session_token;
            // Set the token to session storage
            _this._setLocalToken(token);
            resolve(token);
          },
          error: reject
        });
      });
    }

    /**
     * @returns {String|null} session token from sessionStorage
     */

  }, {
    key: '_fetchLocalToken',
    value: function _fetchLocalToken() {
      return window.sessionStorage.getItem(STORAGE_KEY);
    }

    /**
     * @param {String} sessionToken Sets a token to sessionStorage
     */

  }, {
    key: '_setLocalToken',
    value: function _setLocalToken(sessionToken) {
      window.sessionStorage.setItem(STORAGE_KEY, sessionToken);
    }
  }]);

  return SessionStore;
}();

var sessionStore = new SessionStore();
module.exports = sessionStore;

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _input_commons = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ControlGroup = function (_React$Component) {
  _inherits(ControlGroup, _React$Component);

  function ControlGroup(props) {
    _classCallCheck(this, ControlGroup);

    var _this = _possibleConstructorReturn(this, (ControlGroup.__proto__ || Object.getPrototypeOf(ControlGroup)).call(this, props));

    _this.displayName = 'ControlGroup';
    return _this;
  }

  _createClass(ControlGroup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(['control-group', this.props.className]), style: this.props.style },
        _input_commons.label.call(this),
        _react2.default.createElement(
          'div',
          { className: 'controls' },
          this.props.children,
          _input_commons.helpBlock.call(this)
        )
      );
    }
  }]);

  return ControlGroup;
}(_react2.default.Component);

module.exports = ControlGroup;

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autocomplete__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_autocomplete__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var styles = __webpack_require__(259);
var timePresets = function () {
    var result = [];
    for (var h = 0; h < 24; h += 1) {
        for (var m = 0; m < 60; m += 15) {
            var hr = "00" + h;
            var min = "00" + m;
            hr = hr.substr(hr.length - 2, 2);
            min = min.substr(min.length - 2, 2);
            result.push(hr + ":" + min);
        }
    }
    return result;
};
var TimePicker = /** @class */ (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.renderItem = function (item, isHighlighted) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.item + " " + (isHighlighted ? styles.itemHighlighted : ''), key: item.value }, item.value)); };
        _this.renderMenu = function (children) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.menu }, children)); };
        _this.selectValues = function () {
            return timePresets().map(function (preset) {
                return { value: preset };
            });
        };
        _this.onSelect = function (value) {
            _this.setValue(value);
        };
        _this.onChange = function (e, value) {
            _this.setValue(value);
        };
        _this.setValue = function (value) {
            _this.setState({ value: value });
            if (value.match(/^[012][0-9]:[0-5][0-9]$/)) {
                var _a = value.split(':', 2), hr = _a[0], min = _a[1];
                _this.props.onChange(_this.props.selectedDate
                    .clone()
                    .hour(Number.parseInt(hr))
                    .minute(Number.parseInt(min)));
            }
        };
        _this.onBlur = function (event) {
            _this.setState({ value: _this.props.selectedDate.format('HH:mm') });
        };
        _this.onFocus = function (event) {
            if (event.target) {
                event.target.select();
            }
        };
        _this.inputField = function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ type: "text" }, props, { value: _this.state.value }))); };
        _this.timeInput = function () {
            return _this.props.disabled ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.autoComplete }, _this.inputField({
                className: __WEBPACK_IMPORTED_MODULE_1_classnames__('time-input', styles.timeInput),
                disabled: true,
            }))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_autocomplete__, { items: _this.selectValues(), getItemValue: function (item) { return item.value; }, renderItem: _this.renderItem, onChange: _this.onChange, onSelect: _this.onSelect, value: _this.state.value, inputProps: {
                    className: __WEBPACK_IMPORTED_MODULE_1_classnames__('time-input', styles.timeInput),
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    name: _this.props.name,
                }, wrapperStyle: { display: 'block' }, menuStyle: {
                    position: 'absolute',
                    height: '400px',
                    overflowY: 'scroll',
                    top: 'auto',
                    left: 'auto',
                    zIndex: 100,
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                } }));
        };
        _this.state = {
            value: props.selectedDate.format('HH:mm'),
        };
        return _this;
    }
    TimePicker.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.timePicker }, this.timeInput());
    };
    TimePicker.defaultProps = {
        disabled: false,
    };
    TimePicker.TIME_PRESETS = timePresets();
    return TimePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (TimePicker);


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _color = __webpack_require__(132);

var _color2 = _interopRequireDefault(_color);

var _lodash = __webpack_require__(21);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({
  displayName: 'exports',
  componentDidMount: function componentDidMount() {
    var initialized = false;
    this.$input = $(this.refs.input);
    this.$input.minicolors({
      theme: 'bootstrap',
      position: this.props.position || 'left',
      opacity: this.props.opacity ? this.props.opacity : false,
      letterCase: 'uppercase',
      change: function () {
        if (!initialized) return;
        var color = new _color2.default(this.$input.minicolors('rgbObject'));
        if (color) {
          this.props.onChange({ target: { value: color.toRgba() }, preventDefault: function preventDefault() {}
          });
        }
      }.bind(this)
    });
    var defaultValue = new _color2.default(this.props.defaultValue);
    this.$input.minicolors('opacity', defaultValue.a);
    this.$input.minicolors('value', defaultValue.toHex());
    initialized = true;
  },
  componentWillUnmount: function componentWillUnmount() {
    this.$input.minicolors('destroy');
  },
  manualEntry: function manualEntry(event) {
    this.lazyUpdate(event.target.value);
    event.preventDefault();
  },


  lazyUpdate: _lodash2.default.debounce(function (value) {
    var color = new _color2.default(value);
    if (color) {
      this.$input.minicolors('opacity', color.a);
      this.$input.minicolors('value', color.toHex());
    }
  }, 600),

  render: function render() {
    var classes = ['control-group color-control'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return _react2.default.createElement(
      'div',
      { className: classes.join(' '), style: this.props.style },
      _react2.default.createElement(
        'label',
        null,
        this.props.label
      ),
      _react2.default.createElement(
        'div',
        { className: 'controls' },
        _react2.default.createElement('input', { ref: 'input', type: 'text', name: this.props.name, onChange: this.manualEntry, defaultValue: this.props.defaultValue })
      )
    );
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "title",
    value: function title() {
      if (this.props.title && this.props.title.length > 0) {
        return React.createElement(
          "span",
          { className: "title font-large" },
          this.props.title
        );
      }
    }
  }, {
    key: "search",
    value: function search() {
      if (this.props.searchable) {
        return React.createElement("input", { className: "pull-right border-color", type: "text", name: "search", id: "filter-filter", placeholder: "search by name", onChange: this.props.onChange });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "header border-color", style: { display: !this.props.show ? 'none' : null } },
        this.title(),
        this.search(),
        React.createElement("div", { className: "clearfix" })
      );
    }
  }]);

  return Header;
}(React.Component);

module.exports = Header;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Item = __webpack_require__(133);
var Group = __webpack_require__(234);
var cx = __webpack_require__(4);

var GroupedItemsCollection = function (_React$Component) {
  _inherits(GroupedItemsCollection, _React$Component);

  function GroupedItemsCollection() {
    _classCallCheck(this, GroupedItemsCollection);

    return _possibleConstructorReturn(this, (GroupedItemsCollection.__proto__ || Object.getPrototypeOf(GroupedItemsCollection)).apply(this, arguments));
  }

  _createClass(GroupedItemsCollection, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'body' },
        React.createElement(
          'div',
          { className: cx('grouped-items', this.props.hasGroupedItems ? null : 'no-groups') },
          this.props.items.map(function (item, index) {
            if (item.group) {
              return React.createElement(Group, { group: item, toggleItems: this.props.toggleItems, key: index, showChildren: item.showChildren });
            } else {
              return React.createElement(Item, { item: item, toggle: this.props.toggleItems, key: index });
            }
          }.bind(this))
        )
      );
    }
  }]);

  return GroupedItemsCollection;
}(React.Component);

module.exports = GroupedItemsCollection;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var _ = __webpack_require__(21);
var Item = __webpack_require__(133);
var cx = __webpack_require__(4);

var Group = function (_React$Component) {
  _inherits(Group, _React$Component);

  function Group(props) {
    _classCallCheck(this, Group);

    var _this = _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, props));

    _this.state = {
      showChildren: false
    };
    return _this;
  }

  /**
   * Returns the currently selected children
   * @returns {Array}
   */


  _createClass(Group, [{
    key: 'selectedChildren',
    value: function selectedChildren() {
      return _.select(this.props.group.children, {
        selected: true
      });
    }

    /**
     * Does the group have any selected children?
     * @returns {boolean}
     */

  }, {
    key: 'anyChildrenSelected',
    value: function anyChildrenSelected() {
      return this.selectedChildren().length > 0;
    }

    /**
     * Are all the group's children selected?
     * @returns {boolean}
     */

  }, {
    key: 'allChildrenSelected',
    value: function allChildrenSelected() {
      var selectedChildrenCount = this.selectedChildren().length;
      return selectedChildrenCount === this.props.group.children.length;
    }

    /**
     * Toggle the display of the children
     */

  }, {
    key: 'toggleChildrenDisplay',
    value: function toggleChildrenDisplay() {
      this.setState({ showChildren: !this.state.showChildren });
    }

    /**
     * Toggle all chilrens' selected state.
     * @param event
     */

  }, {
    key: 'toggleSelectedChildren',
    value: function toggleSelectedChildren(event) {
      event.preventDefault();
      event.stopPropagation();
      var newValue = !this.allChildrenSelected();
      this.props.toggleItems(this.props.group.children, newValue);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ showChildren: this.props.showChildren });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ showChildren: nextProps.showChildren || nextProps.group.children.some(function (el) {
          return el.selected;
        }) });
    }
  }, {
    key: 'children',
    value: function children() {
      if (this.state.showChildren) {
        return this.props.group.children.map(function (item, index) {
          return React.createElement(Item, { className: 'child', item: item, toggle: this.props.toggleItems, key: index });
        }.bind(this));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['grouped-item', 'border-color', 'group-parent'];
      var visible = this.anyChildrenSelected() || this.state.showChildren;
      if (visible) {
        classes.push('active', 'open');
      }
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: cx(classes), onClick: this.toggleChildrenDisplay.bind(this) },
          React.createElement('i', { className: cx('color-secondary', 'fa', this.state.showChildren ? 'fa-minus' : 'fa-plus') }),
          React.createElement(
            'span',
            null,
            this.props.group.name
          ),
          ' ',
          React.createElement('i', { className: 'fa fa-ellipsis-v children-selected', style: { display: visible ? null : 'none' } }),
          React.createElement(
            'a',
            { href: '#',
              className: 'toggle-children pull-right color-secondary',
              onClick: this.toggleSelectedChildren.bind(this) },
            !this.allChildrenSelected() ? 'Check' : 'Uncheck',
            ' All'
          )
        ),
        this.children()
      );
    }
  }]);

  return Group;
}(React.Component);

module.exports = Group;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'submitButton',
    value: function submitButton() {
      return React.createElement(
        'a',
        { className: 'flat-button pull-right submit-button', onClick: this.props.onSubmit },
        this.props.submitText || 'Submit'
      );
    }
  }, {
    key: 'closeButton',
    value: function closeButton() {
      return React.createElement(
        'a',
        { className: 'flat-button pull-right close-button', onClick: this.props.onClose },
        'Close'
      );
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      return React.createElement(
        'a',
        { className: 'clear-filter pull-right', onClick: this.props.onClear },
        'Clear'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'footer', style: { display: !this.props.show ? 'none' : null } },
        this.submitButton(),
        this.closeButton(),
        this.clearFilter(),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return Footer;
}(React.Component);

module.exports = Footer;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentStatuses = exports.Component = undefined;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = exports.Component = _propTypes2.default.shape({
  based_on_status: _propTypes2.default.string,
  components: _propTypes2.default.array,
  id: _propTypes2.default.string.isRequired,
  is_group_parent: _propTypes2.default.bool,
  is_overridden: _propTypes2.default.bool,
  is_third_party: _propTypes2.default.bool,
  logo_url: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  position: _propTypes2.default.number,
  status: _propTypes2.default.string.isRequired
});

var ComponentStatuses = exports.ComponentStatuses = _propTypes2.default.shape({
  operational: _propTypes2.default.shape({
    color: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  }),
  degraded_performance: _propTypes2.default.shape({
    color: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  }),
  partial_outage: _propTypes2.default.shape({
    color: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  }),
  major_outage: _propTypes2.default.shape({
    color: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  }),
  under_maintenance: _propTypes2.default.shape({
    color: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  })
});

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);
var ReactDOMServer = __webpack_require__(172);

var cx = __webpack_require__(4);
var Loading = __webpack_require__(343);

var MIN_SEARCH_LENGTH = 3;

var ESSearchField = function (_React$Component) {
  _inherits(ESSearchField, _React$Component);

  /**
   * @param props See PropTypes for optional and required properties.
   */
  function ESSearchField(props) {
    _classCallCheck(this, ESSearchField);

    var _this = _possibleConstructorReturn(this, (ESSearchField.__proto__ || Object.getPrototypeOf(ESSearchField)).call(this, props));

    _this.searchSource = _this._createSearchSource(props.queryUrl);
    _this.state = {
      error: false,
      inputActive: false,
      menuOpen: false,
      commandKeyPressed: false,
      showDeleteButton: false
    };
    return _this;
  }

  // Create search source based on url


  _createClass(ESSearchField, [{
    key: '_createSearchSource',
    value: function _createSearchSource(url) {
      return new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: url,
          wildcard: '%QUERY',
          transport: this._transport.bind(this)
        } });
    }
  }, {
    key: '_transport',
    value: function _transport(options, onSuccess, onError) {
      var _this2 = this;

      var done = function done(data, textStatus, request) {
        if (_this2.state.error) {
          _this2.setState({ error: false }, onSuccess.bind(_this2, data));
        } else {
          onSuccess(data);
        }
      };

      var fail = function fail(request, textStatus, errorThrown) {
        _this2.setState({ error: true }, onError.bind(_this2, errorThrown));
      };

      this._request(options, done, fail);
    }
  }, {
    key: '_request',
    value: function _request(options, done, fail) {
      this.props.loadResults({ url: options.url }).then(done).catch(fail);
    }
  }, {
    key: '_getTypeahead',
    value: function _getTypeahead() {
      return $(ReactDOM.findDOMNode(this)).find('#es-search-field');
    }
  }, {
    key: '_clearField',
    value: function _clearField() {
      var $typeahead = this._getTypeahead();
      $typeahead.typeahead('val', '');
    }

    // HTML string for a loading screen

  }, {
    key: '_loadingScreen',
    value: function _loadingScreen() {
      return ReactDOMServer.renderToString(React.createElement(Loading, { loading: true }));
    }
  }, {
    key: '_noResultOrError',
    value: function _noResultOrError() {
      if (this.state.error) {
        return this._onError();
      } else {
        return this._noResults();
      }
    }

    // HTML string for when no results are found

  }, {
    key: '_noResults',
    value: function _noResults() {
      return ReactDOMServer.renderToString(React.createElement(NoResults, null));
    }

    // HTML string for errors

  }, {
    key: '_onError',
    value: function _onError() {
      return ReactDOMServer.renderToString(React.createElement(ErrorState, null));
    }

    // Typeahead "open" event is not realiable
    // Check the num characters someone has typed in and
    // add "open" class when min search length has been met

  }, {
    key: '_checkInputField',
    value: function _checkInputField(event) {
      var showDeleteButton = event.target.value.length > 0;
      var menuOpen = event.target.value.length >= MIN_SEARCH_LENGTH;
      this.setState({ showDeleteButton: showDeleteButton, menuOpen: menuOpen });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var $typeahead = this._getTypeahead();

      $typeahead.typeahead({
        minLength: MIN_SEARCH_LENGTH,
        highlight: false,
        classNames: {
          hint: "es-hint",
          highlight: "es-highlight",
          menu: "es-menu",
          cursor: "es-cursor"
        }
      }, {
        // HACK bug in typeahead causes limit rendering issues, PR opened but maintainer unresponsive
        limit: 1000,

        name: this.props.pluralizedResultName,
        source: this.searchSource,
        display: function display(suggestion) {
          return $typeahead.typeahead('val');
        },
        templates: {
          suggestion: this.props.template,
          pending: this._loadingScreen(),
          notFound: this._noResultOrError.bind(this)
        }
      }).on('typeahead:select', function (event, suggestion) {
        var url = _this3.props.mapResultToUiUrl(suggestion);
        if (_this3.state.commandKeyPressed) {
          window.open(url, '_blank');
          $('.es-menu').show();
        } else {
          window.location = url;
        }
      })

      // Style typeahead when active
      .on('typeahead:active', function () {
        _this3.setState({ inputActive: true });
      }).on('typeahead:idle', function () {
        _this3.setState({ inputActive: false });
      }).on('typeahead:close', function () {
        if (_this3.state.commandKeyPressed) {
          $('.es-menu').show();
        }
        _this3.setState({ menuOpen: false });
      });

      // Forward slash search focus
      $(window).keyup(function (event) {
        if (_this3._getCharCode(event) === 191 && event.target.type !== "text") {
          $('#es-search-field').focus();
        }
      });
    }
  }, {
    key: '_captureKeyDown',
    value: function _captureKeyDown(event) {
      if (this._isCommandClick(event)) {
        this.setState({ commandKeyPressed: true });
      }
    }
  }, {
    key: '_captureKeyUp',
    value: function _captureKeyUp(event) {
      if (this._isCommandClick(event)) {
        this.setState({ commandKeyPressed: false });
      }
    }
  }, {
    key: '_isCommandClick',
    value: function _isCommandClick(event) {
      var code = this._getCharCode(event);
      return code === 91 || code === 17;
    }
  }, {
    key: '_loseFocus',
    value: function _loseFocus(event) {
      $('.es-menu').hide();
      this.setState({ menuOpen: false });
    }

    // Cross browser supported key code getter

  }, {
    key: '_getCharCode',
    value: function _getCharCode(e) {
      return typeof e.which == "number" ? e.which : e.keyCode;
    }
  }, {
    key: 'render',
    value: function render() {
      var activeClass = this.state.inputActive ? "active" : "";
      var openClass = this.state.menuOpen ? "open" : "";

      var magClass = cx("mag-glass fa fa-search", activeClass);
      var inputClass = cx("typeahead form-control full-width", activeClass, openClass);

      return React.createElement(
        'div',
        { className: 'search-bar', style: { position: 'relative' },
          onKeyDown: this._captureKeyDown.bind(this),
          onKeyUp: this._captureKeyUp.bind(this),
          onBlur: this._loseFocus.bind(this) },
        React.createElement('i', { className: magClass }),
        React.createElement('i', { className: 'fa fa-times', onClick: this._clearField.bind(this), style: { display: this.state.showDeleteButton ? 'inline' : 'none' } }),
        React.createElement('input', { type: 'text',
          ref: 'input',
          id: 'es-search-field',
          className: inputClass,
          onKeyUp: this._checkInputField.bind(this),
          placeholder: 'Search' })
      );
    }
  }]);

  return ESSearchField;
}(React.Component);

ESSearchField.propTypes = {
  // The URL that will be hit to load search results. "%QUERY" will be replaced with the URL-escaped query string.
  // E.g. "/v1/pages/73nfvx10lnbd/subscribers.json?q=%QUERY&limit=10"
  queryUrl: _propTypes2.default.string.isRequired,

  // Pluralized lowercased name of the thing being searched for, used to apply CSS class for styling. E.g. "subscribers"
  pluralizedResultName: _propTypes2.default.string.isRequired,

  // Takes in an object of arguments and returns a promise which resolves to search results. Required options are:
  // * .url: specifies the URL which this function should hit to load search results.
  loadResults: _propTypes2.default.func.isRequired,

  // Takes in a search result and returns the URL for the UI view of that result
  mapResultToUiUrl: _propTypes2.default.func.isRequired,

  // Takes in a search result and returns the HTML string for how a search result should be rendered
  template: _propTypes2.default.func.isRequired
};

var ErrorState = function (_React$Component2) {
  _inherits(ErrorState, _React$Component2);

  function ErrorState() {
    _classCallCheck(this, ErrorState);

    return _possibleConstructorReturn(this, (ErrorState.__proto__ || Object.getPrototypeOf(ErrorState)).apply(this, arguments));
  }

  _createClass(ErrorState, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'no-results-area' },
        React.createElement(
          'p',
          null,
          '\uD83D\uDC79'
        ),
        React.createElement(
          'p',
          { className: 'error-text' },
          'There was an error completing your search.  Please try again later.'
        )
      );
    }
  }]);

  return ErrorState;
}(React.Component);

var NoResults = function (_React$Component3) {
  _inherits(NoResults, _React$Component3);

  function NoResults() {
    _classCallCheck(this, NoResults);

    return _possibleConstructorReturn(this, (NoResults.__proto__ || Object.getPrototypeOf(NoResults)).apply(this, arguments));
  }

  _createClass(NoResults, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'no-results-area' },
        React.createElement(
          'p',
          null,
          'No results found. Try keeping your search phrase more generic to get more results.'
        )
      );
    }
  }]);

  return NoResults;
}(React.Component);

module.exports = ESSearchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base = __webpack_require__(72);
var request = __webpack_require__(73);
var ApiRoutes = __webpack_require__(112);

var Incident = function (_Base) {
  _inherits(Incident, _Base);

  function Incident(attributes) {
    _classCallCheck(this, Incident);

    if (!attributes.page_id) throw new Error('You must provide a page_id');

    attributes.routes = {
      index: function index(options) {
        return Routes.page_incidents_url.bind(null, {
          page_id: attributes.page_id,
          host: Base.api_host,
          port: Base.api_port
        });
      },
      show: function show(options) {
        return Routes.page_incident_url.bind(null, {
          incident_id: options.incident_id,
          page_id: attributes.page_id,
          host: Base.api_host,
          port: Base.api_port
        });
      }
    };

    return _possibleConstructorReturn(this, (Incident.__proto__ || Object.getPrototypeOf(Incident)).call(this, attributes));
  }

  _createClass(Incident, [{
    key: '_serializableObject',
    value: function _serializableObject() {
      return {
        name: this.name,
        status: this.status,
        message: this.message,
        impact: this.impact,
        created_at: this.created_at,
        updated_at: this.created_at,
        scheduled_for: this.scheduled_for,
        scheduled_until: this.scheduled_until
      };
    }
  }], [{
    key: 'searchRoute',
    value: function searchRoute(options) {
      if (!options.page_id) throw new Error('You must provide a page_id');
      return ApiRoutes.page_incidents_url({ pageCode: options.page_id });
    }
  }, {
    key: 'search',
    value: function search(queryOptions) {
      var url = void 0;
      if (queryOptions.url) {
        url = queryOptions.url;
      } else {
        url = Incident.searchRoute({ page_id: queryOptions.page_id });
      }

      return request.get({
        url: url,
        data: { q: queryOptions.query }
      }).then(function (response) {
        var results = response;
        return results.map(function (result) {
          var incident = new Incident(result);
          incident.highlights = result['highlight'];
          return incident;
        });
      });
    }
  }]);

  return Incident;
}(Base);

module.exports = Incident;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constant {Object} The map of fields to display indexed by the type of subscriber.
 */
var SUBSCRIBER_DISPLAY_FIELD_BY_TYPE = {
  sms: 'display_phone_number',
  email: 'email',
  webhook: 'endpoint'
};

/**
 * @constant {Array} The list of subscribers types of which the front-end is aware.
 */
var NOTIFICATION_TYPES = ['email', 'sms', 'webhook'];

/**
 * @constant {Object} The map of title-cased display strings indexed by the type of subscriber.
 */
var SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE = {
  email: 'Email',
  sms: 'SMS',
  webhook: 'Webhook'
};

/**
 * @constant {Object} The map of sentence-cased display strings indexed by the type of subscriber.
 */
var SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE = {
  email: 'email',
  sms: 'SMS',
  webhook: 'webhook'
};

/**
 * @constant {Object} The map of messages to display for an empty list of subscribers indexed by the type.
 */
var QUARANTINE_EMPTY_LIST_MESSAGE_BY_TYPE = {
  email: _react2.default.createElement(
    'span',
    null,
    'If we have any reason to believe an email address cannot be contacted, that subscriber will be put into a quarantine and can be found here.'
  ),
  sms: _react2.default.createElement(
    'span',
    null,
    'If we have any reason to believe a phone number cannot be reached by SMS, that subscriber will be put into a quarantine and can be found here.'
  ),
  webhook: _react2.default.createElement(
    'span',
    null,
    'If we have any reason to believe an endpoint is not reachable or is not successfully processing your webhook, the subscriber will be put into a quarantine and can be found here.'
  )
};

/**
 * Formats a subscriber type and a histogram of counts by type into a styled span.
 *
 * @example
 * // returns <span>Email <span class="subtle">(101)</span></span>
 * renderSubscriberTypeAndCount("email", "active", {"email":{"active":101,"unconfirmed":100,"quarantined":99,"total":300}});
 * @example
 * // returns <span>Webhook</span>
 * renderSubscriberTypeAndCount("webhook");
 * @param   {string} type The type of the subscriber to render.
 * @param   {Object} [counts] The histogram of counts by subscriber type.
 * @returns {ReactElement} The subscriber type and count rendered to displayable HTML.
 */

function renderSubscriberCount(type, state, counts) {
  if (counts && counts[type] !== undefined && counts[type][state] !== undefined) {
    return _react2.default.createElement(
      'span',
      { className: 'subtle' },
      ' (',
      counts[type][state],
      ')'
    );
  }
  return null;
}

var Notifications = {
  NOTIFICATION_TYPES: NOTIFICATION_TYPES,
  QUARANTINE_EMPTY_LIST_MESSAGE_BY_TYPE: QUARANTINE_EMPTY_LIST_MESSAGE_BY_TYPE,
  SUBSCRIBER_DISPLAY_FIELD_BY_TYPE: SUBSCRIBER_DISPLAY_FIELD_BY_TYPE,
  SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE: SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE,
  SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE: SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE,
  renderSubscriberCount: renderSubscriberCount
};

exports.default = Notifications;


module.exports = Notifications;

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscriber; });
var Subscriber;
(function (Subscriber) {
    function displayMode(subscriber) {
        switch (subscriber.mode) {
            case 'email':
                return 'Email';
            case 'sms':
                return 'SMS';
            case 'webhook':
                return 'Webhook';
        }
    }
    Subscriber.displayMode = displayMode;
    function identifier(subscriber) {
        switch (subscriber.mode) {
            case 'email':
                return subscriber.email;
            case 'sms':
                return subscriber.display_phone_number;
            case 'webhook':
                return subscriber.endpoint;
        }
    }
    Subscriber.identifier = identifier;
})(Subscriber || (Subscriber = {}));


/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_COLORS", function() { return DEFAULT_COLORS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_color__ = __webpack_require__(132);

var DEFAULT_COLORS = {
    blue: '#3498DB',
    body_background: '#FFFFFF',
    border: '#E0E0E0',
    font: '#333333',
    graph: '#3498DB',
    green: '#2FCC66',
    light_font: '#AAAAAA',
    link: '#3498DB',
    orange: '#E67E22',
    red: '#E74C3C',
    yellow: '#F1C40F',
};
;
var PageColors = /** @class */ (function () {
    function PageColors(pageColors) {
        if (pageColors === void 0) { pageColors = DEFAULT_COLORS; }
        var colorArgs = Object.assign({}, DEFAULT_COLORS, pageColors);
        this.blue = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.blue);
        this.bodyBackground = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.body_background);
        this.border = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.border);
        this.font = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.font);
        this.graph = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.graph);
        this.green = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.green);
        this.lightFont = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.light_font);
        this.link = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.link);
        this.orange = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.orange);
        this.red = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.red);
        this.yellow = new __WEBPACK_IMPORTED_MODULE_0_components_color__["default"](colorArgs.yellow);
    }
    Object.defineProperty(PageColors.prototype, "operational", {
        get: function () {
            return this.green;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageColors.prototype, "underMaintenance", {
        get: function () {
            return this.blue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageColors.prototype, "partiallyDegraded", {
        get: function () {
            return this.yellow;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageColors.prototype, "minorOutage", {
        get: function () {
            return this.orange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageColors.prototype, "majorOutage", {
        get: function () {
            return this.red;
        },
        enumerable: true,
        configurable: true
    });
    return PageColors;
}());
/* harmony default export */ __webpack_exports__["default"] = (PageColors);


/***/ }),

/***/ 259:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu":"_1kyflWSsoOeatC79Lkpd5z","item":"_2dOkL9lUlA63wwhAcBQ-NX","itemHighlighted":"_2bRT7KBsw6vxSDn0ZAWHjg","timeInput":"_2DdKh9ta4EfNqjK_p6iGz5"};

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function ErrorPage(container, pageType, templateName) {
  this.$container = $(container);
  this.$contentContainer = this.$container.find(templateName == 'sign' ? '.sign-container' : '.content-container');
  this.pageType = pageType;
  this.templateName = templateName;
}

ErrorPage.prototype.centerContent = function () {
  var containerHeight = this.$container.outerHeight(),
      contentContainerHeight = this.$contentContainer.outerHeight(),
      top = (containerHeight - contentContainerHeight) / 2,
      offset = this.templateName == 'sign' ? -100 : 0;

  // // console.log(this.$contentContainer[0]);
  // // console.log('containerHeight = ' + containerHeight)
  // // console.log('contentContainerHeight = ' + contentContainerHeight)
  // // console.log('top = ' + top)

  this.$contentContainer.css('top', top + offset);
};

ErrorPage.prototype.initialize = function () {
  var self = this;

  this.centerContent();
  this.$container.on('resize', function (e) {
    e.preventDefault();
    e.stopPropagation();
    self.centerContent();
  });

  // fades in content on the plain template
  if (this.templateName == 'plain') {
    window.setTimeout(function () {
      self.$contentContainer.addClass('in');
    }, 500);
  }

  // swings sign in on the sign template
  if (this.templateName == 'sign') {
    $('.sign-container').animate({ textIndent: 0 }, {
      step: function step(now) {
        $(this).css({
          transform: 'rotate(' + now + 'deg)',
          'transform-origin': 'top center'
        });
      },

      duration: 1000,
      easing: 'easeOutBounce'
    });
  }
};

ErrorPage.prototype.createTimeRangeTag = function (start, end) {
  return '<time utime=' + start + ' simple_format="MMM DD, YYYY HH:mm">' + start + '</time> - <time utime=' + end + ' simple_format="MMM DD, YYYY HH:mm">' + end + '</time>.';
};

ErrorPage.prototype.handleStatusFetchSuccess = function (pageType, data) {
  if (pageType == '503') {
    $('#replace-with-fetched-data').html(data.status.description);
  } else if (data.scheduled_maintenances.length) {
    var maint = data.scheduled_maintenances[0];
    $('#replace-with-fetched-data').html(this.createTimeRangeTag(maint.scheduled_for, maint.scheduled_until));
    $.fn.localizeTime();
  } else {
    $('#replace-with-fetched-data').html('<em>(there are no active scheduled maintenances)</em>');
  }
};

ErrorPage.prototype.handleStatusFetchFail = function (pageType) {
  $('#replace-with-fetched-data').html('<em>(enter a valid Statuspage url)</em>');
};

ErrorPage.prototype.fetchStatus = function (pageUrl, pageType) {
  // console.log('in app.js fetch');
  if (!pageUrl || !pageType || pageType == '404') return;

  var url = '',
      self = this;

  if (pageType == '503') {
    url = pageUrl + '/api/v2/status.json';
  } else {
    url = pageUrl + '/api/v2/scheduled-maintenances/active.json';
  }

  $.ajax({
    type: 'GET',
    url: url
  }).success(function (data, status) {
    // console.log('success');
    self.handleStatusFetchSuccess(pageType, data);
  }).fail(function (xhr, msg) {
    // console.log('fail');
    self.handleStatusFetchFail(pageType);
  });
};

if (true) {
  module.exports = ErrorPage;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _types = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = __webpack_require__(4);

var ComponentStatusSelector = __webpack_require__(872);

var ComponentRow = function (_React$Component) {
  _inherits(ComponentRow, _React$Component);

  function ComponentRow() {
    _classCallCheck(this, ComponentRow);

    return _possibleConstructorReturn(this, (ComponentRow.__proto__ || Object.getPrototypeOf(ComponentRow)).apply(this, arguments));
  }

  _createClass(ComponentRow, [{
    key: '_displayToggleIcon',
    value: function _displayToggleIcon() {
      var classNames = 'fa group-parent-indicator';
      classNames = this.props.visible ? cx(classNames, 'fa-minus-square-o') : cx(classNames, 'fa-plus-square-o');

      return _react2.default.createElement('span', { className: classNames, onClick: this.props.onClick });
    }
  }, {
    key: '_displayThirdPartyLogo',
    value: function _displayThirdPartyLogo() {
      return _react2.default.createElement('img', { className: 'logo', src: this.props.component.logo_url, alt: this.props.component.name });
    }
  }, {
    key: '_displayStatusSelector',
    value: function _displayStatusSelector() {
      return _react2.default.createElement(ComponentStatusSelector, {
        pageParam: this.props.pageParam,
        currentStatus: this.props.currentStatus,
        component: this.props.component,
        componentStatuses: this.props.componentStatuses,
        isGroupParent: this.props.isGroupParent,
        isChild: this.props.isChild,
        informParent: this.props.informParent,
        toggleOverridden: this.props.toggleOverridden,
        shouldAutoUpdate: this.props.shouldAutoUpdate });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'table-row component-row' },
        this.props.isGroupParent ? this._displayToggleIcon() : null,
        this.props.component.is_third_party ? this._displayThirdPartyLogo() : null,
        _react2.default.createElement(
          'div',
          { className: 'component-name' },
          this.props.component.name
        ),
        this._displayStatusSelector(),
        _react2.default.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return ComponentRow;
}(_react2.default.Component);

ComponentRow.propTypes = {
  currentStatus: _propTypes2.default.string,
  component: _types.Component.isRequired,
  componentStatuses: _types.ComponentStatuses.isRequired,
  informParent: _propTypes2.default.func,
  isChild: _propTypes2.default.bool,
  isGroupParent: _propTypes2.default.bool,
  pageParam: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  shouldAutoUpdate: _propTypes2.default.bool.isRequired,
  toggleOverridden: _propTypes2.default.func,
  visible: _propTypes2.default.bool
};
ComponentRow.defaultProps = {
  informParent: new Function(),
  isChild: false,
  isGroupParent: false,
  onClick: undefined,
  toggleOverridden: new Function(),
  visible: false,
  currentStatus: null
};


module.exports = ComponentRow;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Displays an animated SVG as a loading icon.
function Loading(props) {
  return _react2.default.createElement(
    'div',
    { className: props.className, style: { display: props.loading ? 'block' : 'none' } },
    _react2.default.createElement(
      'div',
      { className: 'loading-circle' },
      _react2.default.createElement(
        'div',
        { className: 'loader' },
        _react2.default.createElement(
          'svg',
          { className: 'circular', viewBox: '25 25 50 50' },
          _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', r: '10', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
        )
      )
    )
  );
}

Loading.propTypes = {
  className: _propTypes2.default.string,
  loading: _propTypes2.default.bool
};

Loading.defaultProps = {
  className: '',
  loading: false
};

module.exports = Loading;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var classnames = __webpack_require__(4);
var label = __webpack_require__(66).label;
var helpBlock = __webpack_require__(66).helpBlock;

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.displayName = 'Input';
    return _this;
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: classnames(['control-group', this.props.className]), style: this.props.style },
        label.call(this),
        React.createElement(
          'div',
          { className: 'controls', style: this.props.controlsStyle },
          React.createElement('input', { className: this.props.inputClass,
            id: this.props.id,
            type: this.props.type || 'text',
            value: this.props.value,
            defaultValue: this.props.defaultValue,
            onChange: this.props.onChange,
            name: this.props.name,
            placeholder: this.props.placeholder }),
          helpBlock.call(this)
        )
      );
    }
  }]);

  return Input;
}(React.Component);

module.exports = Input;

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _color2 = __webpack_require__(132);

var _color3 = _interopRequireDefault(_color2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  background: function background() {
    if (this.props.template === 'background') {
      if (this.props.background_image) {
        return this.background_image(this.props.background_image);
      }
      return {};
    }
    if (this.props.background_color) {
      return this.background_color(this.props.background_color);
    }
    return {};
  },
  background_color: function background_color(color) {
    if (color) {
      return { backgroundColor: new _color3.default(color).toRgba() };
    }
    return {};
  },
  background_image: function background_image(url) {
    if (url) {
      return { backgroundImage: 'url("' + url + '")' };
    }
    return {};
  },
  borderColor: function borderColor(color) {
    if (color) {
      return { borderColor: new _color3.default(color).toRgba() };
    }
    return {};
  },
  color: function color(_color) {
    if (_color) {
      return { color: new _color3.default(_color).toRgba() };
    }
    return {};
  },
  primary_text_color: function primary_text_color() {
    return this.color(this.props.primary_text_color);
  },
  primaryBorderColor: function primaryBorderColor() {
    return this.borderColor(this.props.primary_text_color);
  },
  secondary_text_color: function secondary_text_color() {
    return this.color(this.props.secondary_text_color);
  },
  hrBackgroundColor: function hrBackgroundColor() {
    return this.background_color(this.props.secondary_text_color);
  },
  button: function button() {
    if (this.props.button_color && this.props.button_text_color) {
      return {
        background: new _color3.default(this.props.button_color).toRgba(),
        color: new _color3.default(this.props.button_text_color).toRgba()
      };
    }
    return {};
  },
  borderButton: function borderButton() {
    if (this.props.button_color) {
      return {
        color: new _color3.default(this.props.button_color).toRgba(),
        borderColor: new _color3.default(this.props.button_color).toRgba()
      };
    }
    return {};
  },


  /**
   * Shadow distance takes a max integer of 100, min of 0
   * the strength should be the inverse of the value divided by 100
   * We also need to normalize any color input, so that can happen here too.
   * @returns {{boxShadow: string}}
   */
  shadow: function shadow() {
    if (this.props.shadow_distance) {
      var distance = this.props.shadow_distance;
      var strength = (100 - distance) / 100.0;
      var color = new _color3.default(this.props.shadow_color);
      color.a = strength;
      return { boxShadow: '0 0 ' + distance + 'px ' + color.toRgba() };
    }
    return {};
  },


  /**
   * We should probably do a more descriptive name here, something relating to hiding.
   * @returns {*}
   */
  has_status_page: function has_status_page() {
    if (this.props.has_status_page === 'no') {
      return { display: 'none' };
    }
    return {};
  },


  /**
   * This is a simple multi object merge.  Takes an arbitrary number of objects
   * @returns {Object} single object with all the attributes of the inputed
   */
  mergeStyles: function mergeStyles() {
    var newObj = {};
    for (var i = 0; i < arguments.length; i++) {
      for (var attrname in arguments[i]) {
        newObj[attrname] = arguments[i][attrname];
      }
    }
    return newObj;
  },
  support_email_address: function support_email_address() {
    if (this.props.support_email_address) {
      if (this.props.support_email_address.indexOf('@') != -1) {
        return 'mailto:' + this.props.support_email_address;
      }

      return this.props.support_email_address;
    }
    return 'javascript:alert("Looks like you didn\'t add a Support URL on the previous step.")';
  },
  href: function href(url) {
    if (url) {
      // We need to add http to urls so the links work and aren't relative
      return url.toLowerCase().indexOf('http') < 0 ? 'http://' + url : url;
    }
    return '#';
  }
};

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var IncidentTemplateListItem = function (_React$Component) {
  _inherits(IncidentTemplateListItem, _React$Component);

  function IncidentTemplateListItem() {
    _classCallCheck(this, IncidentTemplateListItem);

    return _possibleConstructorReturn(this, (IncidentTemplateListItem.__proto__ || Object.getPrototypeOf(IncidentTemplateListItem)).apply(this, arguments));
  }

  _createClass(IncidentTemplateListItem, [{
    key: '_editLink',
    value: function _editLink() {
      return Routes.edit_page_incident_template_path(this.props.pageParam, this.props.template.id);
    }
  }, {
    key: '_handleDelete',
    value: function _handleDelete() {
      if (window.confirm('Are you sure you want to delete this template?')) {
        $.ajax({
          type: 'DELETE',
          url: Routes.page_incident_template_path(this.props.pageParam, this.props.template.id),
          dataType: 'JSON',
          success: function success(data, textStatus, xhr) {
            window.location.reload(true);
          },
          error: function error(xhr, textStatus) {
            HRB.utils.basicFailAndReload(xhr);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var template = this.props.template;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'strong',
          null,
          template.name
        ),
        React.createElement(
          'span',
          { className: 'actions' },
          React.createElement(
            'a',
            { href: '#', method: 'DELETE', onClick: this._handleDelete.bind(this) },
            'Delete'
          ),
          React.createElement(
            'a',
            { href: this._editLink() },
            'Edit'
          )
        )
      );
    }
  }]);

  return IncidentTemplateListItem;
}(React.Component);

module.exports = IncidentTemplateListItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(92);

var _inflection2 = _interopRequireDefault(_inflection);

var _select_input = __webpack_require__(74);

var _select_input2 = _interopRequireDefault(_select_input);

var _input = __webpack_require__(42);

var _input2 = _interopRequireDefault(_input);

var _form = __webpack_require__(134);

var _form2 = _interopRequireDefault(_form);

var _textarea = __webpack_require__(140);

var _textarea2 = _interopRequireDefault(_textarea);

var _type_selector = __webpack_require__(955);

var _type_selector2 = _interopRequireDefault(_type_selector);

var _coupon_selector = __webpack_require__(956);

var _coupon_selector2 = _interopRequireDefault(_coupon_selector);

var _plan_selector = __webpack_require__(957);

var _plan_selector2 = _interopRequireDefault(_plan_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateBillingSubscriptionModal = function (_React$Component) {
  _inherits(UpdateBillingSubscriptionModal, _React$Component);

  /**
   * A billing subscription tuning dialog.  Takes a billing subscription and hits the Manage::Admin::BillingSubscriptionController#create endpoint.
   *
   * @param props
   * @param props.coupons {Array}
   * @param props.plans {Array}
   * @param props.page
   * @param props.page.id
   * @param props.page.billing_subscription
   * @param props.page.billing_subscription.type
   * @param props.page.billing_subscription.effective_plan
   * @param props.page.billing_subscription.coupon_enabled
   * @param props.page.billing_subscription.plan_enabled
   * @param props.page.billing_subscription.quantity
   * @param props.page.billing_subscription.note
   * @param props.onClose {Function} Function to call when the modal is closed
   */
  function UpdateBillingSubscriptionModal(props) {
    _classCallCheck(this, UpdateBillingSubscriptionModal);

    var _this = _possibleConstructorReturn(this, (UpdateBillingSubscriptionModal.__proto__ || Object.getPrototypeOf(UpdateBillingSubscriptionModal)).call(this, props));

    _this.state = _this.props.page.billing_subscription;
    return _this;
  }

  _createClass(UpdateBillingSubscriptionModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState(newProps.page.billing_subscription);
    }
  }, {
    key: 'disableSubmitButton',
    value: function disableSubmitButton() {
      var $button = $(this.refs.submitButton);
      $button.text('Updating...');
      $button.addClass('disabled').attr('disabled', true);
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      if (event.target.name === 'billing_subscription[type]') {
        var newState = { type: event.target.value };
        // If the the new, selected type is NOT plan enabled,
        // We need to set the current plan to business.
        if (!this.props.types[event.target.value].plan_enabled) {
          // Fine the business plan, and add it to the new state object
          newState.plan = _.find(this.props.plans, { name: 'business' });
        }
        // set the new state
        this.setState(newState);
      } else if (event.target.name === 'billing_subscription[coupon]') {
        this.setState({ coupon: event.target.value });
      } else if (event.target.name === 'billing_subscription[plan_id]') {
        var plan_id = event.target.value;
        // Lookup the plan from the plans array
        this.setState({ plan: _.find(this.props.plans, { id: plan_id }) });
      }
    }
  }, {
    key: 'subscriptionIdInput',
    value: function subscriptionIdInput() {
      if (this.state.type !== 'StripeBillingSubscription') return;
      return _react2.default.createElement(_input2.default, { name: 'billing_subscription[subscription_id]',
        label: 'Subscription ID',
        helpBlockText: 'If you can\'t find an appropriate plan and discount, you can create a subscription in Stripe and apply it here.' });
    }
  }, {
    key: 'quantityInput',
    value: function quantityInput() {
      if (this.state.plan.cost !== 100) return;
      return _react2.default.createElement(_input2.default, { name: 'billing_subscription[quantity]',
        label: 'Quantity',
        defaultValue: this.state.quantity
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'modal hide fade', id: this.props.id },
        _react2.default.createElement(
          _form2.default,
          { ref: 'form', 'for': 'billing_subscription', action: Routes.page_admin_billing_subscriptions_path(this.props.page), method: 'POST', className: 'form-horizontal', skipPrepend: true, onSubmit: this.disableSubmitButton.bind(this) },
          _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            _react2.default.createElement(
              'a',
              { href: '#', className: 'close', 'data-dismiss': 'modal' },
              'x'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Update billing subscription'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-body', style: { maxHeight: 470 } },
            _react2.default.createElement(_type_selector2.default, { types: this.props.types,
              type: this.state.type,
              plan: this.state.plan,
              onChange: this.onChange.bind(this) }),
            _react2.default.createElement(_plan_selector2.default, { types: this.props.types,
              type: this.state.type,
              plan: this.state.plan,
              plans: this.props.plans,
              onChange: this.onChange.bind(this) }),
            this.quantityInput(),
            _react2.default.createElement(_coupon_selector2.default, { types: this.props.types,
              type: this.state.type,
              coupons: this.props.coupons,
              coupon: this.state.coupon,
              onChange: this.onChange.bind(this) }),
            this.subscriptionIdInput(),
            _react2.default.createElement(_textarea2.default, { name: 'billing_subscription[note]',
              label: 'Note',
              required: true,
              defaultValue: this.state.note })
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            _react2.default.createElement(
              'button',
              { className: 'cpt-button style-primary', ref: 'submitButton' },
              'Update Subscription'
            ),
            _react2.default.createElement(
              'a',
              { href: '#', id: this.props.id, 'data-dismiss': 'modal', className: 'close' },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return UpdateBillingSubscriptionModal;
}(_react2.default.Component);

module.exports = UpdateBillingSubscriptionModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabPanels;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tab_panel = __webpack_require__(498);

var _tab_panel2 = _interopRequireDefault(_tab_panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Virtual container for the tab content area.
// Exactly one of the child tab content areas is rendered.
function TabPanels(_ref) {
  var children = _ref.children,
      activeName = _ref.activeName;

  var clonedChildren = _react2.default.Children.map(children, function (child) {
    return _react2.default.cloneElement(child, { activeName: activeName });
  });
  return _react2.default.createElement(
    'div',
    null,
    clonedChildren
  );
}

TabPanels.propTypes = {
  activeName: _propTypes2.default.string,
  children: _propTypes2.default.arrayOf(_tab_panel2.default).isRequired
};

TabPanels.defaultProps = {
  activeName: null
};

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabPanel;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tab content area.
/* Cannot desctructure the for keyword here, unfortunately. */
function TabPanel(props) {
  var activeName = props.activeName,
      className = props.className,
      children = props.children;

  return _react2.default.createElement(
    'div',
    { style: { display: props.for === activeName ? 'block' : 'none' }, className: (0, _classnames2.default)('tab-panel', className) },
    children
  );
}

TabPanel.propTypes = {
  activeName: _propTypes2.default.node,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  for: _propTypes2.default.string.isRequired
};

TabPanel.defaultProps = {
  className: '',
  activeName: null
};

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabHeaders;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _tab_header = __webpack_require__(500);

var _tab_header2 = _interopRequireDefault(_tab_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// An ordered group of clickable headers, one of which is active.
function TabHeaders(_ref) {
  var children = _ref.children,
      activeName = _ref.activeName,
      className = _ref.className,
      onActivate = _ref.onActivate;

  var clonedChildren = _react2.default.Children.map(children, function (child) {
    return _react2.default.cloneElement(child, {
      activeName: activeName,
      onClick: function onClick() {
        return onActivate(child.props.name);
      }
    });
  });

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('tab-headers', className) },
    clonedChildren
  );
}

TabHeaders.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.shape({ type: _propTypes2.default.oneOf([_tab_header2.default]) })).isRequired,
  activeName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onActivate: _propTypes2.default.func
};

TabHeaders.defaultProps = {
  className: '',
  activeName: null,
  onActivate: function onActivate() {}
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabHeader;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// One clickable header for a tab group.
function TabHeader(_ref) {
  var name = _ref.name,
      activeName = _ref.activeName,
      onClick = _ref.onClick,
      className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    {
      onClick: onClick,
      className: (0, _classnames2.default)('tab-header', name === activeName ? 'active' : 'inactive', className) },
    children
  );
}

TabHeader.propTypes = {
  activeName: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  // On click, calls this callback.
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

TabHeader.defaultProps = {
  activeName: null,
  onClick: function onClick() {},
  className: ''
};

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CptAlertBox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_CLASSES = {
  info: 'fa-info-circle',
  warning: 'fa-warning',
  error: 'fa-exclamation-circle',
  success: 'fa-check-circle'
};

// Displays a header and body in a box.
// The box is formatted according to the type prop.
function CptAlertBox(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('alert-box', 'cpt-notification', props.type, 'in-page') },
    _react2.default.createElement(
      'div',
      { className: 'header' },
      _react2.default.createElement('span', { className: (0, _classnames2.default)('fa', ICON_CLASSES[props.type]), style: { marginRight: '4px' } }),
      props.header
    ),
    _react2.default.createElement(
      'div',
      { className: 'body' },
      props.body
    )
  );
}

CptAlertBox.propTypes = {
  type: _propTypes2.default.oneOf(['info', 'error', 'warning', 'success']).isRequired, // Dictating the display type
  // The larger, heading message
  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  // The larger, heading message
  body: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired
};

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pill = function (_Component) {
  _inherits(Pill, _Component);

  function Pill() {
    _classCallCheck(this, Pill);

    return _possibleConstructorReturn(this, (Pill.__proto__ || Object.getPrototypeOf(Pill)).apply(this, arguments));
  }

  _createClass(Pill, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)('pill', this.props.active ? 'active' : 'inactive', this.props.className),
          onClick: function onClick() {
            return _this2.props.onClick(_this2.props.value);
          } },
        this.props.children
      );
    }
  }]);

  return Pill;
}(_react.Component);

Pill.propTypes = {
  // `value` declares the value identifying this pill in the pill group.
  value: _propTypes2.default.string.isRequired,

  // `active` declares whether or not the pill is clickable.
  active: _propTypes2.default.bool,

  // On click, calls this callback with this component's `value` as the only arguemnt.
  onClick: _propTypes2.default.func,

  // The label/content of the pill group
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]))]).isRequired,
  className: _propTypes2.default.string
};
Pill.defaultProps = {
  active: false,
  onClick: function onClick() {},
  className: ''
};
exports.default = Pill;


module.exports = Pill;

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SubscriberState;
(function (SubscriberState) {
    SubscriberState["ACTIVE"] = "active";
    SubscriberState["QUARANTINED"] = "quarantined";
    SubscriberState["UNCONFIRMED"] = "unconfirmed";
})(SubscriberState || (SubscriberState = {}));
var SubscriberAction = /** @class */ (function (_super) {
    __extends(SubscriberAction, _super);
    function SubscriberAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriberAction.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "subscriber-action link-like foobar " + this.props.className, onClick: function (e) {
                return _this.props.onClick(e, undefined, _this.props.subscriberState);
            } }, this.props.children));
    };
    SubscriberAction.defaultProps = {
        className: '',
        children: null,
        onClick: function () { },
        subscriberState: 'active',
    };
    return SubscriberAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (SubscriberAction);


/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Confirm = /** @class */ (function (_super) {
    __extends(Confirm, _super);
    function Confirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCancel = function () {
            __WEBPACK_IMPORTED_MODULE_2_jquery__(document).trigger("statuspage.confirm." + _this.props.id + ".canceled");
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        _this.onConfirm = function () {
            __WEBPACK_IMPORTED_MODULE_2_jquery__(document).trigger("statuspage.confirm." + _this.props.id + ".confirmed");
            if (_this.props.onConfirm) {
                _this.props.onConfirm();
            }
        };
        _this.message = function () {
            if (!_this.props.message) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-body form-horizontal" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, _this.props.message)));
        };
        _this.children = function () {
            if (!_this.props.children)
                return null;
            return _this.props.children;
        };
        return _this;
    }
    Confirm.prototype.render = function () {
        var className = __WEBPACK_IMPORTED_MODULE_1_classnames__('modal hide fade modal-confirmation', this.props.className);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className, id: "modal-confirmation-" + this.props.id, style: { display: 'none' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-header" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", "data-dismiss": "modal", className: "close" }, "\u00D7"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, this.props.title)),
            this.message(),
            this.children(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-footer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", id: "btn-cancel-" + this.props.id, "data-dismiss": "modal", className: "close secondary", onClick: this.onCancel }, this.props.cancelText),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('cpt-button', this.props.confirmClass), "data-dismiss": "modal", id: "btn-confirm-" + this.props.id, onClick: this.onConfirm }, this.props.confirm_text))));
    };
    Confirm.defaultProps = {
        cancelText: 'Cancel',
        confirmClass: 'style-primary',
    };
    return Confirm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["default"] = (Confirm);


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ErrorPage = __webpack_require__(339);

module.exports = {
  componentDidMount: function componentDidMount() {
    this.errorPage = new ErrorPage('.error-page-wrapper', this.props.page_type, this.props.template);
    this.errorPage.initialize();
    if (!!this.props.page_code && this.props.has_status_page === 'customer') {
      this.fetch(this.props.page_code, this.props.page_type);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.page_code != nextProps.page_code) {
      this.fetch(nextProps.page_code, this.props.page_type);
    } else if (nextProps.has_status_page != this.props.has_status_page && nextProps.has_status_page === 'customer' && !!this.props.page_code) {
      this.fetch(this.props.page_code, this.props.page_type);
    }
  },
  fetch: function fetch(code, type) {
    var url = this.props.hosted_host.replace('hosted', code);
    this.errorPage.fetchStatus(url, type);
  }
};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpBlock = exports.Label = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var optional = function optional(required) {
  if (required === false) {
    return _react2.default.createElement(
      'small',
      null,
      '(optional)'
    );
  }
  return null;
};

/**
 * Input label
 * @deprecated
 * @returns {*}
 */
exports.label = function () {
  if (this.props.label) {
    return _react2.default.createElement(
      'label',
      null,
      this.props.label,
      ' ',
      optional(this.props.required)
    );
  }
  return null;
};

var Label = exports.Label = function Label(_ref) {
  var text = _ref.text,
      name = _ref.name,
      required = _ref.required;

  if (text) {
    return _react2.default.createElement(
      'label',
      { htmlFor: name },
      name,
      ' ',
      optional(required)
    );
  }
  return null;
};

Label.propTypes = {
  text: _propTypes2.default.string,
  name: _propTypes2.default.string,
  required: _propTypes2.default.bool
};

/**
 * Help block text
 * @returns {*}
 */
exports.helpBlock = function () {
  if (this.props.helpBlockText) {
    return _react2.default.createElement(
      'div',
      { className: 'help-block' },
      this.props.helpBlockText
    );
  }
  return null;
};

var HelpBlock = exports.HelpBlock = function HelpBlock(_ref2) {
  var text = _ref2.text;

  if (text) {
    return _react2.default.createElement(
      'div',
      { className: 'help-block' },
      text
    );
  }
  return null;
};

HelpBlock.propTypes = {
  text: _propTypes2.default.string
};

HelpBlock.defaultProps = {
  text: null
};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var request = __webpack_require__(73);

var AbstractMethodError = function (_Error) {
  _inherits(AbstractMethodError, _Error);

  function AbstractMethodError() {
    _classCallCheck(this, AbstractMethodError);

    return _possibleConstructorReturn(this, (AbstractMethodError.__proto__ || Object.getPrototypeOf(AbstractMethodError)).apply(this, arguments));
  }

  return AbstractMethodError;
}(Error);

;

var Base = function () {
  _createClass(Base, null, [{
    key: 'fetch',


    /**
     * Fetch object by id
     * @param id
     * @returns {Promise}
     */
    value: function fetch(id) {}
  }]);

  function Base(attributes) {
    _classCallCheck(this, Base);

    this.routes = attributes.routes;
    delete attributes.routes;
    this.request = request;
    this._setAttributes(attributes);
  }

  /**
   * Saves a new or existing record depending on if we have an id
   * @returns {Promise}
   */


  _createClass(Base, [{
    key: 'save',
    value: function save() {
      this._ensureRoutes();
      var data = {};
      data[this.constructor.name.toLowerCase()] = this._serializableObject();

      if (this.id) {
        // patch the record
        return this.request.patch({
          url: this.routes.show(this.id),
          data: data
        });
      } else {
        // post new record
        return this.request.post({
          url: this.routes.index,
          data: data
        });
      }
    }
  }, {
    key: 'update',
    value: function update(attributes) {
      this._setAttributes(attributes);
      return this.save();
    }
  }, {
    key: 'delete',
    value: function _delete() {
      this._ensureRoutes();
      if (!this.id) throw new Error('This object is not persisted.');

      var data = {};
      data[this.constructor.name.toLowerCase() + '_id'] = this.id;

      return this.request.delete({
        url: this.routes.show(data)
      });
    }
  }, {
    key: '_setAttributes',
    value: function _setAttributes(attributes) {
      for (var key in attributes) {
        this[key] = attributes[key];
      }
    }
  }, {
    key: '_serializableObject',
    value: function _serializableObject() {
      throw new AbstractMethodError();
    }
  }, {
    key: '_ensureRoutes',
    value: function _ensureRoutes() {
      if (!this.routes) throw new Error('You must provide a routes object in your constructor.');
    }
  }]);

  return Base;
}();

Base.api_host = window.location.hostname.replace('manage', 'api');
Base.api_port = window.location.port;
Base.api_protocol = window.location.protocol;

module.exports = Base;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _session = __webpack_require__(177);

var _session2 = _interopRequireDefault(_session);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_TIMEOUT = 20000; // ms
var DEFAULT_CONTENT_TYPE = 'application/json';

var Request = function () {
  function Request() {
    _classCallCheck(this, Request);
  }

  _createClass(Request, [{
    key: 'get',
    value: function get(options) {
      options.type = 'GET';
      return this._request(options);
    }
  }, {
    key: 'post',
    value: function post(options) {
      options.type = 'POST';
      return this._request(options);
    }
  }, {
    key: 'patch',
    value: function patch(options) {
      options.type = 'PATCH';
      return this._request(options);
    }
  }, {
    key: 'delete',
    value: function _delete(options) {
      options.type = 'DELETE';
      return this._request(options);
    }
  }, {
    key: '_request',
    value: function _request(options) {
      var _this = this;

      return _session2.default.get().then(function (session_token) {
        if (!options.url) throw new Error('You must provide a URL.');

        options.headers = options.headers || {};
        options.headers.Authorization = 'Bearer ' + session_token;

        options.contentType = options.contentType || DEFAULT_CONTENT_TYPE;
        options.timeout = options.timeout || DEFAULT_TIMEOUT;

        return new Promise(function (resolve, reject) {
          options.success = resolve;
          options.error = function (xhr, ajaxOptions, error) {
            // check for unauthorized
            if (!options.regenToken && (xhr.status === 401 || xhr.status === 403)) {
              // If we're unauthorized, we try again with a new JWT since the old one has expired.
              _session2.default.clear();
              options.regenToken = true;
              _this._request(options).then(resolve).catch(reject);
            } else {
              reject(error);
            }
          };

          options.crossDomain = true;
          _jquery2.default.ajax(options);
        });
      });
    }
  }]);

  return Request;
}();

var request = new Request();

exports.default = request;


module.exports = request;

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(21);

var _lodash2 = _interopRequireDefault(_lodash);

var _control_group = __webpack_require__(178);

var _control_group2 = _interopRequireDefault(_control_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectInput = function (_React$Component) {
  _inherits(SelectInput, _React$Component);

  function SelectInput(props) {
    _classCallCheck(this, SelectInput);

    var _this = _possibleConstructorReturn(this, (SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call(this, props));

    _this.displayName = 'Input';
    return _this;
  }

  _createClass(SelectInput, [{
    key: 'group',
    value: function group(_group, options) {
      return _react2.default.createElement(
        'optgroup',
        { key: _group, label: _group },
        options.map(function (option) {
          return SelectInput.option(option);
        })
      );
    }
  }, {
    key: 'options',
    value: function options() {
      var _this2 = this;

      if (this.props.children) {
        return this.props.children;
      } else if (this.props.groups && this.props.options) {
        return this.props.groups.map(function (group) {
          return _this2.group(group, _lodash2.default.filter(_this2.props.options, { group: group }));
        });
      } else if (this.props.options) {
        return this.props.options.map(SelectInput.option.bind(this));
      }
      return _react2.default.createElement('option', { value: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _control_group2.default,
        { className: this.props.className, style: this.props.style, label: this.props.label, helpBlockText: this.props.helpBlockText },
        _react2.default.createElement(
          'select',
          {
            className: (0, _classnames2.default)(this.props.selectClass, this.props.disabled ? 'disabled' : null),
            id: this.props.id,
            defaultValue: this.props.defaultValue,
            onChange: this.props.onChange,
            name: this.props.name,
            disabled: this.props.disabled,
            placeholder: this.props.placeholder },
          this.options()
        )
      );
    }
  }], [{
    key: 'option',
    value: function option(_option) {
      return _react2.default.createElement(
        'option',
        { key: _option.value || _option, value: _option.value || _option },
        _option.name || _option
      );
    }
  }]);

  return SelectInput;
}(_react2.default.Component);

module.exports = SelectInput;

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(60);

window.React = __webpack_require__(0);
window.ReactDOM = __webpack_require__(16);

window.AccessControlSearch = __webpack_require__(835);
window.BetterErrorPagesGetStarted = __webpack_require__(836);
window.ComponentToggler = __webpack_require__(870);
window.ComponentStatuses = __webpack_require__(871);
window.ConfirmModal = _confirm2.default;
window.HostHelper = __webpack_require__(877);
window.ExceedingAllocationsDashboard = __webpack_require__(880);
window.ConsentHub = __webpack_require__(881);
window.ImportSubscriberForm = __webpack_require__(882);
window.IncidentsSearchField = __webpack_require__(883);
window.IncidentTemplates = __webpack_require__(945);
window.IncidentTemplateForm = __webpack_require__(949);
window.ItemsSelector = __webpack_require__(110);
window.ModifyUser = __webpack_require__(951);
window.OrganizationPages = __webpack_require__(954);
window.PageAccessUsersForm = __webpack_require__(958);
window.PageAccessSearchField = __webpack_require__(960);
window.PageSubscription = __webpack_require__(962);
window.NotificationsSubscriberManager = __webpack_require__(963);
window.ResendConfirmationLink = __webpack_require__(975);
window.SingleSignOnForm = __webpack_require__(976);
window.SsoMetrics = __webpack_require__(977);
window.StrideConversations = __webpack_require__(978);
window.StrideConversationsAdminInfo = __webpack_require__(979);
window.SubscribersSearchField = __webpack_require__(980);
window.UnsubscribeButton = __webpack_require__(981);

window.ManageSubscription = __webpack_require__(982);
window.BackfillDateTimePicker = __webpack_require__(986);

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var inflect = __webpack_require__(92).inflect;
var _ = __webpack_require__(21);

var AccessControlSearch = function (_React$Component) {
  _inherits(AccessControlSearch, _React$Component);

  function AccessControlSearch(props) {
    _classCallCheck(this, AccessControlSearch);

    var _this = _possibleConstructorReturn(this, (AccessControlSearch.__proto__ || Object.getPrototypeOf(AccessControlSearch)).call(this, props));

    _this.searchSource = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: window.location.href.split('?')[0] + '/search?q=%QUERY',
        wildcard: '%QUERY',
        transform: function (response) {

          var groupResults = response.page_access_groups.map(function (group) {
            return {
              id: group.id,
              type: 'group',
              name: group.name,
              link: window.location.href.split('#')[0].replace('access-control', 'page-access-groups/') + group.id + '/edit',
              metadata: this.humanizedMetadata(group)
            };
          }.bind(this));

          var userResults = response.page_access_users.map(function (user) {
            return {
              id: user.id,
              type: 'user',
              name: user.email,
              link: window.location.href.split('#')[0].replace('access-control', 'page-access-users/') + user.id + (props.read_only ? '' : '/edit'),
              metadata: this.humanizedMetadata(user)
            };
          }.bind(this));

          // console.log(groupResults.concat(userResults));
          return groupResults.concat(userResults);
        }.bind(_this)
      }
    });
    return _this;
  }

  _createClass(AccessControlSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $(this.refs.input).typeahead(null, {
        name: 'access-control',
        display: 'name',
        source: this.searchSource,
        templates: {
          suggestion: _.template('<div class="item search-result" data-js-hook="page-access-<%= type %>-<%= id %>" onClick="window.location = \'<%= link %>\'">' + '<div class="main">' + '<% if (type === "group") { %>' + '<i class="fa fa-users"></i>' + '<% } else { %>' + '<i class="fa fa-user"></i>' + '<% } %>' + '<span class="name"><%= name %></span>' + '</div>' + '<div class="secondary small">' + '<span><%= metadata %></span>' + '</div>' + '</div>')
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $(this.refs.input).typeahead('destroy');
    }
  }, {
    key: 'humanizedMetadata',
    value: function humanizedMetadata(actor) {
      if (actor.group) {
        return 'Belongs to ' + actor.group;
      }
      var list = [];
      _.each(['component', 'metric'], function (field) {
        if (actor[field + 's_list'] === undefined) return;
        var count = actor[field + 's_list'].length;
        if (count > 0) {
          list.push(count + ' ' + inflect(field, count));
        }
      });
      if (list.length > 0) {
        return 'Has access to ' + list.join(' and ');
      } else {
        return 'Has no access to any components or metrics';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'search-bar', style: { position: 'relative' } },
        React.createElement('i', { className: 'mag-glass fa fa-search' }),
        React.createElement('i', { className: 'fa fa-times-circle', style: { display: 'none' } }),
        React.createElement('input', { type: 'text',
          ref: 'input',
          className: 'typeahead form-control full-width',
          id: 'access-control-search',
          placeholder: 'search by name, email, group or id' })
      );
    }
  }]);

  return AccessControlSearch;
}(React.Component);

module.exports = AccessControlSearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var _ = __webpack_require__(21);
var Preview = __webpack_require__(837);
var Header = __webpack_require__(855);
var Buttons = __webpack_require__(856);
var PageToggler = __webpack_require__(857);
var ErrorPage = __webpack_require__(339);

// Questions
var Welcome = __webpack_require__(858); // Step 0
var HaveStatusPage = __webpack_require__(859); // Step 1
var UrlsForm = __webpack_require__(861); // Step 2
var ChooseTemplate = __webpack_require__(862); // Step 3
var Personalize = __webpack_require__(863); // Step 4
var Download = __webpack_require__(868); // Step 5
var ThankYou = __webpack_require__(869); // Step 6

var GetStarted = function (_React$Component) {
  _inherits(GetStarted, _React$Component);

  function GetStarted(props) {
    _classCallCheck(this, GetStarted);

    var newProps = Object.assign({}, props);
    newProps = props.bep;
    newProps.reddit_link = props.reddit_link || '';
    newProps.hacker_news_link = props.hacker_news_link || '';
    newProps.product_hunt_link = props.product_hunt_link || '';
    newProps.thumbnails = props.thumbnails;
    newProps.defaults = props.defaults;

    var _this = _possibleConstructorReturn(this, (GetStarted.__proto__ || Object.getPrototypeOf(GetStarted)).call(this, props));

    var state = props.bep;
    state.loggedIn = window.loggedIn;
    state.page_type = '503';
    state.subscribe_to_news_letter = true;
    state.step = 0;
    state.downloadRequestSent = false;

    _this.state = state;
    _this.cache = {};

    _this.pushStateToServer = _.debounce(function () {
      // If there's nothing to update, don't push an update!
      if (Object.keys(_this.cache).length === 0) return;
      $.ajax({
        url: '/customize/' + _this.props.bep.id,
        type: 'PUT',
        data: { bep: _this.cache }
      }).always(function () {
        this.cache = {};
      }.bind(_this));
    }, 200);

    _this.getCodeFromUrl = _.debounce(function (value) {
      $.ajax({
        type: "GET",
        url: '/page_code?q=' + value
      }).success(function (response) {
        this.update('page_code', response.page.id);
      }.bind(_this)).fail(function () {
        ErrorPage.prototype.handleStatusFetchFail();
        this.triggerAlert('The Statuspage URL or code you entered was invalid.  Please try again.', 'error');
        this.setState({ page_code: null });
      }.bind(_this));
    }, 1000);
    return _this;
  }

  _createClass(GetStarted, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setWalkthroughHeight();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setWalkthroughHeight();
      $(window).on('resize', this.setWalkthroughHeight);

      this.preloadImages();
    }
  }, {
    key: 'preloadImages',
    value: function preloadImages() {
      // preloads template images to prevent need to resize after the step is shown
      var img1 = new Image(),
          img2 = new Image(),
          img3 = new Image();

      img1.src = this.props.thumbnails.plain;
      img2.src = this.props.thumbnails.background;
      img3.src = this.props.thumbnails.sign;
    }
  }, {
    key: 'setWalkthroughHeight',
    value: function setWalkthroughHeight() {
      var $elem = $('.step-container'),
          $wkHeader = $('.walkthrough-header'),
          $wkButtons = $('.walkthrough-buttons'),
          difference = ($(window).innerHeight() - $elem.outerHeight() - $wkHeader.outerHeight() - $wkButtons.outerHeight()) / 2;

      $elem.css('max-height', $(window).innerHeight() - $wkHeader.outerHeight() - $wkButtons.outerHeight());

      if (difference > 0) {
        $elem.css('margin-top', difference).css('margin-bottom', difference);
      } else {
        $elem.css('margin-top', 0).css('margin-bottom', 0);
      }
    }
  }, {
    key: 'resetDefaultValues',
    value: function resetDefaultValues(template) {
      var defaults = this.props.defaults[template];

      for (var prop in defaults) {
        if (prop == 'template') {
          return;
        }

        this.update(prop, defaults[prop]);
      }
    }
  }, {
    key: 'update',
    value: function update(key, value) {
      var _this2 = this;

      var newState = {};
      newState[key] = value;

      if (key === 'has_status_page') {
        newState.page_code = null;
      }

      // We need to cache our updates so the debounced server update posts everything
      this.cache[key] = value;

      this.setState(newState, function (state) {

        if (key === 'template') _this2.resetDefaultValues(value);

        if (key === 'status_page_url' && _this2.state.has_status_page === 'customer' && !!_this2.state.status_page_url) {
          _this2.getCodeFromUrl(value);
        }

        _this2.pushStateToServer();
      });
    }
  }, {
    key: 'renderQuestion',
    value: function renderQuestion() {
      switch (this.state.step) {
        case 0:
          return React.createElement(Welcome, null);
        case 1:
          return React.createElement(HaveStatusPage, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 2:
          return React.createElement(UrlsForm, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 3:
          return React.createElement(ChooseTemplate, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 4:
          return React.createElement(Personalize, _extends({}, this.state, { onChange: this.update.bind(this),
            resetDefaultValues: this.resetDefaultValues.bind(this) }));
        case 5:
          return React.createElement(Download, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 6:
          return React.createElement(ThankYou, _extends({}, this.state, { onChange: this.update.bind(this) }));
        default:
          return React.createElement(Welcome, _extends({}, this.state, { onChange: this.update.bind(this) }));
      }
    }
  }, {
    key: 'triggerAlert',
    value: function triggerAlert(text, type) {
      HRB.utils.notify(text, { cssClass: type });
    }
  }, {
    key: 'canContinue',
    value: function canContinue() {
      if (this.state.step === 5 && this.state.send_to_email_address && this.state.send_to_email_address.indexOf('@') > 1) {
        return true;
      } else if (this.state.step === 2 && this.state.has_status_page === 'customer' && !this.state.page_code) {
        return false;
      }
      return this.state.step <= 4 && this.state !== 6;
    }
  }, {
    key: 'canGoBack',
    value: function canGoBack() {
      return this.state.step !== 0;
    }
  }, {
    key: 'continue',
    value: function _continue() {
      if (this.canContinue()) {
        if (this.state.step === 1 && this.state.has_status_page === 'customer' && !!this.state.status_page_url && !this.state.page_code) {
          // If customer is selected, and a status page url is defined and page code is not, pull the page code
          this.getCodeFromUrl(this.state.status_page_url);
        }

        if (this.state.step === 5 && this.state.downloadRequestSent === false) {
          this.submitDownloadRequest();
        }
        this.setState({ step: this.state.step + 1 });
      }
    }
  }, {
    key: 'back',
    value: function back() {
      if (this.canGoBack()) {
        this.setState({ step: this.state.step - 1 });
      }
    }
  }, {
    key: 'continueText',
    value: function continueText() {
      if (this.state.step === 6) return null;
      return this.state.step === 5 ? 'Get Error Pages' : 'Continue';
    }
  }, {
    key: 'backText',
    value: function backText() {
      return this.state.step <= 1 ? null : 'Back';
    }
  }, {
    key: 'submitDownloadRequest',
    value: function submitDownloadRequest() {
      $.ajax({
        type: 'POST',
        url: '/request_download',
        data: {
          download_request: {
            send_to_email_address: this.state.send_to_email_address,
            bep_id: this.props.bep.id,
            subscribe_to_news_letter: this.state.subscribe_to_news_letter
          }
        },
        success: function success(response) {}
      });
      this.state.downloadRequestSent = true;
    }
  }, {
    key: 'setPageType',
    value: function setPageType(type) {
      this.update('page_type', type);
    }
  }, {
    key: 'preview',
    value: function preview() {
      if (this.state.step > 2 && this.state.step !== 6) {
        return React.createElement(
          'div',
          { className: 'preview-container' },
          React.createElement(PageToggler, _extends({}, this.state, { onChange: this.setPageType.bind(this) })),
          React.createElement(Preview, this.state)
        );
      }
      var height = $(window).outerHeight() + 'px';
      return React.createElement(
        'div',
        { className: 'preview-container', style: { display: 'table' } },
        React.createElement(
          'div',
          {
            style: { height: height, width: '100%', background: '#ddd', textAlign: 'center', display: 'table-cell', verticalAlign: 'middle' } },
          React.createElement('img', { src: '/logo?type=poke&poke_color=rgba(0, 0, 0, 0.03)', style: { width: '25%' } })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'walkthrough-container' },
          React.createElement(Header, { logoUrl: this.props.logo_url }),
          this.renderQuestion(),
          React.createElement(Buttons, {
            'continue': this.continue.bind(this),
            back: this.back.bind(this),
            continueText: this.continueText(),
            backText: this.backText()
          })
        ),
        this.preview()
      );
    }
  }]);

  return GetStarted;
}(React.Component);

module.exports = GetStarted;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var React = __webpack_require__(0);
var Templates = __webpack_require__(838);
var CustomStylesMixin = __webpack_require__(48);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'Preview',

  mixins: [CustomStylesMixin],

  componentDidMount: function componentDidMount() {
    this.has_status_page_value = this.props.has_status_page;
    this.setPreviewHeight();
    $(window).on('resize.setPreviewHeight', this.setPreviewHeight);
  },

  componentWillUnmount: function componentWillUnmount() {
    $(window).off('resize.setPreviewHeight');
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.has_status_page_value !== this.props.has_status_page) {
      $(this.refs.errorPageWrapper).trigger('resize');
    }
  },

  setPreviewHeight: function setPreviewHeight() {
    var $header = $('.bep-customize-header'),
        remainingHeight = window.innerHeight - $header.outerHeight(),
        optionSetHeight = $('.option-set').filter(':visible').outerHeight();

    var element = this.refs.errorPageWrapper;
    $(element).css('height', Math.max(remainingHeight, optionSetHeight) + 'px').trigger('resize');
  },

  templateByName: function templateByName(template, page_type) {
    var Template = Templates[template];
    var FourOhFour = Template.FourOhFour;
    var FiveOhThree = Template.FiveOhThree;
    var Maintenance = Template.Maintenance;
    switch (page_type) {
      case '404':
        return React.createElement(FourOhFour, this.props);
      case '503':
        return React.createElement(FiveOhThree, this.props);
      case 'maintenance':
        return React.createElement(Maintenance, this.props);
      default:
        new Error('Unknown template requested in preview_component.jsx');
    }
  },

  render: function render() {

    var classes = ['preview', 'error-page-wrapper', this.props.template];

    return React.createElement(
      'div',
      { className: classes.join(' '), ref: 'errorPageWrapper', style: this.background() },
      this.templateByName(this.props.template, this.props.page_type)
    );
  }

});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = {
  plain: {
    FourOhFour: __webpack_require__(839),
    FiveOhThree: __webpack_require__(841),
    Maintenance: __webpack_require__(842)
  },
  sign: {
    FourOhFour: __webpack_require__(843),
    FiveOhThree: __webpack_require__(844),
    Maintenance: __webpack_require__(851)
  },
  background: {
    FourOhFour: __webpack_require__(852),
    FiveOhThree: __webpack_require__(853),
    Maintenance: __webpack_require__(854)
  }
};

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var RevealMixin = __webpack_require__(65);
var CustomStylesMixin = __webpack_require__(48);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: '404',

  mixins: [CustomStylesMixin, RevealMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container' },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        '404'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Oops, the page you\'re looking for does not exist.'
      ),
      React.createElement('hr', { style: this.hrBackgroundColor() }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.primary_text_color() },
        React.createElement(
          'p',
          null,
          'You may want to head back to the homepage.',
          React.createElement('br', null),
          'If you think something is broken, report a problem.'
        )
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.homepage_url), style: this.borderButton(), target: '_blank' },
          'Go To Homepage'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
          'Report A Problem'
        )
      )
    );
  }
});

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(108);
var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);

var createReactClass = __webpack_require__(27);

module.exports = createReactClass({

  displayName: '503',

  mixins: [ContextContentMixin, RevealMixin, CustomStylesMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container' },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        '503'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Looks like we\'re having some server issues.'
      ),
      React.createElement('hr', { style: this.hrBackgroundColor() }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.primary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.has_status_page(), this.borderButton()), target: '_blank' },
          'View Status page'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
          'Report A Problem'
        )
      )
    );
  }
});

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(108);
var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  displayName: 'Maintenance',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container' },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        'Maintenance'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'We\'re undergoing a bit of scheduled maintenance.'
      ),
      React.createElement('hr', { style: this.hrBackgroundColor() }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.primary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url),
            style: this.mergeStyles(this.has_status_page(), this.borderButton()), target: '_blank' },
          'View Statuspage'
        )
      )
    );
  }

});

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var RevealMixin = __webpack_require__(65);
var CustomStylesMixin = __webpack_require__(48);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({
  displayName: 'exports',


  mixins: [RevealMixin, CustomStylesMixin],

  render: function render() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'sign-container' },
        React.createElement('div', { className: 'nob', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color)) }),
        React.createElement('div', { className: 'post left', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement('div', { className: 'post right', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement(
          'div',
          { className: 'pane', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color)) },
          React.createElement(
            'div',
            { className: 'headline', style: this.color(this.props.sign_text_color) },
            '404'
          ),
          React.createElement(
            'div',
            { className: 'context', style: this.color(this.props.sign_text_color) },
            'Oops, the page you\'re ',
            React.createElement('br', null),
            'looking for does not exist.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'text-container' },
        React.createElement(
          'div',
          { className: 'headline', style: this.secondary_text_color() },
          '404'
        ),
        React.createElement(
          'div',
          { className: 'context', style: this.primary_text_color() },
          React.createElement(
            'p',
            null,
            'You may want to head back to the homepage. ',
            React.createElement('br', null),
            'If you think something is broken, report a problem.'
          )
        ),
        React.createElement(
          'div',
          { className: 'buttons-container' },
          React.createElement(
            'a',
            { href: this.href(this.props.homepage_url), style: this.borderButton(), target: '_blank' },
            React.createElement('span', { className: 'fa fa-home' }),
            'Home Page'
          ),
          React.createElement(
            'a',
            { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
            React.createElement('span', { className: 'fa fa-warning' }),
            'Report Problem'
          )
        )
      )
    );
  }
});

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _color = __webpack_require__(845);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(108);
var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);


var createReactClass = __webpack_require__(27);
module.exports = createReactClass({
  displayName: 'exports',


  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  buttonsClass: function buttonsClass() {
    var className = "buttons-container";
    if (this.props.has_status_page == 'no') {
      className += " single-button";
    }
    return className;
  },

  render: function render() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'sign-container' },
        React.createElement('div', { className: 'nob', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color)) }),
        React.createElement('div', { className: 'post left', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement('div', { className: 'post right', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement(
          'div',
          { className: 'pane', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color)) },
          React.createElement(
            'div',
            { className: 'headline', style: this.color(this.props.sign_text_color) },
            '503'
          ),
          React.createElement(
            'div',
            { className: 'context', style: this.color(this.props.sign_text_color) },
            'Looks like we\'re having',
            React.createElement('br', null),
            'some server issues.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'text-container' },
        React.createElement(
          'div',
          { className: 'headline', style: this.secondary_text_color() },
          '503'
        ),
        React.createElement(
          'div',
          { className: 'context', style: this.primary_text_color() },
          this.contextContent()
        ),
        React.createElement(
          'div',
          { className: this.buttonsClass() },
          React.createElement(
            'a',
            { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.borderButton(), this.has_status_page()), target: '_blank' },
            React.createElement('span', { className: 'fa fa-power-off' }),
            'View Statuspage'
          ),
          React.createElement(
            'a',
            { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
            React.createElement('span', { className: 'fa fa-warning' }),
            'Report A Problem'
          )
        )
      )
    );
  }
});

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(108);
var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({
  displayName: 'exports',


  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],
  render: function render() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'sign-container' },
        React.createElement('div', { className: 'nob', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color)) }),
        React.createElement('div', { className: 'post left', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement('div', { className: 'post right', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement(
          'div',
          { className: 'pane just-header', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color)) },
          React.createElement(
            'div',
            { className: 'headline', style: this.color(this.props.sign_text_color) },
            'Be Right Back'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'text-container' },
        React.createElement(
          'div',
          { className: 'headline', style: this.secondary_text_color() },
          'Maintenance'
        ),
        React.createElement(
          'div',
          { className: 'context', style: this.primary_text_color() },
          this.contextContent()
        ),
        React.createElement(
          'div',
          { className: 'buttons-container' },
          React.createElement(
            'a',
            { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.borderButton(), this.has_status_page()), target: '_blank' },
            React.createElement('span', { className: 'fa fa-power-off' }),
            'View Statuspage'
          )
        )
      )
    );
  }
});

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'Background404',

  mixins: [CustomStylesMixin, RevealMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container', style: this.shadow() },
      React.createElement(
        'div',
        { className: 'head-line secondary-text', style: this.secondary_text_color() },
        '404'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Oops, the page you\'re',
        React.createElement('br', null),
        'looking for does not exist.'
      ),
      React.createElement('div', { className: 'hr' }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.secondary_text_color() },
        'You may want to head back to the homepage. If you think something is broken, report a problem.'
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.homepage_url), style: this.button(), target: '_blank' },
          React.createElement('span', { className: 'fa fa-home' }),
          'Go To Homepage'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.button(), target: '_blank' },
          React.createElement('span', { className: 'fa fa-warning' }),
          'Report A Problem'
        )
      )
    );
  }
});

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ContextContentMixin = __webpack_require__(108);
var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'Background503',

  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  buttonsClass: function buttonsClass() {
    var ret = "buttons-container";
    if (this.props.has_status_page == 'no') {
      ret += " single-button";
    }
    return ret;
  },

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container', style: this.shadow() },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        '503'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Looks like we\'re having',
        React.createElement('br', null),
        'some server issues.'
      ),
      React.createElement('div', { className: 'hr' }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.secondary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: this.buttonsClass() },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.button(), this.has_status_page()), target: '_blank' },
          React.createElement('span', { className: 'fa fa-power-off' }),
          'View Statuspage'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.button(), target: '_blank' },
          React.createElement('span', { className: 'fa fa-warning' }),
          'Report A Problem'
        )
      )
    );
  }

});

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(108);
var CustomStylesMixin = __webpack_require__(48);
var RevealMixin = __webpack_require__(65);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'BackgroundMaintenance',

  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container', style: this.shadow() },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        'Maintenance'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'We\'re undergoing a bit of scheduled maintenance.'
      ),
      React.createElement('div', { className: 'hr' }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.secondary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: 'buttons-container single-button', style: this.has_status_page() },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.button(), this.has_status_page()), target: '_blank' },
          React.createElement('span', { className: 'fa fa-power-off' }),
          'View Statuspage'
        )
      )
    );
  }
});

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "walkthrough-header" },
        React.createElement(
          "a",
          { className: "logo", href: "/" },
          React.createElement("img", { src: this.props.logoUrl, alt: "Statuspage Logo" }),
          React.createElement(
            "span",
            { className: "bep" },
            "Better Error Pages"
          )
        ),
        React.createElement(
          "span",
          { className: "powered-by" },
          "Powered by ",
          React.createElement(
            "a",
            { href: "http://statuspage.io", target: "_blank" },
            "Statuspage"
          )
        )
      );
    }
  }]);

  return Header;
}(React.Component);

module.exports = Header;

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Buttons = function (_React$Component) {
  _inherits(Buttons, _React$Component);

  function Buttons() {
    _classCallCheck(this, Buttons);

    return _possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).apply(this, arguments));
  }

  _createClass(Buttons, [{
    key: "render",
    value: function render() {

      return React.createElement(
        "div",
        { className: "walkthrough-buttons" },
        React.createElement(
          "a",
          { href: "#",
            onClick: this.props.back,
            className: "cpt-button pull-left",
            style: { display: !this.props.backText ? 'none' : null } },
          this.props.backText
        ),
        React.createElement(
          "a",
          { href: "#",
            onClick: this.props.continue,
            className: "cpt-button pull-right style-primary",
            style: { display: !this.props.continueText ? 'none' : null } },
          this.props.continueText
        )
      );
    }
  }]);

  return Buttons;
}(React.Component);

module.exports = Buttons;

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var CustomStylesMixin = __webpack_require__(48);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'PageToggler',

  mixins: [CustomStylesMixin],

  setPageType: function setPageType(event) {
    event.preventDefault();
    this.props.onChange(event.target.dataset.type);
  },

  activeTab: function activeTab(name) {
    return this.props.page_type === name ? 'active' : null;
  },

  togglerColor: function togglerColor(name) {
    return this.props.page_type === name ? this.mergeStyles(this.primary_text_color(), this.primaryBorderColor()) : this.secondary_text_color();
  },

  render: function render() {
    var type = this.props.page_type || '503';
    return React.createElement(
      'div',
      { className: 'page-toggler' },
      React.createElement(
        'a',
        { href: '#', className: this.activeTab('503'), style: this.togglerColor('503'), onClick: this.setPageType, 'data-type': '503' },
        '503'
      ),
      React.createElement(
        'a',
        { href: '#', className: this.activeTab('404'), style: this.togglerColor('404'), onClick: this.setPageType, 'data-type': '404' },
        '404'
      ),
      React.createElement(
        'a',
        { href: '#', className: this.activeTab('maintenance'), style: this.togglerColor('maintenance'), onClick: this.setPageType, 'data-type': 'maintenance' },
        'Maintenance'
      )
    );
  }

});

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ThankYou = function (_React$Component) {
  _inherits(ThankYou, _React$Component);

  function ThankYou(props) {
    _classCallCheck(this, ThankYou);

    return _possibleConstructorReturn(this, (ThankYou.__proto__ || Object.getPrototypeOf(ThankYou)).call(this, props));
  }

  _createClass(ThankYou, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "step-container step-zero" },
        React.createElement(
          "h2",
          null,
          "Welcome To Better Error Pages!"
        ),
        React.createElement(
          "p",
          { className: "works-header" },
          React.createElement(
            "strong",
            null,
            "Here's how this thing works:"
          )
        ),
        React.createElement(
          "ul",
          { className: "styled" },
          React.createElement(
            "li",
            null,
            "We're going to ask you a few questions about your company."
          ),
          React.createElement(
            "li",
            null,
            "You're going to have the opportunity to customize what your error pages look like."
          ),
          React.createElement(
            "li",
            null,
            "When you're done, you'll be able to download the flat HTML files for your shiny new 404, 503 and Maintenance pages."
          )
        ),
        React.createElement(
          "p",
          null,
          "Let's get started!"
        )
      );
    }
  }]);

  return ThankYou;
}(React.Component);

module.exports = ThankYou;

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Radio = __webpack_require__(860);

var Welcome = function (_React$Component) {
  _inherits(Welcome, _React$Component);

  function Welcome() {
    _classCallCheck(this, Welcome);

    return _possibleConstructorReturn(this, (Welcome.__proto__ || Object.getPrototypeOf(Welcome)).apply(this, arguments));
  }

  _createClass(Welcome, [{
    key: 'handleChange',
    value: function handleChange(event) {
      this.props.onChange('has_status_page', event.target.value);
    }
  }, {
    key: 'contextText',
    value: function contextText() {
      if (this.props.has_status_page === 'customer') {
        return 'Great news! As a Statuspage customer, your error pages will include a javascript snippet that pulls in information from your status page via the API.';
      } else if (this.props.has_status_page === 'non-customer') {
        return "Cool! We'll be able to include links to your status page on your error pages.";
      }
      if (this.props.has_status_page === 'no') {
        return React.createElement(
          'span',
          null,
          'Need a status page? ',
          React.createElement(
            'a',
            { href: 'https://www.statuspage.io', target: '_blank' },
            'We can help you with that.'
          ),
          '.'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var values = [{ label: 'Yes I have a status page AND I\'m a Statuspage  customer.', value: 'customer' }, { label: 'Yes I have a status page BUT I\'m not a Statuspage customer.', value: 'non-customer' }, { label: 'No, I don\'t have a status page.', value: 'no' }];
      return React.createElement(
        'div',
        { className: 'step-container step-one' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'h2',
            null,
            'First off, do you have a status page?'
          ),
          React.createElement(
            'p',
            null,
            'We need to know if your company has a status page because if you do, we\'ll include a link to it on your error pages.'
          ),
          React.createElement(
            'div',
            { className: 'controls' },
            values.map(function (value, index) {
              return React.createElement(Radio, {
                key: index,
                label: value.label,
                value: value.value,
                name: 'has-status-page',
                checked: value.value === _this2.props.has_status_page,
                onChange: _this2.handleChange.bind(_this2) });
            })
          ),
          React.createElement(
            'small',
            null,
            this.contextText()
          )
        )
      );
    }
  }]);

  return Welcome;
}(React.Component);

module.exports = Welcome;

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({
  displayName: 'exports',

  render: function render() {
    return React.createElement(
      'label',
      { className: 'radio' },
      React.createElement('input', { type: 'radio',
        name: this.props.name,
        value: this.props.value,
        defaultChecked: this.props.checked,
        onChange: this.props.onChange }),
      ' ',
      this.props.label
    );
  }
});

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Input = __webpack_require__(42);

var URLsForm = function (_React$Component) {
  _inherits(URLsForm, _React$Component);

  function URLsForm() {
    _classCallCheck(this, URLsForm);

    return _possibleConstructorReturn(this, (URLsForm.__proto__ || Object.getPrototypeOf(URLsForm)).apply(this, arguments));
  }

  _createClass(URLsForm, [{
    key: 'change',
    value: function change(key, event) {
      this.props.onChange(key, event.target.value);
    }
  }, {
    key: 'greeting',
    value: function greeting() {
      if (this.props.has_status_page === 'customer') {
        if (this.props.loggedIn) {
          return React.createElement(
            'p',
            null,
            'Since you\'re logged in, we were able to pull the following information from your Statuspage account.  Verify that this is correct and proceed to the next step.'
          );
        }
        return React.createElement(
          'p',
          null,
          'If you ',
          React.createElement(
            'a',
            { href: 'https://manage.statuspage.io/login' },
            'login'
          ),
          ', we can pull this information in automatically.  No worries, though, if you don\'t want to.'
        );
      } else {
        return React.createElement(
          'p',
          null,
          'We\'re making good progress! Now we need some info about your website and support channels.'
        );
      }
    }
  }, {
    key: 'minimumFields',
    value: function minimumFields() {
      return React.createElement(
        'div',
        null,
        React.createElement(Input, {
          label: 'Homepage URL',
          name: 'homepage_url',
          defaultValue: this.props.homepage_url,
          onChange: this.change.bind(this, 'homepage_url') }),
        React.createElement(Input, {
          label: 'Support Email Address or URL',
          name: 'support_email_address',
          defaultValue: this.props.support_email_address,
          onChange: this.change.bind(this, 'support_email_address') })
      );
    }
  }, {
    key: 'requiredInputs',
    value: function requiredInputs() {
      if (this.props.has_status_page === 'customer' || this.props.has_status_page === 'non-customer') {
        return React.createElement(
          'div',
          { className: 'urls-form' },
          React.createElement(Input, {
            label: 'Statuspage URL',
            name: 'status_page_url',
            defaultValue: this.props.status_page_url,
            onChange: this.change.bind(this, 'status_page_url') }),
          this.minimumFields()
        );
      } else if (this.props.has_status_page === 'no') {
        return React.createElement(
          'div',
          { className: 'urls-form' },
          this.minimumFields()
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'step-container step-two' },
          React.createElement(
            'h2',
            null,
            'Awesome!'
          ),
          this.greeting(),
          this.requiredInputs(),
          React.createElement(
            'small',
            null,
            'We\'ll use this information to add helpful links to your error pages.'
          )
        )
      );
    }
  }]);

  return URLsForm;
}(React.Component);

module.exports = URLsForm;

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseATemplate = function (_React$Component) {
  _inherits(ChooseATemplate, _React$Component);

  function ChooseATemplate() {
    _classCallCheck(this, ChooseATemplate);

    return _possibleConstructorReturn(this, (ChooseATemplate.__proto__ || Object.getPrototypeOf(ChooseATemplate)).apply(this, arguments));
  }

  _createClass(ChooseATemplate, [{
    key: 'change',
    value: function change(template) {
      this.props.onChange('template', template);
    }
  }, {
    key: 'render',
    value: function render() {
      var template = this.props.template;
      var _props$thumbnails = this.props.thumbnails,
          plain = _props$thumbnails.plain,
          background = _props$thumbnails.background,
          sign = _props$thumbnails.sign;


      return _react2.default.createElement(
        'div',
        { className: 'step-container step-three' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Choose A Template'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Use one of these templates as a jumping off point. You\'ll be able to customize your error pages further on the next page.'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              { onClick: this.change.bind(this, 'plain'), className: template === 'plain' ? 'selected' : null },
              _react2.default.createElement('img', { src: plain, alt: 'Plain Template' })
            ),
            _react2.default.createElement(
              'li',
              { onClick: this.change.bind(this, 'background'), className: template === 'background' ? 'selected' : null },
              _react2.default.createElement('img', { src: background, alt: 'Background Template' })
            ),
            _react2.default.createElement(
              'li',
              { onClick: this.change.bind(this, 'sign'), className: template === 'sign' ? 'selected' : null },
              _react2.default.createElement('img', { src: sign, alt: 'Sign Template' })
            )
          )
        )
      );
    }
  }]);

  return ChooseATemplate;
}(_react2.default.Component);

ChooseATemplate.propTypes = {
  template: _propTypes2.default.string
};

module.exports = ChooseATemplate;

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var BackgroundControls = __webpack_require__(864);
var PlainControls = __webpack_require__(866);
var SignControls = __webpack_require__(867);

var Personalize = function (_React$Component) {
  _inherits(Personalize, _React$Component);

  function Personalize(props) {
    _classCallCheck(this, Personalize);

    var _this = _possibleConstructorReturn(this, (Personalize.__proto__ || Object.getPrototypeOf(Personalize)).call(this, props));

    _this.props = props;

    _this.onChange = _this.onChange.bind(_this);
    _this.resetDefaultValues = _this.resetDefaultValues.bind(_this);
    return _this;
  }

  _createClass(Personalize, [{
    key: 'onChange',
    value: function onChange(name, event) {
      this.props.onChange(name, event.target.value);
      event.preventDefault();
    }
  }, {
    key: 'controls',
    value: function controls() {
      switch (this.props.template) {
        case 'background':
          return React.createElement(BackgroundControls, _extends({}, this.props, { onChange: this.onChange }));
        case 'plain':
          return React.createElement(PlainControls, _extends({}, this.props, { onChange: this.onChange }));
        case 'sign':
          return React.createElement(SignControls, _extends({}, this.props, { onChange: this.onChange }));
        default:
          throw new Error('Invalid template name');
      }
    }
  }, {
    key: 'resetDefaultValues',
    value: function resetDefaultValues() {
      var _this2 = this;

      $('.color-control input').each(function (index, $control) {
        $($control).minicolors('value', _this2.props.defaults[_this2.props.template][$control.name]); // #shame.js @TMD
      });
      this.props.resetDefaultValues();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'step-container step-four' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'h2',
            null,
            'Make Them Your Own'
          ),
          this.controls(),
          React.createElement(
            'small',
            null,
            'If you get a little too adventurous with your customizations, you can always ',
            React.createElement(
              'a',
              { href: '#reset-default', onClick: this.resetDefaultValues },
              'go back to using the default colors'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return Personalize;
}(React.Component);

module.exports = Personalize;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Input = __webpack_require__(42);
var Range = __webpack_require__(865);
var Color = __webpack_require__(231);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'BackgroundControls',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'customization-controls' },
      React.createElement(Input, {
        label: 'Background Image',
        name: 'background_image',
        type: 'text',
        defaultValue: this.props.background_image,
        onChange: this.props.onChange.bind(null, 'background_image') }),
      React.createElement(Color, {
        label: 'Primary Text Color',
        name: 'primary_text_color',
        defaultValue: this.props.primary_text_color,
        onChange: this.props.onChange.bind(null, 'primary_text_color') }),
      React.createElement(Color, {
        label: 'Secondary Text Color',
        name: 'secondary_text_color',
        defaultValue: this.props.secondary_text_color,
        onChange: this.props.onChange.bind(null, 'secondary_text_color') }),
      React.createElement(Color, {
        label: 'Button Color',
        name: 'button_color',
        defaultValue: this.props.button_color,
        onChange: this.props.onChange.bind(null, 'button_color') }),
      React.createElement(Color, {
        label: 'Button Text Color',
        name: 'button_text_color',
        defaultValue: this.props.button_text_color,
        onChange: this.props.onChange.bind(null, 'button_text_color') }),
      React.createElement(Color, {
        label: 'Shadow Color',
        name: 'shadow_color',
        defaultValue: this.props.shadow_color,
        onChange: this.props.onChange.bind(null, 'shadow_color') }),
      React.createElement(Range, {
        label: 'Shadow Distance',
        min: '1',
        max: '75',
        defaultValue: this.props.shadow_distance,
        onChange: this.props.onChange.bind(null, 'shadow_distance') })
    );
  }

});

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var React = __webpack_require__(0);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({
  displayName: 'exports',


  componentDidMount: function componentDidMount() {
    var self = this;
    $(this.refs.slider).noUiSlider({
      start: parseInt(this.props.defaultValue),
      range: {
        min: parseInt(this.props.min),
        max: parseInt(this.props.max)
      }
    }).on('slide', function (event) {
      event.target = { value: parseInt($(this).val()) };
      self.props.onChange(event);
    });
  },

  componentWillUnmount: function componentWillUnmount() {},

  render: function render() {
    var classes = ['control-group'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return React.createElement(
      'div',
      { className: classes.join(' '), style: this.props.style },
      React.createElement(
        'label',
        null,
        this.props.label
      ),
      React.createElement(
        'div',
        { className: 'controls' },
        React.createElement('div', { ref: 'slider', className: 'slider' })
      )
    );
  }

});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Input = __webpack_require__(42);
var Color = __webpack_require__(231);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'PlainControls',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'customization-controls' },
      React.createElement(Color, {
        label: 'Background Color',
        name: 'background_color',
        defaultValue: this.props.background_color,
        onChange: this.props.onChange.bind(null, 'background_color') }),
      React.createElement(Color, {
        label: 'Primary Text Color',
        name: 'primary_text_color',
        defaultValue: this.props.primary_text_color,
        onChange: this.props.onChange.bind(null, 'primary_text_color') }),
      React.createElement(Color, {
        label: 'Secondary Text Color',
        name: 'secondary_text_color',
        defaultValue: this.props.secondary_text_color,
        onChange: this.props.onChange.bind(null, 'secondary_text_color') }),
      React.createElement(Color, {
        label: 'Button Color',
        name: 'button_color',
        defaultValue: this.props.button_color,
        onChange: this.props.onChange.bind(null, 'button_color') })
    );
  }

});

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Input = __webpack_require__(42);
var Color = __webpack_require__(231);

var createReactClass = __webpack_require__(27);
module.exports = createReactClass({

  displayName: 'SignControls',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'customization-controls' },
      React.createElement(Color, {
        label: 'Background Color',
        name: 'background_color',
        defaultValue: this.props.background_color,
        onChange: this.props.onChange.bind(null, 'background_color') }),
      React.createElement(Color, {
        label: 'Primary Text Color',
        name: 'primary_text_color',
        defaultValue: this.props.primary_text_color,
        onChange: this.props.onChange.bind(null, 'primary_text_color') }),
      React.createElement(Color, {
        label: 'Secondary Text Color',
        name: 'secondary_text_color',
        defaultValue: this.props.secondary_text_color,
        onChange: this.props.onChange.bind(null, 'secondary_text_color') }),
      React.createElement(Color, {
        label: 'Sign Frame Color',
        name: 'sign_frame_color',
        defaultValue: this.props.sign_frame_color,
        onChange: this.props.onChange.bind(null, 'sign_frame_color') }),
      React.createElement(Color, {
        label: 'Sign Text Color',
        name: 'sign_text_color',
        defaultValue: this.props.sign_text_color,
        onChange: this.props.onChange.bind(null, 'sign_text_color') }),
      React.createElement(Color, {
        label: 'Sign Background Color',
        name: 'sign_background_color',
        defaultValue: this.props.sign_background_color,
        onChange: this.props.onChange.bind(null, 'sign_background_color') }),
      React.createElement(Color, {
        label: 'Button Color',
        name: 'button_color',
        type: 'text',
        defaultValue: this.props.button_color,
        onChange: this.props.onChange.bind(null, 'button_color') })
    );
  }

});

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkbox = __webpack_require__(109);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Input = __webpack_require__(42);

var Download = function (_React$Component) {
  _inherits(Download, _React$Component);

  function Download() {
    _classCallCheck(this, Download);

    return _possibleConstructorReturn(this, (Download.__proto__ || Object.getPrototypeOf(Download)).apply(this, arguments));
  }

  _createClass(Download, [{
    key: 'onChange',
    value: function onChange(name, event) {
      this.props.onChange(name, name === 'subscribe_to_news_letter' ? event.target.checked : event.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'step-container step-five' },
        React.createElement(
          'h2',
          null,
          'Almost Done!'
        ),
        React.createElement(
          'p',
          null,
          'All we need now is your email address so we can email you the HTML files for your error pages.'
        ),
        React.createElement(Input, { label: 'Email Address',
          name: 'emailAddress',
          defaultValue: this.props.send_to_email_address,
          onChange: this.onChange.bind(this, 'send_to_email_address') }),
        React.createElement(
          'div',
          { className: 'checkbox-container' },
          React.createElement(_checkbox2.default, { label: 'Yes! Send me news and offers from Statuspage about products, events, and more.', onChange: this.onChange.bind(this, 'subscribe_to_news_letter'), defaultChecked: this.props.subscribe_to_news_letter })
        ),
        React.createElement(
          'p',
          { style: { marginTop: '1.5rem' } },
          React.createElement(
            'small',
            null,
            'By continuing, you agree to our ',
            React.createElement(
              'a',
              { href: 'https://dr-wac.atlassian.com/legal/privacy-policy', target: '_blank' },
              'Privacy Policy'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return Download;
}(React.Component);

module.exports = Download;

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ThankYou = function (_React$Component) {
  _inherits(ThankYou, _React$Component);

  function ThankYou(props) {
    _classCallCheck(this, ThankYou);

    return _possibleConstructorReturn(this, (ThankYou.__proto__ || Object.getPrototypeOf(ThankYou)).call(this, props));
  }

  _createClass(ThankYou, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var twttr = window.twttr || { widgets: { load: function load() {} } };
      twttr.widgets.load();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "step-container step-six" },
        React.createElement(
          "h2",
          null,
          "Thanks!"
        ),
        React.createElement(
          "p",
          null,
          "Check your inbox for a link to your Better Error Pages download!"
        ),
        React.createElement(
          "p",
          null,
          "Think Better Error Pages is a nifty little tool? Share it on Twitter."
        ),
        React.createElement(
          "a",
          { href: "https://twitter.com/share", className: "twitter-share-button", "data-url": "https://better-error-pages.statuspage.io/", "data-text": "Better Error Pages: build free 404, 500-level, and maintenance pages in 60 seconds.", "data-via": "statuspageio", "data-size": "large" },
          "Tweet"
        )
      );
    }
  }]);

  return ThankYou;
}(React.Component);

module.exports = ThankYou;

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = __webpack_require__(21);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);
var ItemsSelector = __webpack_require__(110);

var _require = __webpack_require__(171),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var UNSUBSCRIBE_MODAL = 'unsubscribe-user';
var UNSUBSCRIBE_MODAL_TRIGGER = MODAL_PREFIX + UNSUBSCRIBE_MODAL;

var ComponentToggler = function (_React$Component) {
  _inherits(ComponentToggler, _React$Component);

  function ComponentToggler() {
    _classCallCheck(this, ComponentToggler);

    return _possibleConstructorReturn(this, (ComponentToggler.__proto__ || Object.getPrototypeOf(ComponentToggler)).apply(this, arguments));
  }

  _createClass(ComponentToggler, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $(ReactDOM.findDOMNode(this)).parents('form').submit(function (e) {
        if (_this2._allUntoggled()) {
          _this2._triggerModal(UNSUBSCRIBE_MODAL_TRIGGER, e);
        }
      });
    }
  }, {
    key: '_allUntoggled',
    value: function _allUntoggled() {
      return _.every($('.grouped-item'), function (item) {
        return !$(item).hasClass('active');
      });
    }
  }, {
    key: '_triggerModal',
    value: function _triggerModal(modalId, e) {
      e.preventDefault();
      e.stopPropagation();
      $(ReactDOM.findDOMNode(this)).find('#' + modalId).modal();
    }
  }, {
    key: '_submit',
    value: function _submit() {
      var $form = $(ReactDOM.findDOMNode(this)).parents('form');
      $form.unbind();
      $form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(ItemsSelector, this.props),
        React.createElement(_confirm2.default, { id: UNSUBSCRIBE_MODAL,
          title: 'Hey! Just so you know...',
          message: 'This will unsubscribe this user from all updates. Are you sure you want to do that?',
          onConfirm: this._submit.bind(this),
          confirm_text: 'Unsubscribe User'
        })
      );
    }
  }]);

  return ComponentToggler;
}(React.Component);

module.exports = ComponentToggler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ComponentRow = __webpack_require__(342);
var GroupComponentRow = __webpack_require__(876);

var ComponentStatuses = function (_React$Component) {
  _inherits(ComponentStatuses, _React$Component);

  function ComponentStatuses() {
    _classCallCheck(this, ComponentStatuses);

    return _possibleConstructorReturn(this, (ComponentStatuses.__proto__ || Object.getPrototypeOf(ComponentStatuses)).apply(this, arguments));
  }

  _createClass(ComponentStatuses, [{
    key: '_componentsPresent',

    /*
     * ComponentStatuses Table, rendered on Dashboard and Incident Page
     *
     * @param {object} props
     * @param {object} props.page_param - Param of the owning page
     * @param {object} props.components - All components belonging to the page
     * @param {object} props.should_auto_update - Should we AJAX the component status updates? Or listen for form submit?
     * @param {object} props.component_statuses: List of all available statues and colors, provided in format:
     * {
     *   status_name: {label: 'status_name', name: 'Readable Status Name', color: '#hexcode'},
     *   ...
     * }
     */

    value: function _componentsPresent() {
      return this.props.components.length > 0;
    }
  }, {
    key: '_buildComponentRows',
    value: function _buildComponentRows() {
      var _this2 = this;

      var rows = [];

      this.props.components.map(function (component) {
        if (component.is_group_parent) {
          rows.push(React.createElement(GroupComponentRow, { key: component.id,
            pageParam: _this2.props.page_param,
            componentGroup: component,
            componentStatuses: _this2.props.component_statuses,
            shouldAutoUpdate: _this2.props.should_auto_update }));
        } else {
          rows.push(React.createElement(ComponentRow, { key: component.id,
            pageParam: _this2.props.page_param,
            component: component,
            componentStatuses: _this2.props.component_statuses,
            shouldAutoUpdate: _this2.props.should_auto_update }));
        }
      });

      return React.createElement(
        'div',
        null,
        ' ',
        rows,
        ' '
      );
    }
  }, {
    key: '_noComponentState',
    value: function _noComponentState() {
      return React.createElement(
        'div',
        { className: 'table-row blank-state' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'strong',
            null,
            'Sometimes downtime only affects one small part of your tech stack'
          )
        ),
        React.createElement(
          'small',
          null,
          'List those parts out here:',
          React.createElement(
            'a',
            { href: Routes.page_components_path(this.props.page_param) },
            '\xA0Create a Component'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'table-row-group component-statuses' },
        this._componentsPresent() ? this._buildComponentRows() : this._noComponentState()
      );
    }
  }]);

  return ComponentStatuses;
}(React.Component);

module.exports = ComponentStatuses;

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _types = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusDropdown = __webpack_require__(873);
var StatusOverride = __webpack_require__(875);

var ComponentStatusSelector = function (_React$Component) {
  _inherits(ComponentStatusSelector, _React$Component);

  function ComponentStatusSelector(props) {
    _classCallCheck(this, ComponentStatusSelector);

    var _this = _possibleConstructorReturn(this, (ComponentStatusSelector.__proto__ || Object.getPrototypeOf(ComponentStatusSelector)).call(this, props));

    _this.canOverride = _this.props.isGroupParent || _this.props.component.is_third_party;
    _this.state = {
      dropdownEnabled: _this._initialDropdownState(),
      currentStatus: _this.props.component.status
    };
    return _this;
  }

  _createClass(ComponentStatusSelector, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({ currentStatus: newProps.currentStatus });
    }
  }, {
    key: '_initialDropdownState',
    value: function _initialDropdownState() {
      // All non-group components and overridden components are active.
      return !this.canOverride || this.props.component.is_overridden;
    }
  }, {
    key: '_toggleActiveDropdown',
    value: function _toggleActiveDropdown() {
      // Toggle overridden if we're working with a group
      if (this.props.isGroupParent) {
        this.props.toggleOverridden();
        this.props.informParent();
      }

      // Tell the parent if we're working with a child
      if (this.props.isChild) {
        this.props.informParent(this.props.component.id, this.props.component.name);
      }

      if (this.state.dropdownEnabled) {
        // 3PCs use their provided based_on_status
        if (this.props.component.is_third_party) {
          var newStatus = this.props.component.based_on_status;
          this.setState({ currentStatus: newStatus });
        }

        // And let the server know we're using derived/based on status
        if (this.props.shouldAutoUpdate) {
          this._updateComponent(null);
        }
      }

      this.setState({ dropdownEnabled: !this.state.dropdownEnabled });
    }
  }, {
    key: '_updateComponent',
    value: function _updateComponent(newStatus) {
      var newName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'its derived status';

      var successMessage = 'Successfully updated ' + this.props.component.name + ' to ' + newName + '.';

      $.ajax({
        type: 'PUT',
        url: Routes.page_component_path(this.props.pageParam, this.props.component.id, { format: 'json' }),
        data: { component: { status: newStatus } },
        success: function success(data, textStatus, xhr) {
          HRB.utils.notify(successMessage);
        },
        error: function error(xhr, textStatus) {
          HRB.utils.basicFailAndReload(xhr);
        }
      });
    }
  }, {
    key: '_displayDropdown',
    value: function _displayDropdown() {
      return _react2.default.createElement(StatusDropdown, {
        isEnabled: this.state.dropdownEnabled,
        component: this.props.component,
        currentStatus: this.state.currentStatus,
        componentStatuses: this.props.componentStatuses,
        shouldAutoUpdate: this.props.shouldAutoUpdate,
        updateComponent: this._updateComponent.bind(this),
        informParent: this.props.informParent,
        isChild: this.props.isChild,
        isGroup: this.props.isGroupParent });
    }
  }, {
    key: '_displayOverride',
    value: function _displayOverride() {
      if (this.canOverride) {
        return _react2.default.createElement(StatusOverride, {
          isActive: this.state.dropdownEnabled,
          componentParam: this.props.component.id,
          onClick: this._toggleActiveDropdown.bind(this) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'component-status-container' },
        this._displayOverride(),
        this._displayDropdown()
      );
    }
  }]);

  return ComponentStatusSelector;
}(_react2.default.Component);

ComponentStatusSelector.propTypes = {
  component: _types.Component.isRequired,
  componentStatuses: _types.ComponentStatuses.isRequired,
  informParent: _propTypes2.default.func,
  isChild: _propTypes2.default.bool,
  isGroupParent: _propTypes2.default.bool,
  pageParam: _propTypes2.default.string.isRequired,
  shouldAutoUpdate: _propTypes2.default.bool.isRequired,
  toggleOverridden: _propTypes2.default.func
};
ComponentStatusSelector.defaultProps = {
  informParent: new Function(),
  isChild: false,
  isGroupParent: false,
  toggleOverridden: new Function()
};


module.exports = ComponentStatusSelector;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _types = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = __webpack_require__(4);

var StatusInput = __webpack_require__(874);

var StatusDropdown = function (_React$Component) {
  _inherits(StatusDropdown, _React$Component);

  function StatusDropdown(props) {
    _classCallCheck(this, StatusDropdown);

    var _this = _possibleConstructorReturn(this, (StatusDropdown.__proto__ || Object.getPrototypeOf(StatusDropdown)).call(this, props));

    _this._toggleDropdown = function () {
      if (_this.props.isEnabled) {
        _this.setState({ showDropdown: !_this.state.showDropdown });
      }
    };

    _this._setNewStatus = function (e) {
      var newName = e.target.textContent;
      var newStatus = Object.values(_this.props.componentStatuses).find(function (entry) {
        return entry.name === newName;
      });

      _this.setState({ currentStatus: newStatus });
      _this._toggleDropdown();

      // Inform the parent of a change if this is a child component
      if (_this.props.isChild) {
        _this.props.informParent(_this.props.component.id, newStatus.label);
      }

      // Send the change to the server if we're on the dashboard
      if (_this.props.shouldAutoUpdate) {
        _this.props.updateComponent(newStatus.label, newName);
      }
    };

    _this.state = {
      showDropdown: false,
      currentStatus: _this.props.componentStatuses[_this.props.currentStatus]
    };
    return _this;
  }

  _createClass(StatusDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      HRB.utils.djshook('tooltip').tooltip();
      window.addEventListener('click', this._handlePageClick.bind(this, this.props.component.id));
      window.addEventListener('keydown', this._handleKeyPress.bind(this));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // Allow Group updates to trickle down, for derived statuses
      if (this.props.isGroup) {
        this.setState({ currentStatus: this.props.componentStatuses[newProps.currentStatus] });
      }

      // If a 3PC is disabled, the based_on_status is used
      if (this.props.component.is_third_party && !newProps.isEnabled) {
        this.setState({ currentStatus: this.props.componentStatuses[newProps.component.based_on_status] });
      }
    }
  }, {
    key: '_handlePageClick',
    value: function _handlePageClick(id, e) {
      // Close the dropdown unless we're clicking on ourselves
      if (!$(e.target).hasClass(id)) {
        this.setState({ showDropdown: false });
      }
    }
  }, {
    key: '_handleKeyPress',
    value: function _handleKeyPress(e) {
      // Close the dropdownn on ESC
      if (e.keyCode === 27) {
        this.setState({ showDropdown: false });
      }
    }
  }, {
    key: '_tooltipMessage',
    value: function _tooltipMessage() {
      var message = '';

      if (this.props.isGroup) {
        message = 'Based on the status of its children, ' + this.props.component.name + ' is reporting a status of ' + this.state.currentStatus.name + '.';
      } else if (this.props.component.is_third_party) {
        message = this.props.component.based_on_name + ' is reporting a status of ' + this.state.currentStatus.name + '.';
      }

      return message;
    }
  }, {
    key: '_currentStatusDisplay',
    value: function _currentStatusDisplay() {
      return _react2.default.createElement(
        'div',
        {
          className: 'component-status-display ' + this.props.component.id,
          'data-js-hook': 'tooltip',
          'data-original-title': this.props.isEnabled ? null : this._tooltipMessage(),
          onClick: this._toggleDropdown },
        _react2.default.createElement('i', { className: 'fa fa-circle ' + this.props.component.id, style: { color: this.state.currentStatus.color } }),
        _react2.default.createElement(
          'span',
          { className: 'current-status ' + this.props.component.id },
          this.state.currentStatus.name
        ),
        _react2.default.createElement('span', { className: 'pull-right arrow fa fa-chevron-down ' + this.props.component.id })
      );
    }
  }, {
    key: '_dropdownDisplay',
    value: function _dropdownDisplay() {
      var _this2 = this;

      if (!this.state.showDropdown || !this.props.isEnabled) {
        return;
      }

      var dropdown = [];
      var active = this.state.currentStatus.name;

      Object.keys(this.props.componentStatuses).forEach(function (key) {
        var status = _this2.props.componentStatuses[key];

        if (active !== status.name) {
          dropdown.push(_react2.default.createElement(
            'div',
            { className: 'status-option', onClick: _this2._setNewStatus, key: status.name },
            _react2.default.createElement('i', { className: 'fa fa-circle', style: { color: status.color } }),
            _react2.default.createElement(
              'span',
              { className: 'status-option-name' },
              status.name
            )
          ));
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'status-dropdown' },
        dropdown
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var classNames = 'component-dropdown-selector';

      if (!this.props.isEnabled) {
        classNames = cx(classNames, 'dropdown-inactive');
      }
      if (this.state.showDropdown) {
        classNames = cx(classNames, 'dropdown-open');
      }

      return _react2.default.createElement(
        'div',
        { className: classNames, 'data-js-hook': 'component-status-selector' },
        this._currentStatusDisplay(),
        this._dropdownDisplay(),
        _react2.default.createElement(StatusInput, {
          componentParam: this.props.component.id,
          updateStatus: this.state.currentStatus.label,
          shouldReset: !this.props.isEnabled,
          groupOr3pc: this.props.isGroup || this.props.component.is_third_party })
      );
    }
  }]);

  return StatusDropdown;
}(_react2.default.Component);

StatusDropdown.propTypes = {
  component: _types.Component.isRequired,
  componentStatuses: _types.ComponentStatuses.isRequired,
  currentStatus: _propTypes2.default.string,
  informParent: _propTypes2.default.func,
  isChild: _propTypes2.default.bool,
  isEnabled: _propTypes2.default.bool,
  isGroup: _propTypes2.default.bool,
  shouldAutoUpdate: _propTypes2.default.bool.isRequired,
  updateComponent: _propTypes2.default.func.isRequired
};
StatusDropdown.defaultProps = {
  informParent: new Function(),
  isChild: false,
  isEnabled: false,
  isGroup: false,
  currentStatus: 'operational'
};


module.exports = StatusDropdown;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusInput = function (_React$Component) {
  _inherits(StatusInput, _React$Component);

  function StatusInput() {
    _classCallCheck(this, StatusInput);

    return _possibleConstructorReturn(this, (StatusInput.__proto__ || Object.getPrototypeOf(StatusInput)).apply(this, arguments));
  }

  _createClass(StatusInput, [{
    key: '_getStatusValue',
    value: function _getStatusValue() {
      // If its a group or 3PC, and we're disabling the component, send null and use derived
      if (this.props.groupOr3pc && this.props.shouldReset) {
        return '';
      }
      return this.props.updateStatus;
    }
  }, {
    key: 'render',
    value: function render() {
      var name = 'components[' + this.props.componentParam + ']';
      return _react2.default.createElement('input', { type: 'hidden', value: this._getStatusValue(), name: name });
    }
  }]);

  return StatusInput;
}(_react2.default.Component);

StatusInput.propTypes = {
  componentParam: _propTypes2.default.string.isRequired,
  groupOr3pc: _propTypes2.default.bool.isRequired,
  shouldReset: _propTypes2.default.bool.isRequired,
  updateStatus: _propTypes2.default.string.isRequired
};


module.exports = StatusInput;

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = __webpack_require__(4);

var StatusOverride = function (_React$Component) {
  _inherits(StatusOverride, _React$Component);

  function StatusOverride() {
    _classCallCheck(this, StatusOverride);

    return _possibleConstructorReturn(this, (StatusOverride.__proto__ || Object.getPrototypeOf(StatusOverride)).apply(this, arguments));
  }

  _createClass(StatusOverride, [{
    key: 'render',
    value: function render() {
      var classNames = 'component-status-override';

      if (this.props.isActive) {
        classNames = cx(classNames, 'derived');
      } else {
        classNames = cx(classNames, 'override');
      }

      return _react2.default.createElement('div', {
        className: classNames,
        onClick: this.props.onClick,
        id: 'override-' + this.props.componentParam });
    }
  }]);

  return StatusOverride;
}(_react2.default.Component);

StatusOverride.propTypes = {
  componentParam: _propTypes2.default.string.isRequired,
  isActive: _propTypes2.default.bool,
  onClick: _propTypes2.default.func.isRequired
};
StatusOverride.defaultProps = {
  isActive: false
};


module.exports = StatusOverride;

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ComponentRow = __webpack_require__(342);

var GroupComponentRow = function (_React$Component) {
  _inherits(GroupComponentRow, _React$Component);

  function GroupComponentRow(props) {
    _classCallCheck(this, GroupComponentRow);

    var _this = _possibleConstructorReturn(this, (GroupComponentRow.__proto__ || Object.getPrototypeOf(GroupComponentRow)).call(this, props));

    _this.state = {
      showChildren: true,
      isOverridden: _this.props.componentGroup.is_overridden,
      parentComponentStatus: _this.props.componentGroup.status,
      childStatuses: _this._buildInitialChildStatuses()
    };
    return _this;
  }

  _createClass(GroupComponentRow, [{
    key: '_buildInitialChildStatuses',
    value: function _buildInitialChildStatuses() {
      // Since we're not always updating async, a group row has to keep up with the current
      // status of all of its children, regardless of whether or not we've hit the sever.
      return this.props.componentGroup.components.map(function (component) {
        return {
          id: component.id,
          status: component.status
        };
      });
    }
  }, {
    key: '_updateChildStatus',
    value: function _updateChildStatus(componentId, newStatus) {
      // The group needs to know of a status change in the view, so we
      // can update the derived group status accordingly.
      var updateStatuses = this.state.childStatuses;

      // Insert the new status in place of the old
      var index = _.indexOf(updateStatuses, _.find(updateStatuses, { id: componentId }));
      updateStatuses.splice(index, 1, { id: componentId, status: newStatus });

      // Have the group determine its own derived status unless it is overridden
      if (!this.state.isOverridden) {
        this._determineGroupDerivedStatus();
      }
    }
  }, {
    key: '_determineGroupDerivedStatus',
    value: function _determineGroupDerivedStatus() {
      // Update the parent's group accordingly based on the status of its children
      var comparatorStatuses = this.state.childStatuses.map(function (component) {
        return component.status;
      });
      var updateStatus;

      if (_.contains(comparatorStatuses, 'operational')) {
        updateStatus = 'operational';
      }
      if (_.contains(comparatorStatuses, 'under_maintenance')) {
        updateStatus = 'under_maintenance';
      }
      if (_.contains(comparatorStatuses, 'degraded_performance')) {
        updateStatus = 'degraded_performance';
      }
      if (_.contains(comparatorStatuses, 'partial_outage')) {
        updateStatus = 'partial_outage';
      }
      if (_.contains(comparatorStatuses, 'major_outage')) {
        updateStatus = 'major_outage';
      }

      this.setState({ parentComponentStatus: updateStatus });
    }
  }, {
    key: '_toggleChildren',
    value: function _toggleChildren() {
      this.setState({ showChildren: !this.state.showChildren });
    }
  }, {
    key: '_toggleOverridden',
    value: function _toggleOverridden() {
      this.setState({ isOverridden: !this.state.isOverridden });
    }
  }, {
    key: '_displayChildren',
    value: function _displayChildren() {
      var _this2 = this;

      if (this.state.showChildren) {
        return React.createElement(
          'div',
          { className: 'child-components-container' },
          this.props.componentGroup.components.map(function (component) {
            return React.createElement(ComponentRow, { key: component.id,
              pageParam: _this2.props.pageParam,
              currentStatus: component.status,
              component: component,
              componentStatuses: _this2.props.componentStatuses,
              isChild: true,
              informParent: _this2._updateChildStatus.bind(_this2),
              shouldAutoUpdate: _this2.props.shouldAutoUpdate });
          })
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'component-group-outer-container' },
        React.createElement(ComponentRow, { key: this.props.componentGroup.id,
          onClick: this._toggleChildren.bind(this),
          visible: this.state.showChildren,
          pageParam: this.props.pageParam,
          currentStatus: this.state.parentComponentStatus,
          component: this.props.componentGroup,
          componentStatuses: this.props.componentStatuses,
          toggleOverridden: this._toggleOverridden.bind(this),
          shouldAutoUpdate: this.props.shouldAutoUpdate,
          informParent: this._determineGroupDerivedStatus.bind(this),
          isGroupParent: true }),
        this._displayChildren()
      );
    }
  }]);

  return GroupComponentRow;
}(React.Component);

module.exports = GroupComponentRow;

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var DnsRecordSet = __webpack_require__(878);

/*
 * This component displays the current state of host dns records for a given domain.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {string} props.subdomain - the subdomain of the page, if any.
 * @param {bool}   props.subdomain_forced - true iff one cannot modify or use the vanity subdomain.
 * @param {bool}   props.active - false iff we should display a notice that the domain is not active until the person activates.
 * @param {string} props.page_code - the code of the page; used to generate the page-specific json url.
 * @param {string} props.expected_endpoint - the ideal endpoint the user should CNAME to.
 * @param {int}    props.expected_ttl - the suggested TTL for a new DNS record.
 * @param {string} props.status - unset, deprecated, invalid, or valid.
 * @param {bool}   props.detailed_view - true to force the detailed view of the domain status.
 * @param {array}  props.actual_records - A list of dns records with the fields 'type', 'ttl', 'value', and 'hints'.
 */

var HostHelper = function (_React$Component) {
  _inherits(HostHelper, _React$Component);

  function HostHelper(props) {
    _classCallCheck(this, HostHelper);

    var _this = _possibleConstructorReturn(this, (HostHelper.__proto__ || Object.getPrototypeOf(HostHelper)).call(this, props));

    _this.state = {
      'page_code': _this.props.page_code,
      'domain': _this.props.domain,
      'expected_endpoint': _this.props.expected_endpoint,
      'expected_ttl': _this.props.expected_ttl,
      'actual_records': _this.props.actual_records,
      'status': _this.props.status,
      'folded': _this.props.status === 'unset' || _this.props.status == 'valid',
      'detailed_view': _this.props.detailed_view,
      'subdomain': _this.props.subdomain,
      'subdomain_forced': _this.props.subdomain_forced,
      'active': _this.props.active
    };
    return _this;
  }

  // On hitting the revalidate button or link, pull the new state as a json and set local state to that.


  _createClass(HostHelper, [{
    key: '_submit',
    value: function _submit() {
      var _this2 = this;

      $.ajax({
        type: "GET",
        url: Routes.domain_state_page_url(this.state.page_code)
      }).success(function (msg) {
        // If we do not notify and nothing changes, it looks like nothing happened.
        HRB.utils.notify('Current DNS state refreshed successfully.');
        _this2.setState(msg);
      }).fail(function () {
        HRB.utils.basicFailAndReload();
      });
    }

    // Switch between folded and unfolded

  }, {
    key: '_toggleFolding',
    value: function _toggleFolding() {
      this.setState({ folded: !this.state.folded });
    }
  }, {
    key: '_foldedClass',
    value: function _foldedClass() {
      return this.state.folded ? 'folded' : 'unfolded';
    }
  }, {
    key: '_statusClass',
    value: function _statusClass() {
      return 'domain-' + this.state.status;
    }

    // This is the view that most clients see.
    // It does not display anything about the inbound DNS but the expected DNS row
    // and whether or not the actual endpoint matches it exactly.

  }, {
    key: '_renderLegacyView',
    value: function _renderLegacyView() {
      var contents = void 0;
      var configUrl = Routes.edit_page_url(this.props.page_code, { 'anchor': 'tab-dns-config' });
      if (this.state.status === 'unset') {
        contents = React.createElement(
          'span',
          null,
          React.createElement(
            'strong',
            null,
            'Directions'
          ),
          ': create a CNAME DNS record and point it at ',
          React.createElement(
            'em',
            null,
            this.state.expected_endpoint
          ),
          '.'
        );
      } else if (this.state.status === 'valid') {
        contents = React.createElement(
          'span',
          { className: 'checkmark-inline' },
          ' DNS is correctly configured! ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          ' points at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.expected_endpoint
          )
        );
      } else {
        contents = React.createElement(
          'span',
          { className: 'alert-inline' },
          '\xA0Please ensure your DNS entry for ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          ' is a ',
          React.createElement(
            'span',
            { className: 'monospace' },
            'CNAME'
          ),
          ' entry pointing at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.expected_endpoint
          ),
          '.'
        );
      }

      var activeMessage = this.state.active ? null : React.createElement(
        'span',
        null,
        React.createElement('br', null),
        React.createElement(
          'strong',
          null,
          'Note:'
        ),
        ' your status page will redirect to your unique subdomain ',
        React.createElement(
          'em',
          null,
          '(',
          this.state.subdomain,
          ')'
        ),
        ' until your page launches.'
      );

      var revalidate_link = this.state.status === 'unset' ? null : React.createElement(
        'a',
        { id: 'dns-revalidation-button', href: '#', onClick: this._submit.bind(this) },
        'Revalidate DNS'
      );

      return React.createElement(
        'p',
        { className: 'help-block' },
        contents,
        '\xA0',
        revalidate_link,
        activeMessage
      );
    }

    // Returns a DnsRecordSet representing the expected set of records at the custom domain.

  }, {
    key: '_expectedCname',
    value: function _expectedCname() {
      return React.createElement(DnsRecordSet, { domain: this.state.domain ? this.state.domain : 'Expected Domain', show_header: true, show_ttl: true, records: [{
          type: 'CNAME',
          ttl: this.state.expected_ttl,
          value: this.state.expected_endpoint,
          hints: []
        }] });
    }

    // This is the detailed view.
    // The header contains the status and a 'folder' button to show more detail.
    // The detail contains all the records found at the custom domain, hints to resolve an invalid record,
    //   explanations of deprecation, the expected CNAME record, and a button to revalidate without refreshing.

  }, {
    key: '_renderDetailedView',
    value: function _renderDetailedView() {
      // The funky &nbsp; insertions are to correct for odd spacing before and after spans.
      // We only revalidate if we expect a DNS entry, so we can short-cut this case.
      var contents,
          header = React.createElement(
        'span',
        null,
        this.state.status
      );
      if (this.state.status === 'unset') {
        contents = React.createElement(
          'div',
          null,
          'To prepare to serve from a custom domain immediately, insert the following record at that domain: ',
          this._expectedCname()
        );
      } else {
        var revalidate_button = React.createElement(
          'a',
          { id: 'dns-revalidation-button',
            className: 'cpt-button style-primary size-small',
            onClick: this._submit.bind(this),
            href: '#' },
          'Revalidate DNS'
        );

        // Do not show the TTL on the records here. This is the TTL in the DNS cache we use, not the TTL of the record
        // on the authoritative server.
        var actual_records = this.state.actual_records.length > 0 ? React.createElement(
          'div',
          null,
          'We found the following records at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          ':',
          React.createElement(DnsRecordSet, { domain: this.state.domain, show_header: true, show_ttl: false, records: this.state.actual_records })
        ) : React.createElement(
          'div',
          null,
          'We were unable to find any records at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          '.'
        );

        // Only show the actual records if they are different than expected.
        if (this.state.status === 'valid') {
          contents = React.createElement(
            'div',
            null,
            actual_records,
            revalidate_button
          );
        } else {
          contents = React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              null,
              'We require this DNS record: ',
              this._expectedCname()
            ),
            actual_records,
            revalidate_button
          );
        }
      }

      return React.createElement(
        'div',
        null,
        this._renderLegacyView(),
        React.createElement(
          'div',
          { className: 'domain-helper' },
          React.createElement(
            'div',
            { className: 'domain-header ' + this._statusClass() + ' ' + this._foldedClass() },
            React.createElement('a', { id: 'domain-folder', className: this._foldedClass(), onClick: this._toggleFolding.bind(this), href: '#' }),
            React.createElement(
              'div',
              { className: 'domain-helper-title' },
              this.state.status.toUpperCase()
            ),
            React.createElement('i', { className: 'domain-status-icon' })
          ),
          React.createElement(
            'div',
            { className: 'domain-content ' + this._statusClass() + ' ' + this._foldedClass() },
            contents,
            React.createElement('div', { style: { display: 'block', clear: 'both', float: 'none' } })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.subdomain_forced) {
        return React.createElement(
          'p',
          { className: 'help-block' },
          'This field is disabled because the privacy feature you are using requires you to use the subdomain URL.'
        );
      } else if (this.state.detailed_view) {
        return this._renderDetailedView();
      } else {
        return this._renderLegacyView();
      }
    }
  }]);

  return HostHelper;
}(React.Component);

module.exports = HostHelper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DnsRecord = __webpack_require__(879);

/*
 * A table of DNS records, complete with headers and hints.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {array}  props.records - the records in the set, each as {type, value, hints}.
 * @param {bool}   props.show_ttl - true iff you want to display the ttl column.
 * @param {bool}   props.show_header - true iff you want to display the header row.
 */

var DnsRecordSet = function (_React$Component) {
  _inherits(DnsRecordSet, _React$Component);

  function DnsRecordSet() {
    _classCallCheck(this, DnsRecordSet);

    return _possibleConstructorReturn(this, (DnsRecordSet.__proto__ || Object.getPrototypeOf(DnsRecordSet)).apply(this, arguments));
  }

  _createClass(DnsRecordSet, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var header;
      if (this.props.show_header) {
        var ttl_header = this.props.show_ttl ? _react2.default.createElement(
          'div',
          { className: 'dns-ttl' },
          'TTL'
        ) : _react2.default.createElement('div', null);
        header = _react2.default.createElement(
          'div',
          { className: 'dns-records-header' },
          _react2.default.createElement(
            'div',
            { className: 'dns-domain' },
            'Domain'
          ),
          _react2.default.createElement(
            'div',
            { className: 'dns-type' },
            'Type'
          ),
          ttl_header,
          _react2.default.createElement(
            'div',
            { className: 'dns-value' },
            'Value'
          ),
          _react2.default.createElement('div', { style: { display: 'block', clear: 'both', float: 'none' } })
        );
      }
      var key = 0;
      var records = _.map(this.props.records, function (record) {
        return _react2.default.createElement(DnsRecord, { key: key++, domain: _this2.props.domain, type: record['type'], ttl: record['ttl'], value: record['value'], hints: record['hints'], show_ttl: _this2.props.show_ttl });
      });

      return _react2.default.createElement(
        'div',
        { className: 'dns-records' },
        header,
        records
      );
    }
  }]);

  return DnsRecordSet;
}(_react2.default.Component);

module.exports = DnsRecordSet;

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// A single row in a DNS records table.
// Show the TTL cell iff show_ttl.
/*
 * A table of DNS records, complete with headers and hints.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {array}  props.type - The type of the DNS record.
 * @param {bool}   props.show_ttl - true iff you want to display the ttl column.
 * @param {bool}   props.value - The value of the DNS record, e.g. a target name for a CNAME or an IP for an A record.
 */
var DnsRecord = function (_React$Component) {
  _inherits(DnsRecord, _React$Component);

  function DnsRecord() {
    _classCallCheck(this, DnsRecord);

    return _possibleConstructorReturn(this, (DnsRecord.__proto__ || Object.getPrototypeOf(DnsRecord)).apply(this, arguments));
  }

  _createClass(DnsRecord, [{
    key: "render",
    value: function render() {
      var ttl = this.props.show_ttl ? _react2.default.createElement(
        "div",
        { className: "dns-ttl" },
        this.props.ttl
      ) : _react2.default.createElement("div", null);
      var hint_items = [];
      if (this.props.hints) {
        for (var j = 0; j < this.props.hints.length; j++) {
          hint_items.push(_react2.default.createElement(
            "li",
            { key: j },
            this.props.hints[j]
          ));
        }
      }

      return _react2.default.createElement(
        "div",
        { className: "dns-records-row" },
        _react2.default.createElement(
          "div",
          { className: "dns-records-entry" },
          _react2.default.createElement(
            "div",
            { className: "dns-domain" },
            this.props.domain
          ),
          _react2.default.createElement(
            "div",
            { className: "dns-type" },
            "IN ",
            this.props.type
          ),
          ttl,
          _react2.default.createElement(
            "div",
            { className: "dns-value" },
            this.props.value
          ),
          _react2.default.createElement("div", { style: { display: 'block', clear: 'both', float: 'none' } })
        ),
        _react2.default.createElement(
          "div",
          { className: "dns-record-hints", style: { display: 'block', clear: 'both' } },
          _react2.default.createElement(
            "ul",
            null,
            hint_items
          )
        )
      );
    }
  }]);

  return DnsRecord;
}(_react2.default.Component);

module.exports = DnsRecord;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var TEAM = 'Team Members';
var SUBSCRIBERS = 'Subscribers';
var METRICS = 'Metrics';
var PAGE_ACCESS_GROUPS = 'Page Access Groups';
var TABS = [TEAM, SUBSCRIBERS, METRICS, PAGE_ACCESS_GROUPS];

var ExceedingAllocationsDashboard = function (_React$Component) {
  _inherits(ExceedingAllocationsDashboard, _React$Component);

  function ExceedingAllocationsDashboard(props) {
    _classCallCheck(this, ExceedingAllocationsDashboard);

    var _this = _possibleConstructorReturn(this, (ExceedingAllocationsDashboard.__proto__ || Object.getPrototypeOf(ExceedingAllocationsDashboard)).call(this, props));

    _this.state = { activeTab: TEAM };
    return _this;
  }

  _createClass(ExceedingAllocationsDashboard, [{
    key: '_toggleTab',
    value: function _toggleTab(tabClicked) {
      this.setState({ activeTab: tabClicked });
    }
  }, {
    key: '_displayTabs',
    value: function _displayTabs() {
      var _this2 = this;

      var tabs = [];

      _.map(TABS, function (tab) {
        tabs.push(React.createElement(
          'li',
          { key: tab, className: _this2.state.activeTab === tab ? 'active' : null, onClick: _this2._toggleTab.bind(_this2, tab) },
          React.createElement(
            'a',
            { href: '#' },
            tab
          )
        ));
      });

      return React.createElement(
        'ul',
        { className: 'cpt-tabs' },
        ' ',
        tabs,
        ' '
      );
    }
  }, {
    key: '_determineData',
    value: function _determineData() {
      if (this.state.activeTab === TEAM) {
        return this.props.team_results;
      } else if (this.state.activeTab === SUBSCRIBERS) {
        return this.props.subscriber_results;
      } else if (this.state.activeTab === METRICS) {
        return this.props.metric_results;
      } else if (this.state.activeTab === PAGE_ACCESS_GROUPS) {
        return this.props.page_access_group_results;
      }
    }
  }, {
    key: '_displayData',
    value: function _displayData() {
      var data = this._determineData();
      var rows = [];

      if (data.length > 0) {
        rows.push(React.createElement(
          'div',
          { className: 'table-row column-header' },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'span6' },
              this.state.activeTab === TEAM ? "Organization " : "Team ",
              'Name'
            ),
            React.createElement(
              'div',
              { className: 'span3' },
              'Over By'
            )
          )
        ));

        _.map(data, function (datapoint) {
          rows.push(React.createElement(
            'div',
            { className: 'table-row' },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'span6' },
                React.createElement(
                  'a',
                  { href: datapoint.snapshot_link },
                  datapoint.name
                )
              ),
              React.createElement(
                'div',
                { className: 'span3' },
                datapoint.over_allocation_count
              )
            )
          ));
        });
      } else {
        rows.push(React.createElement(
          'span',
          { key: this.state.activeTab },
          React.createElement(
            'em',
            null,
            'Good news! No one is over their allocations for ',
            this.state.activeTab,
            '.'
          )
        ));
      }

      return rows;
    }
  }, {
    key: 'csvRoute',
    value: function csvRoute() {
      return Routes.admin_exceeding_allocations_path({ format: 'csv' });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'content-area' },
        React.createElement(
          'div',
          { className: 'header' },
          React.createElement(
            'a',
            { href: this.csvRoute(), className: 'cpt-button size-small style-primary pull-right' },
            ' Download as CSV '
          ),
          React.createElement(
            'h3',
            { className: 'page-header' },
            'Exceeding Allocations Dashboard'
          )
        ),
        this._displayTabs(),
        React.createElement(
          'div',
          { className: 'cpt-table' },
          React.createElement(
            'div',
            { className: 'content' },
            React.createElement(
              'div',
              { className: 'table-row-group' },
              this._displayData()
            )
          )
        )
      );
    }
  }]);

  return ExceedingAllocationsDashboard;
}(React.Component);

module.exports = ExceedingAllocationsDashboard;

/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchLocale"] = fetchLocale;
/* harmony export (immutable) */ __webpack_exports__["doesLocaleRequireGeneralMarketingConsent"] = doesLocaleRequireGeneralMarketingConsent;
/* harmony export (immutable) */ __webpack_exports__["fetchConsentState"] = fetchConsentState;
/* harmony export (immutable) */ __webpack_exports__["setConsentState"] = setConsentState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

/**
 * Fetch the GEORGRAPHIC locale of this IP from ConsentHub.
 * This is NOT a language locale; this returns a best guess for a LEGAL, GEOGRAPHICAL entity to which the IP belongs.
 *
 * @param basePreferencesUrl The base url for the locale endpoint. This is environment-specific.
 * @param done The callback when the request has finished. If there is a locale, the locale is passed; otherwise, including if there was an error, locale is null.
 */
function fetchLocale(basePreferencesUrl, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["get"](basePreferencesUrl + "/rest/forms/locale").
        done(function (body) { return done(body['locale']); }).
        fail(function () { return done(null); });
}
/**
 * Fetch whether the locale requires we collect consent from an endpoint we maintain in our own app, /marketing-consent-required.
 *
 * @param locale The locale to check for consent requirements.
 * @param done The callback on conclusion of the request. Called with 'required' reflecting whether or not the checkbox is required.
 */
function doesLocaleRequireGeneralMarketingConsent(locale, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["get"]('/marketing-consent-required?locale=' + locale)
        .done(function (body) {
        done(body.should_display_general_marketing_consent_checkbox);
    })
        .fail(function () { return done(true); }); // err on the side of caution and display it anyway; if it's unnecessary it's ignored anyway.
}
/**
 * Fetch whether the locale requires we collect consent from an endpoint we maintain in our own app, /marketing-consent.
 * This may also possibly auto-consent a user, in which case we can hide the banner.
 *
 * @param locale  The locale to check for consent requirements.
 * @param done The callback when the request completes successfully.
 */
function fetchConsentState(locale, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["get"]('/marketing-consent?locale=' + locale)
        .done(function (body) { return done(body.should_display_general_marketing_consent_banner); })
        .fail(function () { return done(true); }); // err on the side of caution and display it anyway; if it's unnecessary it's ignored anyway.
}
/**
 * Give a decsion whether to grant the generalMarketingOptIn consent or not.
 *
 * @param locale The geographic locale of the user.
 * @param general_marketing_opt_in_result true means the user is giving their consent, false means they are not.
 * @param done The callback when the request has completed successfully.
 */
function setConsentState(locale, general_marketing_opt_in_result, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["post"]('/marketing-consent', { locale: locale, general_marketing_opt_in_result: general_marketing_opt_in_result })
        .done(function (_body) {
        done(true);
    })
        .fail(function (_error) { return done(true); });
}


/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _form = __webpack_require__(134);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);

var ImportSubscriberForm = function (_React$Component) {
  _inherits(ImportSubscriberForm, _React$Component);

  function ImportSubscriberForm(props) {
    _classCallCheck(this, ImportSubscriberForm);

    var _this = _possibleConstructorReturn(this, (ImportSubscriberForm.__proto__ || Object.getPrototypeOf(ImportSubscriberForm)).call(this, props));

    _this.state = { 'filepickerId': '', 'filename': '' };
    return _this;
  }

  _createClass(ImportSubscriberForm, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'modal hide fade modal-import-subscribers', id: 'modal-import-subscribers', style: { display: 'none' } },
        React.createElement(
          'div',
          { className: 'modal-header' },
          React.createElement(
            'a',
            { href: '#', 'data-dismiss': 'modal', className: 'close' },
            '\xD7'
          ),
          React.createElement(
            'h3',
            null,
            'Import Subscribers'
          )
        ),
        React.createElement(
          _form2.default,
          { method: 'POST', action: this.props.import_subscribers_page_url, onSubmit: this.onSubmit.bind(this), ref: 'input_subscribers_form' },
          React.createElement(
            'div',
            { className: 'modal-body form-horizontal' },
            React.createElement(
              'p',
              null,
              'Import many subscribers at once by uploading a ',
              React.createElement(
                'em',
                null,
                '.csv'
              ),
              ' file. Before you get started, keep the following in mind:'
            ),
            React.createElement(
              'ul',
              { className: 'styled' },
              React.createElement(
                'li',
                null,
                'The only allowed file type is a .csv (not a .numbers or .xlsx)'
              ),
              React.createElement(
                'li',
                null,
                'The file must be under 20Mb in size'
              ),
              React.createElement(
                'li',
                null,
                'The upload might take a while; we\'ll email you when it\'s done'
              ),
              React.createElement(
                'li',
                null,
                React.createElement(
                  'a',
                  { href: this.props.download_template_page_url },
                  'Download this import template'
                ),
                ' to see how to organize your .csv'
              ),
              React.createElement(
                'li',
                null,
                React.createElement(
                  'a',
                  { href: 'http://help.statuspage.io/knowledge_base/topics/importing-subscribers-via-csv' },
                  'Check out this article'
                ),
                ' for more details on specifics for each field'
              )
            ),
            this.error(),
            React.createElement(
              'div',
              { className: 'file-upload-container' },
              React.createElement('input', { type: 'file', ref: 'csv_file', accept: 'text/csv', id: 'csv_file' }),
              React.createElement('input', { type: 'hidden', name: 'filepicker_id', value: this.state.filepickerId }),
              React.createElement('input', { type: 'hidden', name: 'filename', value: this.state.filename })
            ),
            this.progress()
          ),
          React.createElement(
            'div',
            { className: 'modal-footer' },
            React.createElement(
              'button',
              { className: 'cpt-button style-primary', id: 'btn-import-subscribers' },
              'Import Subscribers'
            )
          )
        )
      );
    }
  }, {
    key: 'error',
    value: function error() {
      if (!this.state.error) {
        return null;
      }

      return React.createElement(
        'div',
        { className: 'cpt-notification error in-page no-delivery-types-error', style: { 'marginBottom': '1rem' } },
        this.state.error
      );
    }
  }, {
    key: 'progress',
    value: function progress() {
      if (!this.state.progress) {
        return null;
      }
      return React.createElement(
        'div',
        { className: 'cpt-progress', style: { 'marginTop': '1rem' } },
        React.createElement('div', { className: 'bar', style: { width: this.state.progress + '%' } })
      );
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      var fileInput = ReactDOM.findDOMNode(this.refs.csv_file);

      if (fileInput.files.length == 0) {
        this.setErrorMessage("Please provide a CSV file to import.");
        return;
      }

      var maxSize = 20 * 1024 * 1024;
      // Check the size of the file to make sure it's not too large if the browser supports the check
      if (window.FileReader && fileInput.files) {
        if (fileInput.files[0].size > maxSize) {
          // Add an error message and return
          this.setErrorMessage("You can't upload files larger than 20Mb.");
          return;
        }
      }

      filepicker.setKey(this.props.filepicker_key);
      filepicker.store(fileInput, {
        mimetype: 'text/csv'
      }, function (FPFile) {
        // Update the progress bar
        _this2.setState({ 'progress': 100 });
        // Remove the progress bar shortly after completion
        setTimeout(function () {
          _this2.setState({ 'progress': null });
        }, 150);

        // Check that the file uploaded wasn't larger than what we want to process
        if (FPFile.size && FPFile.size > maxSize) {
          _this2.setErrorMessage("You can't upload files larger than 20Mb.");
          return;
        }
        var urlsParts = FPFile.url.split("/");
        var filepickerId = urlsParts[urlsParts.length - 1];
        var filename = FPFile.filename;
        _this2.setState({ 'filepickerId': filepickerId, 'filename': filename }, function () {
          ReactDOM.findDOMNode(_this2.refs.input_subscribers_form).submit();
        });
      }, function (FPError) {
        _this2.setErrorMessage(FPError.toString());
      }, function (progress) {
        _this2.setState({ 'progress': progress });
      });
    }
  }, {
    key: 'setErrorMessage',
    value: function setErrorMessage(errorMessage) {
      var _this3 = this;

      this.setState({ 'error': errorMessage });
      // Only show the error message for 4 seconds
      setTimeout(function () {
        _this3.setState({ 'error': null });
      }, 4000);
    }
  }]);

  return ImportSubscriberForm;
}(React.Component);

module.exports = ImportSubscriberForm;

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _server = __webpack_require__(172);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ESSearchField = __webpack_require__(237);
var moment = __webpack_require__(2);
var sanitizeHtml = __webpack_require__(466);

var Incident = __webpack_require__(255);

var IncidentsSearchField = function (_React$Component) {
  _inherits(IncidentsSearchField, _React$Component);

  function IncidentsSearchField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IncidentsSearchField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IncidentsSearchField.__proto__ || Object.getPrototypeOf(IncidentsSearchField)).call.apply(_ref, [this].concat(args))), _this), _this._template = function (suggestion) {
      var view = React.createElement(IncidentTypeaheadView, { suggestion: suggestion });
      return _server2.default.renderToString(view);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Get HTML string for how a typeahead item should be rendered


  _createClass(IncidentsSearchField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var searchRoute = Incident.searchRoute({ page_id: this.props.page.id });
      var mapResultToUiRoute = function mapResultToUiRoute(suggestion) {
        return Routes.page_incident_path(_this2.props.page, suggestion.id, { domain: null, subdomain: null });
      };
      return React.createElement(ESSearchField, { queryUrl: searchRoute + '?limit=10&q=%QUERY',
        pluralizedResultName: "incidents",
        loadResults: Incident.search,
        mapResultToUiUrl: mapResultToUiRoute,
        template: this._template
      });
    }
  }]);

  return IncidentsSearchField;
}(React.Component);

var IncidentTypeaheadView = function (_React$Component2) {
  _inherits(IncidentTypeaheadView, _React$Component2);

  function IncidentTypeaheadView() {
    _classCallCheck(this, IncidentTypeaheadView);

    return _possibleConstructorReturn(this, (IncidentTypeaheadView.__proto__ || Object.getPrototypeOf(IncidentTypeaheadView)).apply(this, arguments));
  }

  _createClass(IncidentTypeaheadView, [{
    key: '_context',
    value: function _context() {
      var timestamp = this._timestamp();
      var highlight = sanitizeHtml(this._highlightText());
      var innerHtml = timestamp + ' - ' + highlight + '&#8230;';

      return React.createElement('div', { className: 'context', dangerouslySetInnerHTML: { __html: innerHtml } });
    }
  }, {
    key: '_timestamp',
    value: function _timestamp() {
      return moment(this._mostRecentUpdate().created_at).format('l');
    }
  }, {
    key: '_highlightText',
    value: function _highlightText() {
      if (this._isUpdateHighlighted()) {
        return this.props.suggestion.highlight['incident_updates.body'][0];
      }

      return this._firstUpdate().body;
    }
  }, {
    key: '_mostRecentUpdate',
    value: function _mostRecentUpdate() {
      return this.props.suggestion.incident_updates[0];
    }
  }, {
    key: '_firstUpdate',
    value: function _firstUpdate() {
      var updates = this.props.suggestion.incident_updates;
      return updates[updates.length - 1];
    }
  }, {
    key: '_titleText',
    value: function _titleText() {
      var displayWords = this.props.suggestion.name;

      if (this._isNameHighlighted()) {
        var text = this.props.suggestion.highlight['name'];
        var highlightItems = $('<span>' + text + '</span>').find('strong');
        var tagClasses = $(highlightItems[0]).attr('class');
        var highlightedWords = _.map(highlightItems, function (t) {
          return $(t).text().toLowerCase();
        });

        displayWords = this.props.suggestion.name.split(' ').map(function (word, index) {
          var sanitizedWord = word.toLowerCase().replace(/[!?\.,]/, '');
          if (highlightedWords.indexOf(sanitizedWord) >= 0) {
            return React.createElement(
              'strong',
              { key: sanitizedWord, className: tagClasses },
              ' ',
              word,
              ' '
            );
          }
          return React.createElement(
            'span',
            { key: sanitizedWord },
            ' ',
            word,
            ' '
          );
        });
      }
      return React.createElement(
        'span',
        { className: 'name' },
        displayWords
      );
    }
  }, {
    key: '_isUpdateHighlighted',
    value: function _isUpdateHighlighted() {
      return this._checkFieldHighlight('incident_updates.body');
    }
  }, {
    key: '_isNameHighlighted',
    value: function _isNameHighlighted() {
      return this._checkFieldHighlight('name');
    }
  }, {
    key: '_checkFieldHighlight',
    value: function _checkFieldHighlight(property) {
      return this.props.suggestion.highlight && this.props.suggestion.highlight.hasOwnProperty(property);
    }
  }, {
    key: 'render',
    value: function render() {
      var suggestion = this.props.suggestion;
      var iconClass = suggestion.is_scheduled_maintenance ? "fa-calendar" : "fa-exclamation-triangle";

      return React.createElement(
        'div',
        { className: 'item search-result es-results' },
        React.createElement(
          'div',
          { className: 'icon-container' },
          React.createElement('i', { className: "fa " + iconClass })
        ),
        React.createElement(
          'div',
          { className: 'result-text-container' },
          this._titleText(),
          this._context()
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return IncidentTypeaheadView;
}(React.Component);

module.exports = IncidentsSearchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* README:
 * Removed  "import * as $ from 'jquery'" since the invocation of tooltip was breaking on it.
 * We rely on a global imported jQuery, which has the tooltip method,
 * to get our tests to consistently work for now.
 * TODO: [ ] Componentize jQuery and tooltips together.
 * */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.componentDidMount = function () {
        this.mountTooltip();
    };
    Tooltip.prototype.componentDidUpdate = function () {
        var domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this);
        $(domNode).tooltipster('content', this.props.title);
    };
    Tooltip.prototype.componentWillUnmount = function () {
        this.destroyTooltip();
    };
    Tooltip.prototype.mountTooltip = function () {
        if ('ontouchstart' in document.documentElement && this.props.disableOnTouchScreen) {
            return;
        }
        var domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this);
        $(domNode).tooltipster({
            animationDuration: this.props.animationDuration,
            side: this.props.placement,
            content: this.props.title,
            delay: this.props.delay,
            maxWidth: this.props.maxWidth,
            theme: this.props.theme,
        });
    };
    Tooltip.prototype.destroyTooltip = function () {
        var domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this);
        $(domNode).tooltipster('destroy');
    };
    Tooltip.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: this.props.className }, this.props.children));
    };
    Tooltip.defaultProps = {
        animationDuration: 100,
        placement: 'top',
        delay: 100,
        maxWidth: 250,
        theme: 'tooltipster-borderless',
        disableOnTouchScreen: false,
    };
    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var IncidentTemplateIndex = __webpack_require__(946);

var IncidentTemplates = function (_React$Component) {
  _inherits(IncidentTemplates, _React$Component);

  function IncidentTemplates() {
    _classCallCheck(this, IncidentTemplates);

    return _possibleConstructorReturn(this, (IncidentTemplates.__proto__ || Object.getPrototypeOf(IncidentTemplates)).apply(this, arguments));
  }

  _createClass(IncidentTemplates, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cpt-table standard-two-row' },
        React.createElement(
          'div',
          { id: 'incident-template-index', className: 'incident-template-index content' },
          React.createElement(IncidentTemplateIndex, { templates: this.props.individual_templates,
            template_groups: this.props.template_groups,
            page_param: this.props.page_param,
            new_template_url: this.props.new_template_url })
        )
      );
    }
  }]);

  return IncidentTemplates;
}(React.Component);

module.exports = IncidentTemplates;

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var IncidentTemplateListItem = __webpack_require__(495);
var IncidentTemplateListGroup = __webpack_require__(947);

var IncidentTemplateIndex = function (_React$Component) {
  _inherits(IncidentTemplateIndex, _React$Component);

  function IncidentTemplateIndex(props) {
    _classCallCheck(this, IncidentTemplateIndex);

    var _this = _possibleConstructorReturn(this, (IncidentTemplateIndex.__proto__ || Object.getPrototypeOf(IncidentTemplateIndex)).call(this, props));

    _this.pageParam = props.page_param;
    return _this;
  }

  _createClass(IncidentTemplateIndex, [{
    key: '_insertHeader',
    value: function _insertHeader() {
      return React.createElement(
        'div',
        { className: 'header' },
        React.createElement(
          'h4',
          null,
          'Incident Templates'
        ),
        React.createElement(
          'a',
          { href: this.props.new_template_url, className: 'cpt-button size-small style-primary' },
          '+ New Incident Template'
        )
      );
    }
  }, {
    key: '_buildTemplateItems',
    value: function _buildTemplateItems() {
      var pageParam = this.pageParam;

      return React.createElement(
        'div',
        null,
        this.props.templates.map(function (template) {
          return React.createElement(
            'div',
            { className: 'table-row', key: template.id },
            React.createElement(IncidentTemplateListItem, { template: template, pageParam: pageParam })
          );
        })
      );
    }
  }, {
    key: '_buildTemplateGroups',
    value: function _buildTemplateGroups() {
      var pageParam = this.pageParam;

      return React.createElement(
        'div',
        { className: 'template-group-items' },
        this.props.template_groups.map(function (group) {
          return React.createElement(IncidentTemplateListGroup, { key: group.param, group: group, pageParam: pageParam });
        })
      );
    }
  }, {
    key: '_tableRowGroupClass',
    value: function _tableRowGroupClass() {
      return 'table-row-group ' + (this.props.template_groups.length ? 'has-template-groups' : '');
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.templates.length > 0 || this.props.template_groups.length > 0) {
        return React.createElement(
          'div',
          null,
          this._insertHeader(),
          React.createElement(
            'div',
            { className: this._tableRowGroupClass() },
            this.props.templates.length > 0 ? this._buildTemplateItems() : null,
            this.props.template_groups.length > 0 ? this._buildTemplateGroups() : null
          )
        );
      }
      return React.createElement(
        'div',
        null,
        this._insertHeader(),
        React.createElement(
          'div',
          { className: 'table-row-group' },
          React.createElement(
            'div',
            { className: 'table-row blank-state' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'strong',
                null,
                'Proper preparation prevents poor performance!'
              )
            ),
            React.createElement(
              'small',
              null,
              'Prepare for downtime before it happens: ',
              React.createElement(
                'a',
                { href: this.props.new_template_url },
                'Create an incident template.'
              )
            )
          )
        )
      );
    }
  }]);

  return IncidentTemplateIndex;
}(React.Component);

module.exports = IncidentTemplateIndex;

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);

var IncidentTemplateListItem = __webpack_require__(495);
var EditFieldModal = __webpack_require__(948);

var ClosedState = "fa fa-plus-square-o";
var OpenState = "fa fa-minus-square-o";

var IncidentTemplateListGroup = function (_React$Component) {
  _inherits(IncidentTemplateListGroup, _React$Component);

  function IncidentTemplateListGroup(props) {
    _classCallCheck(this, IncidentTemplateListGroup);

    var _this = _possibleConstructorReturn(this, (IncidentTemplateListGroup.__proto__ || Object.getPrototypeOf(IncidentTemplateListGroup)).call(this, props));

    _this.state = { groupShow: OpenState };
    return _this;
  }

  _createClass(IncidentTemplateListGroup, [{
    key: '_toggleDropdown',
    value: function _toggleDropdown() {
      if (this.state.groupShow == ClosedState) {
        this.setState({ groupShow: OpenState });
      } else {
        this.setState({ groupShow: ClosedState });
      }
    }
  }, {
    key: '_showTemplateGroups',
    value: function _showTemplateGroups() {
      var pageParam = this.props.pageParam;

      return React.createElement(
        'div',
        null,
        this.props.group.templates.map(function (template) {
          return React.createElement(
            'div',
            { className: 'template-sub-item', key: template.id },
            React.createElement(IncidentTemplateListItem, { template: template, pageParam: pageParam })
          );
        })
      );
    }
  }, {
    key: '_triggerEditModal',
    value: function _triggerEditModal(event) {
      event.preventDefault();
      event.stopPropagation();
      $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-edit-incident-template-group-name').modal();
    }
  }, {
    key: '_handleDelete',
    value: function _handleDelete() {
      if (window.confirm("Are you sure you want to delete this template group? Templates in this group won't be deleted, but will become \"ungrouped\" templates.")) {
        $.ajax({
          type: 'DELETE',
          url: Routes.page_incident_template_group_path(this.props.pageParam, this.props.group.param),
          dataType: 'JSON',
          success: function success(data, textStatus, xhr) {
            window.location.reload(true);
          },
          error: function error(xhr, textStatus) {
            HRB.utils.basicFailAndReload(xhr);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var group = this.props.group;

      return React.createElement(
        'div',
        { className: 'table-row' },
        React.createElement('i', { className: this.state.groupShow, onClick: this._toggleDropdown.bind(this) }),
        React.createElement(
          'div',
          { className: 'template-meta' },
          React.createElement(
            'strong',
            null,
            group.name
          )
        ),
        React.createElement(
          'a',
          { href: '#', onClick: this._triggerEditModal.bind(this) },
          'Edit'
        ),
        React.createElement(
          'a',
          { href: '#', className: 'template-delete', onClick: this._handleDelete.bind(this) },
          'Delete'
        ),
        this.state.groupShow == OpenState ? this._showTemplateGroups() : null,
        React.createElement(EditFieldModal, { id: 'edit-incident-template-group-name',
          title: "Edit " + group.name,
          putUrl: Routes.page_update_group_name_path(this.props.pageParam),
          owningEntityParam: group.param,
          label: 'Group Name',
          placeholder: group.name,
          paramName: 'group_name',
          submit_text: 'Save' })
      );
    }
  }]);

  return IncidentTemplateListGroup;
}(React.Component);

module.exports = IncidentTemplateListGroup;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(4);

var Input = __webpack_require__(42);

var EditFieldModal = function (_React$Component) {
  _inherits(EditFieldModal, _React$Component);

  /**
   * A reusable modal with an input field.
   *
   * @param {object} props
   * @param {string} props.id - Id of the modal confirmation div, will be 'modal-confirmation-{{PROVIDED_ID}}'
   * @param {string} props.title - Title of the modal
   * @param {string} props.label - Label for the input
   * @param {string} props.putUrl - Where are going to send this thing?
   * @param {string} props.paramName - name of the param to send up the chain
   * @param {string} props.owningEntityParam - Param for the object that we're updating with this input
   * @param {string} props.placeholder - placeholder text for the input
   * @param {string} props.submit_text - the text used as the submit button text
   */

  function EditFieldModal(props) {
    _classCallCheck(this, EditFieldModal);

    var _this = _possibleConstructorReturn(this, (EditFieldModal.__proto__ || Object.getPrototypeOf(EditFieldModal)).call(this, props));

    _this.state = { inputValue: null };
    return _this;
  }

  _createClass(EditFieldModal, [{
    key: '_setInputValue',
    value: function _setInputValue(e) {
      this.setState({ inputValue: e.target.value });
    }
  }, {
    key: '_submitInput',
    value: function _submitInput() {
      if (this.state.inputValue != null) {
        var params = { id: this.props.owningEntityParam };
        params[this.props.paramName] = this.state.inputValue;

        $.ajax({
          type: 'PUT',
          url: this.props.putUrl,
          data: params,
          success: function success(data, textStatus, xhr) {
            window.location.reload(true);
          },
          error: function error(xhr, textStatus) {
            HRB.utils.basicFailAndReload(xhr);
          }
        });
      } else {
        alert('This field cannot be blank!');
      }
    }
  }, {
    key: '_onCancel',
    value: function _onCancel() {
      $(document).trigger('statuspage.confirm.' + this.props.id + '.canceled');
      if (this.props.onCancel) {
        this.props.onCancel();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = cx('modal hide fade modal-confirmation', this.props.className);

      return React.createElement(
        'div',
        { className: className, id: "modal-confirmation-" + this.props.id, style: { display: 'none' } },
        React.createElement(
          'div',
          { className: 'modal-header' },
          React.createElement(
            'a',
            { href: '#', 'data-dismiss': 'modal', className: 'close' },
            '\xD7'
          ),
          React.createElement(
            'h4',
            null,
            this.props.title
          )
        ),
        React.createElement(
          'div',
          { className: 'modal-body' },
          React.createElement(Input, { type: 'text',
            label: this.props.label,
            inputClass: 'full-width',
            name: this.props.paramName,
            placeholder: this.props.placeholder,
            onChange: this._setInputValue.bind(this) })
        ),
        React.createElement(
          'div',
          { className: 'modal-footer' },
          React.createElement(
            'button',
            { className: 'cpt-button style-primary', 'data-dismiss': 'modal', id: "btn-confirm-" + this.props.id, onClick: this._submitInput.bind(this) },
            this.props.submit_text
          ),
          React.createElement(
            'a',
            { href: '#', id: "btn-cancel-" + this.props.id, 'data-dismiss': 'modal', className: 'close', onClick: this._onCancel.bind(this) },
            'Cancel'
          )
        )
      );
    }
  }]);

  return EditFieldModal;
}(React.Component);

module.exports = EditFieldModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _form = __webpack_require__(134);

var _form2 = _interopRequireDefault(_form);

var _checkbox = __webpack_require__(109);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Input = __webpack_require__(42);
var InputDropdownToggle = __webpack_require__(950);
var SelectInput = __webpack_require__(74);
var TextArea = __webpack_require__(140);

var IncidentTemplateForm = function (_React$Component) {
  _inherits(IncidentTemplateForm, _React$Component);

  function IncidentTemplateForm(props) {
    _classCallCheck(this, IncidentTemplateForm);

    var _this = _possibleConstructorReturn(this, (IncidentTemplateForm.__proto__ || Object.getPrototypeOf(IncidentTemplateForm)).call(this, props));

    _this._handleTwitterCheckboxChange = function (event) {
      _this.setState({ shouldTweet: event.target.checked });
    };

    _this._handleSendNotificationsCheckboxChange = function (event) {
      _this.setState({ shouldSendNotifications: event.target.checked });
    };

    _this.state = {
      shouldTweet: _this.props.should_tweet,
      shouldSendNotifications: _this.props.should_send_notifications
    };
    return _this;
  }

  _createClass(IncidentTemplateForm, [{
    key: '_showGroupDropdown',
    value: function _showGroupDropdown() {
      if (this.props.allow_groups) {
        return React.createElement(InputDropdownToggle, { dropdownName: 'group_id',
          inputName: 'group_name',
          label: 'Incident Template Group',
          helpBlockText: 'The group that this template belongs to.',
          placeholder: 'New Template Group Name',
          toggleElement: 'create',
          cancelText: 'Cancel new group creation',
          options: this.props.group_values,
          defaultValue: this.props.default_group,
          selectClass: 'full-width' });
      } else {
        return React.createElement('input', { type: 'hidden', id: 'nil_group_selector', name: 'group_id', value: 'no_group' });
      }
    }
  }, {
    key: '_showComponentSelector',
    value: function _showComponentSelector() {
      if (this.props.allow_components && this.props.components.length > 0) {
        return React.createElement(
          'div',
          { className: 'component-subscriptions control-group' },
          React.createElement(
            'label',
            null,
            this.props.components_label
          ),
          React.createElement(ItemsSelector, { items: this.props.components,
            className: this.props.item_selector_class_name,
            preselectedItemIds: this.props.selected_components,
            hiddenFieldName: 'component_ids' })
        );
      }
    }
  }, {
    key: '_showSendNotificationsCheckbox',
    value: function _showSendNotificationsCheckbox() {
      return React.createElement(
        'div',
        { className: 'send-notifications-update control-group' },
        React.createElement(
          'label',
          null,
          'Send Notifications'
        ),
        React.createElement(_checkbox2.default, { name: 'should_send_notifications',
          label: 'Checks the \'Send Notifications\' checkbox when using this template',
          defaultChecked: this.props.should_send_notifications,
          onChange: this._handleSendNotificationsCheckboxChange }),
        React.createElement('input', { type: 'hidden', id: 'should_send_notifications', name: 'should_send_notifications', value: !!this.state.shouldSendNotifications })
      );
    }
  }, {
    key: '_showTwitterCheckbox',
    value: function _showTwitterCheckbox() {
      // Checkboxes are shitty, and either return 'on' or nil.
      // Utilize a hidden input to send either true or false to the controller.
      if (this.props.allow_twitter && this.props.isTwitterAuthorized) {
        return React.createElement(
          'div',
          { className: 'twitter-update control-group' },
          React.createElement(
            'label',
            null,
            'Tweet Update'
          ),
          React.createElement(_checkbox2.default, { name: 'should_tweet',
            label: 'Check the \'Post to Twitter\' checkbox when using this template',
            defaultChecked: this.props.should_tweet,
            onChange: this._handleTwitterCheckboxChange }),
          React.createElement('input', { type: 'hidden', id: 'should_tweet', name: 'should_tweet', value: !!this.state.shouldTweet })
        );
      } else {
        return React.createElement('input', { type: 'hidden', id: 'should_tweet', name: 'should_tweet', value: 'false' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'incident-template-form' },
        React.createElement(
          _form2.default,
          { 'for': 'IncidentTemplate', method: this.props.method, action: this.props.path },
          this._showGroupDropdown(),
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: 'Template Name',
            name: 'name',
            placeholder: 'Template Name',
            defaultValue: this.props.template ? this.props.template.name : null,
            helpBlockText: 'This is used internally so you can identify which template you\'re using.' }),
          React.createElement(SelectInput, { name: 'update_status',
            label: 'Incident Status',
            options: this.props.status_values,
            helpBlockText: 'The status that will be applied to the incident or scheduled maintenance.',
            defaultValue: this.props.template ? this.props.template.update_status : null,
            selectClass: 'full-width',
            groups: ["Realtime Incidents", "Scheduled Maintenances"] }),
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: 'Incident Title',
            name: 'title',
            placeholder: 'Incident Title',
            defaultValue: this.props.template ? this.props.template.title : null,
            helpBlockText: 'The title given to the incident or scheduled maintenance. This is only applied when creating an incident or scheduled maintenance.' }),
          React.createElement(
            'div',
            { className: 'span12 text-area-container control-group' },
            React.createElement(TextArea, { inputClass: 'full-width',
              label: 'Message Body',
              name: 'body',
              placeholder: 'Message Body',
              defaultValue: this.props.template ? this.props.template.body : null,
              textareaStyle: { height: 160 } })
          ),
          this._showComponentSelector(),
          this._showTwitterCheckbox(),
          this._showSendNotificationsCheckbox(),
          React.createElement(
            'div',
            { className: 'form-actions' },
            React.createElement(
              'button',
              { type: 'submit', className: 'cpt-button style-primary size-small' },
              this.props.button_text,
              ' Template'
            )
          )
        )
      );
    }
  }]);

  return IncidentTemplateForm;
}(React.Component);

IncidentTemplateForm.defaultProps = {
  components_label: 'Alert Users Subscribed To:',
  shouldTweet: false
};


module.exports = IncidentTemplateForm;

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Input = __webpack_require__(42);
var SelectInput = __webpack_require__(74);

var InputDropdownToggle = function (_React$Component) {
  _inherits(InputDropdownToggle, _React$Component);

  /*
   * A combination Dropdown/Input field that allows the user to either select an existing value, or create a new one.
   * On selection of 'Create a new (template, component, etc)', the field will toggle to an input value.
   *
   * @param {object} props
   * @param {object} props.dropdownName - name tied to the Dropdown
   * @param {object} props.inputName - name tied to the Input
   * @param {object} props.label - label for the input & dropdown
   * @param {object} props.helpBlockText - helpblock text for the input & dropdown
   * @param {object} props.options - options for the dropdown box
   * @param {object} props.defaultValue - efaultValue for the text area
   * @param {object} props.toggleElement - the value in the dropdown that triggers the switch to input
   * @param {object} props.cancelText - Text and value for link that cancels new group creating
   */

  function InputDropdownToggle(props) {
    _classCallCheck(this, InputDropdownToggle);

    var _this = _possibleConstructorReturn(this, (InputDropdownToggle.__proto__ || Object.getPrototypeOf(InputDropdownToggle)).call(this, props));

    _this.id = 'input-dropdown-toggle-' + Math.round(Math.random() * 100000);
    _this.state = { showDropdown: true };
    return _this;
  }

  _createClass(InputDropdownToggle, [{
    key: '_handleGroupChange',
    value: function _handleGroupChange(event) {
      if (event.target.value === this.props.toggleElement) {
        this.setState({ showDropdown: false });
      } else if (event.target.id === this.id + '-cancel-link') {
        this.setState({ showDropdown: true });
      }
    }
  }, {
    key: '_determineFormElement',
    value: function _determineFormElement() {
      if (this.state.showDropdown) {
        return React.createElement(SelectInput, { name: this.props.dropdownName,
          label: this.props.label,
          helpBlockText: this.props.helpBlockText,
          options: this.props.options,
          defaultValue: this.props.defaultValue,
          onChange: this._handleGroupChange.bind(this),
          selectClass: this.props.selectClass });
      } else {
        return React.createElement(
          'span',
          null,
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: this.props.label,
            name: this.props.inputName,
            placeholder: this.props.placeholder,
            selectClass: this.props.selectClass }),
          React.createElement(
            'span',
            { className: 'help-block' },
            React.createElement(
              'a',
              { href: '#', id: this.id + '-cancel-link', onClick: this._handleGroupChange.bind(this) },
              this.props.cancelText
            )
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'control-group' },
        this._determineFormElement()
      );
    }
  }]);

  return InputDropdownToggle;
}(React.Component);

module.exports = InputDropdownToggle;

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _make_owner = __webpack_require__(952);

var _make_owner2 = _interopRequireDefault(_make_owner);

var _delete_user = __webpack_require__(953);

var _delete_user2 = _interopRequireDefault(_delete_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModifyUser = function (_React$Component) {
  _inherits(ModifyUser, _React$Component);

  function ModifyUser(props) {
    _classCallCheck(this, ModifyUser);

    return _possibleConstructorReturn(this, (ModifyUser.__proto__ || Object.getPrototypeOf(ModifyUser)).call(this, props));
  }

  _createClass(ModifyUser, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "inline" } },
        _react2.default.createElement(_make_owner2.default, this.props),
        _react2.default.createElement(_delete_user2.default, this.props)
      );
    }
  }]);

  return ModifyUser;
}(_react2.default.Component);

module.exports = ModifyUser;

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(171),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);

var MAKE_OWNER_MODAL = 'make-owner';
var MAKE_OWNER_MODAL_TRIGGER = MODAL_PREFIX + MAKE_OWNER_MODAL;

var MakeOwner = function (_React$Component) {
  _inherits(MakeOwner, _React$Component);

  /**
   * @params props.organization
   * @params props.user
   */
  function MakeOwner(props) {
    _classCallCheck(this, MakeOwner);

    return _possibleConstructorReturn(this, (MakeOwner.__proto__ || Object.getPrototypeOf(MakeOwner)).call(this, props));
  }

  _createClass(MakeOwner, [{
    key: '_changeOwner',
    value: function _changeOwner() {
      var ownerUrl = Routes.owner_organization_user_path(this.props.organization, this.props.user);
      var email = this.props.user.email;

      $.ajax({
        type: 'POST',
        url: ownerUrl,
        data: { _method: 'PUT' },
        success: function success() {
          HRB.utils.notify("Great! " + email + " is now the new owner.");
          window.location.reload();
        },
        error: function error(xhr, textStatus, _error) {
          HRB.utils.notify("Sorry, it looks like changing the owner didn't work.", { cssClass: 'error' });
        }
      });
    }
  }, {
    key: '_openModal',
    value: function _openModal(e) {
      e.preventDefault();
      $(ReactDOM.findDOMNode(this)).find('#' + MAKE_OWNER_MODAL_TRIGGER).modal();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { style: { display: "inline" } },
        React.createElement(
          'a',
          { className: 'make-owner', href: '#',
            onClick: this._openModal.bind(this) },
          'Make Owner'
        ),
        React.createElement(_confirm2.default, { id: MAKE_OWNER_MODAL,
          title: 'Change owner',
          message: 'This will change the owner of the organization.',
          onConfirm: this._changeOwner.bind(this),
          confirm_text: 'Yes, change owner' })
      );
    }
  }]);

  return MakeOwner;
}(React.Component);

module.exports = MakeOwner;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(171),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var React = __webpack_require__(0);

var DeleteUser = function (_React$Component) {
  _inherits(DeleteUser, _React$Component);

  /**
   * @params props.organization
   * @params props.user
   */
  function DeleteUser(props) {
    _classCallCheck(this, DeleteUser);

    return _possibleConstructorReturn(this, (DeleteUser.__proto__ || Object.getPrototypeOf(DeleteUser)).call(this, props));
  }

  _createClass(DeleteUser, [{
    key: 'render',
    value: function render() {
      var ownerUrl = Routes.delete_organization_user_path(this.props.organization, this.props.user);
      return React.createElement(
        'a',
        { href: ownerUrl, style: { display: "inline" } },
        'Delete User'
      );
    }
  }]);

  return DeleteUser;
}(React.Component);

module.exports = DeleteUser;

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);
var UpdateBillingSubscriptionModal = __webpack_require__(496);

var Textarea = __webpack_require__(140);

var subscriptionToCancel = null;

var OrganizationPages = function (_React$Component) {
  _inherits(OrganizationPages, _React$Component);

  /**
   * @params props
   * @params props.pages
   * @params props.coupons
   * @params props.types
   * @params props.plans
   */
  function OrganizationPages(props) {
    _classCallCheck(this, OrganizationPages);

    var _this = _possibleConstructorReturn(this, (OrganizationPages.__proto__ || Object.getPrototypeOf(OrganizationPages)).call(this, props));

    _this.modalID = 'update-billing-subscription-modal';
    _this.state = {};
    return _this;
  }

  _createClass(OrganizationPages, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $('.update-page-subscription').on('click', this.openSubscriptionModal.bind(this));
      $('.cancel').on('click', function (event) {
        var type, id;
        if (event.target.dataset.pageId) {
          type = 'page';
          id = event.target.dataset.pageId;
        } else if (event.target.dataset.organizationId) {
          type = 'organization';
          id = event.target.dataset.organizationId;
        }
        subscriptionToCancel = {
          id: id,
          type: type
        };
        _this2.cancel();
      });
      $(ReactDOM.findDOMNode(this)).find('#btn-confirm-cancel-subscription').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.onCancel().then(function () {
          $(ReactDOM.findDOMNode(_this2)).find('#modal-confirmation-cancel-subscription').modal('hide');
          window.location.reload();
        }).catch(function (error) {
          _this2.setState({ cancelError: error });
        });
      });
    }
  }, {
    key: 'cancelSubscription',
    value: function cancelSubscription(id, type, reason) {
      if (!id) alert('#cancelSubscription - You must provide a id to cancel.');
      if (!reason) alert('#cancelSubscription - You must provide a id to cancel.');
      if (type !== 'page' && type !== 'organization') alert('#cancelSubscription - You must provide a valid type.  {page|organization}');
      window.location = Routes[type + '_admin_cancel_billing_subscription_path'](id, { reason: reason });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $('.update-page-subscription').off('click', this.openSubscriptionModal.bind(this));
    }
  }, {
    key: 'openSubscriptionModal',
    value: function openSubscriptionModal(event) {
      var _this3 = this;

      var pageId = void 0;
      if (!!$(event.target).data().pageId) {
        pageId = $(event.target).data().pageId;
      } else {
        pageId = $(event.target).parent('*[data-page-id]').data().pageId;
      }
      this.setState({ page: null }, function () {
        _this3.setState({ page: _this3.props.pages[pageId] }, function () {
          $('.modal#' + _this3.modalID).modal();
        });
      });
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var reason = $(ReactDOM.findDOMNode(_this4.refs.reason)).find('textarea').eq(0).val().trim();
        if (!reason) {
          reject('You must provide a reason for cancelling');
        } else if (!subscriptionToCancel) {
          reject('There was a problem cancelling your subscription');
        } else {
          $.ajax({
            type: 'DELETE',
            url: Routes[subscriptionToCancel.type + '_admin_cancel_billing_subscription_path'](subscriptionToCancel.id, { format: 'json' }),
            data: { reason: reason },
            success: resolve,
            error: function error(errors) {
              reject(JSON.parse(errors.responseText).errors[0]);
            }
          });
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-cancel-subscription').modal();
    }
  }, {
    key: 'cancelError',
    value: function cancelError() {
      if (this.state.cancelError) {
        return React.createElement(
          'span',
          { className: 'error', style: { color: 'indianred' } },
          this.state.cancelError
        );
      }
    }
  }, {
    key: 'subscriptionModal',
    value: function subscriptionModal() {
      if (this.state.page) {
        return React.createElement(UpdateBillingSubscriptionModal, { id: this.modalID, page: this.state.page, plans: this.props.plans, coupons: this.props.coupons, types: this.props.types });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this.subscriptionModal(),
        React.createElement(
          _confirm2.default,
          { id: 'cancel-subscription',
            title: 'Cancel subscription',
            onConfirm: this.onCancel.bind(this),
            confirm_text: 'Yes, cancel it' },
          React.createElement(
            'div',
            { style: { padding: '1rem 2rem' } },
            React.createElement(Textarea, { name: 'reason', ref: 'reason', label: 'Are you sure?  Why?' }),
            this.cancelError()
          )
        )
      );
    }
  }]);

  return OrganizationPages;
}(React.Component);

module.exports = OrganizationPages;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(92);

var _inflection2 = _interopRequireDefault(_inflection);

var _lodash = __webpack_require__(21);

var _lodash2 = _interopRequireDefault(_lodash);

var _select_input = __webpack_require__(74);

var _select_input2 = _interopRequireDefault(_select_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeSelector = function (_React$Component) {
  _inherits(TypeSelector, _React$Component);

  function TypeSelector() {
    _classCallCheck(this, TypeSelector);

    return _possibleConstructorReturn(this, (TypeSelector.__proto__ || Object.getPrototypeOf(TypeSelector)).apply(this, arguments));
  }

  _createClass(TypeSelector, [{
    key: 'types',
    value: function types() {
      var options = Object.keys(this.props.types).map(function (type) {
        return {
          name: _inflection2.default.titleize(_inflection2.default.underscore(type.replace('BillingSubscription', 'Subscription'))),

          value: type
        };
      });

      return _lodash2.default.sortBy(options, 'name');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_select_input2.default, { name: 'billing_subscription[type]',
        options: this.types(),
        label: 'Type',
        defaultValue: this.props.type,
        onChange: this.props.onChange.bind(this),
        helpBlockText: this.props.types[this.props.type].helpBlockText });
    }
  }]);

  return TypeSelector;
}(_react2.default.Component);

module.exports = TypeSelector;

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _select_input = __webpack_require__(74);

var _select_input2 = _interopRequireDefault(_select_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CouponSelector = function (_React$Component) {
  _inherits(CouponSelector, _React$Component);

  function CouponSelector() {
    _classCallCheck(this, CouponSelector);

    return _possibleConstructorReturn(this, (CouponSelector.__proto__ || Object.getPrototypeOf(CouponSelector)).apply(this, arguments));
  }

  _createClass(CouponSelector, [{
    key: 'render',
    value: function render() {
      if (!this.props.types[this.props.type].coupon_enabled) return _react2.default.createElement('div', null);

      var noCoupon = [{ name: 'No discount', value: 'nil' }];

      var couponOptions = this.props.coupons.map(function (coupon) {
        return { name: coupon.display + ' (' + coupon.id + ')', value: coupon.id };
      });

      var coupons = noCoupon.concat(_.sortBy(couponOptions, 'name'));

      return _react2.default.createElement(_select_input2.default, { name: 'billing_subscription[coupon]',
        options: coupons,
        label: 'Coupon',
        defaultValue: this.props.coupon ? this.props.coupon.id : 'nil' });
    }
  }]);

  return CouponSelector;
}(_react2.default.Component);

module.exports = CouponSelector;

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(92);

var _inflection2 = _interopRequireDefault(_inflection);

var _lodash = __webpack_require__(21);

var _lodash2 = _interopRequireDefault(_lodash);

var _select_input = __webpack_require__(74);

var _select_input2 = _interopRequireDefault(_select_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlanSelector = function (_React$Component) {
  _inherits(PlanSelector, _React$Component);

  function PlanSelector() {
    _classCallCheck(this, PlanSelector);

    return _possibleConstructorReturn(this, (PlanSelector.__proto__ || Object.getPrototypeOf(PlanSelector)).apply(this, arguments));
  }

  _createClass(PlanSelector, [{
    key: 'planOption',
    value: function planOption(plan) {
      return { name: _inflection2.default.titleize(plan.name), value: plan.id };
    }
  }, {
    key: 'plans',
    value: function plans() {
      return _lodash2.default.sortBy(this.props.plans.map(this.planOption), 'name');
    }
  }, {
    key: 'render',
    value: function render() {
      // If the current type isn't plan enabled, we'll default to the available business plan
      var businessPlan = _lodash2.default.find(this.props.plans, { name: 'business' });
      var planOptions = this.props.types[this.props.type].plan_enabled ? this.plans() : [this.planOption(businessPlan)];
      return _react2.default.createElement(_select_input2.default, { name: 'billing_subscription[plan_id]',
        id: 'plan_id',
        options: planOptions,
        defaultValue: this.props.plan.id,
        label: 'Plan',
        onChange: this.props.onChange
      });
    }
  }]);

  return PlanSelector;
}(_react2.default.Component);

module.exports = PlanSelector;

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var _ = __webpack_require__(21);
var ItemSelector = __webpack_require__(110);
var Label = __webpack_require__(959);

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  /**
   * This is a composition form that displays the ItemSelectors and subscriber checkbox for PageAccessUser creation
   * and update. It controls the logic around showing and hiding the different ItemSelectors and the subscribe
   * checkbox.
   *
   * @param {object} props
   * @param {string} props.group.items - A collection of pag items to display.  Minimum required field is `name`
   * @param {string} props.group.preselectedItemIds - A collection of preselected group item ids
   * @param {string} props.group.hiddenFieldName
   * @param {string} props.group.hiddenFieldId
   * @param {string} props.component.items - A collection of component items to display.  Minimum required field is `name`
   * @param {string} props.component.preselectedItemIds - A collection of preselected component item ids
   * @param {string} props.component.hiddenFieldName
   * @param {string} props.component.hiddenFieldId
   * @param {string} props.metric.items - A collection of metric items to display.  Minimum required field is `name`
   * @param {string} props.metric.preselectedItemIds - A collection of preselected metric item ids
   * @param {string} props.metric.hiddenFieldName
   * @param {string} props.metric.hiddenFieldId
   * @param {string} props.subscribe.include - will show the subscribe checkbox if true. We only show that checkbox
   *                                           when a new PageAccessUser is being created
   */
  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.state = {
      subscribeShow: false,
      componentShow: _this.props.group.preselectedItemIds.length == 0,
      metricShow: _this.props.group.preselectedItemIds.length == 0
    };
    return _this;
  }

  _createClass(Form, [{
    key: '_handlePageAccessGroupOnToggle',
    value: function _handlePageAccessGroupOnToggle(items) {
      // We don't show the component or metrics selectors if a user has selected a group in the UI
      var pageAccessGroups = _.filter(items, function (item) {
        return !!item.selected;
      });
      if (pageAccessGroups.length == 0) {
        // Show the components and metrics ItemSelectors
        this.setState({ componentShow: true });
        this.setState({ metricShow: true });
        // Don't show the subscribe checkbox, since no groups are selected the component selections will control the hide/show for that
        this.setState({ subscribeShow: false });
      } else {
        // Since at least one PAG is selected we hide the components and metrics ItemsSelectors
        this.setState({ componentShow: false });
        this.setState({ metricShow: false });

        // Check to see if we need to be showing the subscribe checkbox because of the PAG selections
        // We only show the subscribe checkbox if a selected PAG has associated components
        var pageAccessGroup = _.find(pageAccessGroups, function (pageAccessGroup) {
          return pageAccessGroup.component_ids.length > 0;
        });
        if (pageAccessGroup != null) {
          // Show the subscription checkbox
          this.setState({ subscribeShow: true });
        } else {
          // Hide the subscription checkbox
          this.setState({ subscribeShow: false });
        }
      }
    }
  }, {
    key: '_handleComponentOnToggle',
    value: function _handleComponentOnToggle(items) {
      // We want to show the subscribe checkbox if the user has selected any of the components in the UI
      var comps = _.filter(items, function (item) {
        return !!item.selected;
      });
      if (comps.length == 0) {
        this.setState({ subscribeShow: false });
      } else {
        this.setState({ subscribeShow: true });
      }
    }
  }, {
    key: '_pageAccessGroups',
    value: function _pageAccessGroups() {
      if (this.props.group.items.length > 0) {
        return React.createElement(
          'div',
          null,
          React.createElement(Label, {
            text: 'Associated Groups',
            tooltipText: 'Add the relevant page access groups that this user should be associated with' }),
          React.createElement(ItemSelector, {
            className: 'inline',
            items: this.props.group.items,
            preselectedItemIds: this.props.group.preselectedItemIds,
            hiddenFieldName: this.props.group.hiddenFieldName,
            onToggle: this._handlePageAccessGroupOnToggle.bind(this),
            hiddenFieldId: this.props.group.hiddenFieldId })
        );
      }
    }
  }, {
    key: '_components',
    value: function _components() {
      if (this.props.component.items.length > 0 && this.state.componentShow) {
        return React.createElement(
          'div',
          null,
          React.createElement(Label, {
            text: 'Associated Components',
            tooltipText: 'Add the relevant components that this user should be associated with' }),
          React.createElement(ItemSelector, {
            className: 'inline',
            items: this.props.component.items,
            preselectedItemIds: this.props.component.preselectedItemIds,
            hiddenFieldName: this.props.component.hiddenFieldName,
            onToggle: this._handleComponentOnToggle.bind(this),
            hiddenFieldId: this.props.component.hiddenFieldId })
        );
      }
    }
  }, {
    key: '_subscribe',
    value: function _subscribe() {
      if (this.props.subscribe.include && this.state.subscribeShow) {
        return React.createElement(
          'div',
          { className: 'control-group', 'data-js-hook': 'subscription-ui' },
          React.createElement(
            'label',
            null,
            'Subscribe To Notifications'
          ),
          React.createElement(
            'div',
            { className: 'controls' },
            React.createElement(
              'label',
              { className: 'checkbox' },
              'Also subscribe this user to the components they have access to ',
              React.createElement('input', { id: 'page_access_user_subscribe_to_components', name: 'page_access_user[subscribe_to_components]', type: 'checkbox', value: '1' })
            ),
            React.createElement(
              'div',
              { className: 'help-block' },
              'User will ',
              React.createElement(
                'strong',
                null,
                'not'
              ),
              ' receive a confirmation email for the subscription.'
            )
          ),
          React.createElement('br', null)
        );
      }
    }
  }, {
    key: '_metrics',
    value: function _metrics() {
      if (this.props.metric.items.length > 0 && this.state.metricShow) {
        return React.createElement(
          'div',
          null,
          React.createElement(Label, {
            text: 'Associated Metrics',
            tooltipText: 'Add the relevant metrics that this user should be associated with' }),
          React.createElement(ItemSelector, {
            className: 'inline',
            items: this.props.metric.items,
            preselectedItemIds: this.props.metric.preselectedItemIds,
            hiddenFieldName: this.props.metric.hiddenFieldName,
            hiddenFieldId: this.props.metric.hiddenFieldId })
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this._pageAccessGroups(),
        this._components(),
        this._metrics(),
        this._subscribe()
      );
    }
  }]);

  return Form;
}(React.Component);

module.exports = Form;

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

/**
 * A simple component that will render a label that can include a Statuspage style tooltip with a help icon.
 *
 **/

var Label = function (_React$Component) {
  _inherits(Label, _React$Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(this.refs.tooltip).tooltip();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(this.refs.tooltip).tooltip("destroy");
    }
  }, {
    key: "_tooltip",
    value: function _tooltip() {
      if (this.props.tooltipText) {
        return React.createElement(
          "a",
          { href: "#", ref: "tooltip", className: "tooltip-base", "data-js-hook": "tooltip", "data-original-title": this.props.tooltipText },
          "?"
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "label",
        null,
        this.props.text,
        this._tooltip()
      );
    }
  }]);

  return Label;
}(React.Component);

module.exports = Label;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _server = __webpack_require__(172);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ESSearchField = __webpack_require__(237);
var inflect = __webpack_require__(92).inflect;

var PageAccess = __webpack_require__(961);

var PageAccessSearchField = function (_React$Component) {
  _inherits(PageAccessSearchField, _React$Component);

  function PageAccessSearchField() {
    _classCallCheck(this, PageAccessSearchField);

    return _possibleConstructorReturn(this, (PageAccessSearchField.__proto__ || Object.getPrototypeOf(PageAccessSearchField)).apply(this, arguments));
  }

  _createClass(PageAccessSearchField, [{
    key: '_template',

    // Get HTML string for how a typeahead item should be rendered
    value: function _template(suggestion) {
      var view = React.createElement(PageAccessTypeaheadView, { suggestion: suggestion });
      return _server2.default.renderToString(view);
    }
  }, {
    key: 'render',
    value: function render() {
      var searchRoute = PageAccess.searchRoute({ page_id: this.props.page.id });
      function mapResultToUiRoute(suggestion) {
        var url = suggestion.isUser() ? Routes.edit_page_page_access_user_url : Routes.edit_page_page_access_group_url;
        return url(this.props.page, suggestion.id, { domain: null, subdomain: null });
      }
      return React.createElement(ESSearchField, { queryUrl: searchRoute + '?limit=10&q=%QUERY',
        pluralizedResultName: "incidents",
        loadResults: PageAccess.search,
        mapResultToUiUrl: mapResultToUiRoute.bind(this),
        template: this._template.bind(this)
      });
    }
  }]);

  return PageAccessSearchField;
}(React.Component);

var PageAccessTypeaheadView = function (_React$Component2) {
  _inherits(PageAccessTypeaheadView, _React$Component2);

  function PageAccessTypeaheadView() {
    _classCallCheck(this, PageAccessTypeaheadView);

    return _possibleConstructorReturn(this, (PageAccessTypeaheadView.__proto__ || Object.getPrototypeOf(PageAccessTypeaheadView)).apply(this, arguments));
  }

  _createClass(PageAccessTypeaheadView, [{
    key: '_determineType',
    value: function _determineType() {
      var suggestion = this.props.suggestion;

      if (suggestion.isUser()) {
        return {
          iconClass: 'fa-user',
          matchValue: suggestion.email
        };
      } else {
        return {
          iconClass: 'fa-users',
          matchValue: suggestion.name
        };
      }
    }
  }, {
    key: '_titleText',
    value: function _titleText(displayWords) {
      if (this._isNameHighlighted()) {
        var _extractData2 = this._extractData('name'),
            highlightedWords = _extractData2.highlightedWords,
            tagClasses = _extractData2.tagClasses;

        displayWords = this.props.suggestion.name.split(' ').map(function (word, index) {
          if (highlightedWords.indexOf(word.toLowerCase().replace(/[!?\.,]/, '')) >= 0) {
            return React.createElement(
              'strong',
              { className: tagClasses, key: index },
              ' ',
              word,
              ' '
            );
          }
          return React.createElement(
            'span',
            { key: index },
            ' ',
            word,
            ' '
          );
        });
      } else if (this.props.suggestion.isUser()) {
        return React.createElement(
          'span',
          { className: 'name' },
          React.createElement(
            'strong',
            { className: 'es-highlight' },
            this.props.suggestion.email
          )
        );
      }
      return React.createElement(
        'span',
        { className: 'name' },
        displayWords
      );
    }
  }, {
    key: '_extractData',
    value: function _extractData(highlightedField) {
      var text = this.props.suggestion.highlight[highlightedField];
      var highlightItems = $('<span>' + text + '</span>').find('strong');
      var tagClasses = $(highlightItems[0]).attr('class');
      var highlightedWords = _.map(highlightItems, function (t) {
        return $(t).text().toLowerCase();
      });
      return { highlightedWords: highlightedWords, tagClasses: tagClasses };
    }
  }, {
    key: '_isNameHighlighted',
    value: function _isNameHighlighted() {
      return this._checkFieldHighlight('name');
    }
  }, {
    key: '_checkFieldHighlight',
    value: function _checkFieldHighlight(property) {
      return this.props.suggestion.highlight && this.props.suggestion.highlight.hasOwnProperty(property);
    }
  }, {
    key: '_humanizedMetadata',
    value: function _humanizedMetadata(suggestion) {
      if (suggestion.group) {
        return 'Belongs to ' + suggestion.group;
      }
      var list = [];
      _.each(['component', 'metric'], function (field) {
        if (suggestion[field + 's_list'] === undefined) return;
        var count = suggestion[field + 's_list'].length;
        if (count > 0) {
          list.push(count + ' ' + inflect(field, count));
        }
      });
      if (list.length > 0) {
        return 'Has access to ' + list.join(' and ');
      } else {
        return 'Has no access to any components or metrics';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var suggestion = this.props.suggestion;
      var suggestionData = this._determineType();

      return React.createElement(
        'div',
        { className: 'item search-result es-results' },
        React.createElement(
          'div',
          { className: 'icon-container' },
          React.createElement('i', { className: 'fa ' + suggestionData.iconClass })
        ),
        React.createElement(
          'div',
          { className: 'result-text-container' },
          this._titleText(suggestionData.matchValue),
          React.createElement(
            'div',
            null,
            React.createElement(
              'span',
              { className: 'context' },
              this._humanizedMetadata(suggestion)
            )
          )
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return PageAccessTypeaheadView;
}(React.Component);

module.exports = PageAccessSearchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base = __webpack_require__(72);
var request = __webpack_require__(73);

var PageAccess = function (_Base) {
  _inherits(PageAccess, _Base);

  function PageAccess(attributes) {
    _classCallCheck(this, PageAccess);

    return _possibleConstructorReturn(this, (PageAccess.__proto__ || Object.getPrototypeOf(PageAccess)).call(this, attributes));
  }

  _createClass(PageAccess, [{
    key: 'isUser',
    value: function isUser() {
      return !!this.email;
    }
  }], [{
    key: 'searchRoute',
    value: function searchRoute(options) {
      if (!options.page_id) throw new Error('You must provide a page_id');
      return Routes.access_control_search_page_url({ id: options.page_id }, { domain: null, subdomain: null });
    }
  }, {
    key: 'search',
    value: function search(queryOptions) {
      var url = void 0;
      if (queryOptions.url) {
        url = queryOptions.url;
      } else {
        url = PageAccess.searchRoute({ page_id: queryOptions.page_id });
      }

      return request.get({
        url: url,
        data: { q: queryOptions.query }
      }).then(function (response) {
        var results = response;
        return results.map(function (result) {
          var pa = new PageAccess(result);
          return pa;
        });
      });
    }
  }]);

  return PageAccess;
}(Base);

module.exports = PageAccess;

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(92);

var _inflection2 = _interopRequireDefault(_inflection);

var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

var _textarea = __webpack_require__(140);

var _textarea2 = _interopRequireDefault(_textarea);

var _update_billing_subscription_modal = __webpack_require__(496);

var _update_billing_subscription_modal2 = _interopRequireDefault(_update_billing_subscription_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactDOM = __webpack_require__(16);

var Subscription = function (_React$Component) {
  _inherits(Subscription, _React$Component);

  /**
   * General subscription management and updating for pages
   * @params props
   * @params props.page
   * @params props.coupons
   * @params props.plans
   * @params props.types
   */
  function Subscription(props) {
    _classCallCheck(this, Subscription);

    var _this = _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).call(this, props));

    _this.state = { cancelError: null };
    return _this;
  }

  _createClass(Subscription, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $(ReactDOM.findDOMNode(this)).find('#btn-confirm-cancel-subscription').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.onCancel().then(function () {
          $(ReactDOM.findDOMNode(_this2)).find('#modal-confirmation-cancel-subscription').modal('hide');
          window.location.reload();
        }).catch(function (error) {
          _this2.setState({ cancelError: error });
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-cancel-subscription').modal();
    }
  }, {
    key: 'update',
    value: function update() {
      $(ReactDOM.findDOMNode(this)).find('#sub-' + this.props.page.billing_subscription.id).modal();
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var reason = $('textarea[name="reason"]').val().trim();
        if (!reason) {
          reject('You must provide a reason for cancelling');
        } else {
          $.ajax({
            type: 'DELETE',
            url: Routes.page_admin_cancel_billing_subscription_path(_this3.props.page.id, { format: 'json' }),
            data: { reason: reason },
            success: resolve,
            error: function error(errors) {
              reject(JSON.parse(errors.responseText).errors[0]);
            }
          });
        }
      });
    }
  }, {
    key: 'cancelError',
    value: function cancelError() {
      if (this.state.cancelError) {
        return _react2.default.createElement(
          'span',
          { className: 'error', style: { color: 'indianred' } },
          this.state.cancelError
        );
      }
    }
  }, {
    key: 'cancelElement',
    value: function cancelElement() {
      if (this.props.cancelable && !this.props.page.billing_subscription.canceled) {
        return _react2.default.createElement(
          'a',
          { href: '#', onClick: this.cancel.bind(this) },
          _react2.default.createElement(
            'small',
            null,
            'cancel'
          )
        );
      } else {
        return _react2.default.createElement(
          'span',
          { style: { color: '#EFEFEF', cursor: 'default' } },
          '\u263A'
        );
      }
    }
  }, {
    key: 'canceled',
    value: function canceled() {
      if (this.props.page.billing_subscription.canceled) {
        return _react2.default.createElement(
          'small',
          null,
          ' (canceled)'
        );
      }
    }
  }, {
    key: 'quantity',
    value: function quantity() {
      if (this.props.page.billing_subscription.quantity > 1) {
        return _react2.default.createElement(
          'span',
          null,
          ' x ',
          this.props.page.billing_subscription.quantity
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var subscription = this.props.page.billing_subscription;
      var coupon = _.find(this.props.coupons, { id: subscription.coupon });
      return _react2.default.createElement(
        'div',
        { className: 'section row overview' },
        _react2.default.createElement('hr', { className: 'span12' }),
        _react2.default.createElement(
          'div',
          { className: 'header span3' },
          'Subscription'
        ),
        _react2.default.createElement(
          'div',
          { className: 'span9' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Type'
              ),
              subscription.type.replace('BillingSubscription', ''),
              this.canceled()
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Plan'
              ),
              _inflection2.default.titleize(subscription.plan_name),
              ' ',
              this.quantity()
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Discount'
              ),
              _inflection2.default.titleize(coupon ? coupon.display : 'None')
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Note'
              ),
              _inflection2.default.titleize(subscription.note || 'None')
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '#', onClick: this.update.bind(this) },
                  'Update ',
                  _react2.default.createElement('i', { className: 'fa fa-subway' })
                )
              ),
              this.cancelElement()
            )
          )
        ),
        _react2.default.createElement(_update_billing_subscription_modal2.default, {
          types: this.props.types,
          plans: this.props.plans,
          coupons: this.props.coupons,
          page: this.props.page,
          id: 'sub-' + this.props.page.billing_subscription.id }),
        _react2.default.createElement(
          _confirm2.default,
          { id: 'cancel-subscription',
            title: 'Cancel subscription',
            onConfirm: this.onCancel.bind(this),
            confirm_text: 'Yes, cancel it' },
          _react2.default.createElement(
            'div',
            { style: { padding: '1rem 2rem' } },
            _react2.default.createElement(_textarea2.default, { name: 'reason', label: 'Are you sure?  Why?' }),
            this.cancelError()
          )
        )
      );
    }
  }]);

  return Subscription;
}(_react2.default.Component);

module.exports = Subscription;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _tab_group = __webpack_require__(964);

var _tab_group2 = _interopRequireDefault(_tab_group);

var _tab_header = __webpack_require__(500);

var _tab_header2 = _interopRequireDefault(_tab_header);

var _tab_headers = __webpack_require__(499);

var _tab_headers2 = _interopRequireDefault(_tab_headers);

var _tab_panel = __webpack_require__(498);

var _tab_panel2 = _interopRequireDefault(_tab_panel);

var _tab_panels = __webpack_require__(497);

var _tab_panels2 = _interopRequireDefault(_tab_panels);

var _notifications = __webpack_require__(256);

var _notifications2 = _interopRequireDefault(_notifications);

var _subscriber_counts = __webpack_require__(965);

var _subscriber_counts2 = _interopRequireDefault(_subscriber_counts);

var _notifications_subscriber_type_manager = __webpack_require__(966);

var _notifications_subscriber_type_manager2 = _interopRequireDefault(_notifications_subscriber_type_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  The interface to browse and search lists of email, sms, and web subscribers.
 */
var NotificationsSubscriberManager = function (_Component) {
  _inherits(NotificationsSubscriberManager, _Component);

  function NotificationsSubscriberManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationsSubscriberManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsSubscriberManager.__proto__ || Object.getPrototypeOf(NotificationsSubscriberManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      updatedAt: (0, _moment2.default)().format()
    }, _this._touch = function () {
      _this.setState({ updatedAt: (0, _moment2.default)().format() });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationsSubscriberManager, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var beginningOfPastMonthTimestamp = (0, _moment2.default)().subtract(1, 'month').startOf('day').format();
      return (
        // These components wrap network requests, allowing us to leverage the prop system to only make network requests when the parameters change
        _react2.default.createElement(
          _subscriber_counts2.default,
          { pageCode: this.props.pageCode, updatedAt: this.state.updatedAt },
          function (allTimeHistogram) {
            return (

              // Note that in spite of this being nested, its network request is independent of the results of the outer SubscriberCounts call.
              _react2.default.createElement(
                _subscriber_counts2.default,
                {
                  pageCode: _this2.props.pageCode,
                  since: beginningOfPastMonthTimestamp,
                  updatedAt: _this2.state.updatedAt },
                function (thisMonthHistogram) {
                  return _react2.default.createElement(
                    _tab_group2.default,
                    { 'default': 'email',
                      onChange: function onChange(deliveryType) {
                        return analytics.track('Notifications Page - Clicked Tab', { deliveryType: deliveryType, source: 'Notifications Page' });
                      } },
                    _react2.default.createElement(
                      _tab_headers2.default,
                      null,
                      _notifications2.default.NOTIFICATION_TYPES.map(function (type) {
                        var countText = allTimeHistogram[type] ? ' (' + allTimeHistogram[type].total + ')' : '';
                        var label = '' + _notifications2.default.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[type] + countText;
                        return _react2.default.createElement(
                          _tab_header2.default,
                          { key: type, name: type, className: (0, _classnames2.default)(_this2.props.enabledNotificationTypes[type] ? null : 'disabled') },
                          label
                        );
                      })
                    ),
                    _react2.default.createElement(
                      _tab_panels2.default,
                      null,
                      _notifications2.default.NOTIFICATION_TYPES.map(function (type) {
                        var enabled = _this2.props.enabledNotificationTypes[type];
                        var requiresAdvancedNotifications = _this2.props.requiresAdvancedNotifications[type];
                        var displayUpgradeForNotificationTypeMessage = !enabled && requiresAdvancedNotifications;
                        var typeTitle = _notifications2.default.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[type];
                        var typeNoun = _notifications2.default.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[type];
                        var settingsModalLink = _react2.default.createElement(
                          'a',
                          {
                            href: '#modal-settings',
                            'data-toggle': 'modal',
                            onClick: function onClick() {
                              return analytics.track('Notifications Page - Settings Modal Clicked', { source: 'Notifications Page' });
                            } },
                          'reactivate ',
                          typeNoun,
                          ' notifications now'
                        );
                        var disabledAlertBox = null;
                        if (displayUpgradeForNotificationTypeMessage) {
                          disabledAlertBox = _react2.default.createElement(
                            'div',
                            { className: 'disable-notification-type-warning' },
                            _react2.default.createElement(
                              'div',
                              { className: 'header' },
                              typeTitle,
                              ' notifications are not available for your plan.'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'body' },
                              'To deliver notification through ',
                              typeNoun,
                              ', upgrade your plan.'
                            )
                          );
                        } else if (!enabled) {
                          disabledAlertBox = _react2.default.createElement(
                            'div',
                            { className: 'disable-notification-type-warning' },
                            _react2.default.createElement(
                              'div',
                              { className: 'header' },
                              typeTitle,
                              ' notifications are disabled.'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'body' },
                              'To deliver notification through ',
                              typeNoun,
                              ', ',
                              settingsModalLink,
                              '.'
                            )
                          );
                        }
                        return _react2.default.createElement(
                          _tab_panel2.default,
                          { 'for': type, key: type },
                          disabledAlertBox,
                          _react2.default.createElement(_notifications_subscriber_type_manager2.default, {
                            allTimeHistogram: allTimeHistogram,
                            thisMonthHistogram: thisMonthHistogram,
                            pageCode: _this2.props.pageCode,
                            limit: _this2.props.limit,
                            type: type,
                            updatedAt: _this2.state.updatedAt,
                            touch: _this2._touch })
                        );
                      })
                    )
                  );
                }
              )
            );
          }
        )
      );
    }
  }]);

  return NotificationsSubscriberManager;
}(_react.Component);

NotificationsSubscriberManager.propTypes = {
  pageCode: _propTypes2.default.string.isRequired, // The code of the page whose subscribers to list.
  limit: _propTypes2.default.number.isRequired,
  enabledNotificationTypes: _propTypes2.default.shape({
    email: _propTypes2.default.bool.isRequired,
    sms: _propTypes2.default.bool.isRequired,
    webhook: _propTypes2.default.bool.isRequired
  }).isRequired,
  requiresAdvancedNotifications: _propTypes2.default.shape({
    email: _propTypes2.default.bool.isRequired,
    sms: _propTypes2.default.bool.isRequired,
    webhook: _propTypes2.default.bool.isRequired
  }).isRequired
};
exports.default = NotificationsSubscriberManager;


module.exports = NotificationsSubscriberManager;

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _tab_panels = __webpack_require__(497);

var _tab_panels2 = _interopRequireDefault(_tab_panels);

var _tab_headers = __webpack_require__(499);

var _tab_headers2 = _interopRequireDefault(_tab_headers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TabGroup: A tab widget matching views with tabs.
//
// TabGroup is designed to use React declarative style in a more idiomatic way than TabNavigationBar,
// our other tab widget, and may eventually replace it.
//
// Usage:
//
//   <TabGroup default="first">
//     <TabHeaders>
//       <TabHeader name="first">First Tab</TabHeader>
//       <TabHeader name="second">Second Tab</TabHeader>
//       <TabHeader name="third">Third Tab</TabHeader>
//     </TabHeaders>
//     <TabPanels>
//       <TabPanel for="first"><div>I am the first tab content.</div></TabPanel>
//       <TabPanel for="second"><div>I am the second tab content.</div></TabPanel>
//       <TabPanel for="third"><div>I am the third tab content.</div></TabPanel>
//     </TabPanels>
//   </TabGroup>

var TabGroup = function (_React$Component) {
  _inherits(TabGroup, _React$Component);

  function TabGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TabGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabGroup.__proto__ || Object.getPrototypeOf(TabGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeName: _this.props.default
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = _react2.default.Children.map(this.props.children, function (child) {
        if (child.type === _tab_panels2.default) {
          return _react2.default.cloneElement(child, {
            activeName: _this2.state.activeName
          });
        }
        if (child.type === _tab_headers2.default) {
          return _react2.default.cloneElement(child, {
            activeName: _this2.state.activeName,
            onActivate: function onActivate(activeName) {
              _this2.setState({ activeName: activeName });
              _this2.props.onChange(activeName);
            }
          });
        }
        return child;
      });

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('tab-group', this.props.className) },
        children
      );
    }
  }]);

  return TabGroup;
}(_react2.default.Component);

TabGroup.propTypes = {
  // Index of the active TabHeader.
  default: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.arrayOf(_propTypes2.default.shape({ type: _propTypes2.default.oneOf([_tab_headers2.default, _tab_panels2.default]) })).isRequired,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
TabGroup.defaultProps = {
  className: '',
  onChange: function onChange(_) {}
};
exports.default = TabGroup;

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cpt_alert_box = __webpack_require__(501);

var _cpt_alert_box2 = _interopRequireDefault(_cpt_alert_box);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriber = __webpack_require__(113);

var _subscriber2 = _interopRequireDefault(_subscriber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriberCounts = function (_React$Component) {
  _inherits(SubscriberCounts, _React$Component);

  function SubscriberCounts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubscriberCounts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscriberCounts.__proto__ || Object.getPrototypeOf(SubscriberCounts)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      request: null, // expected type of PropTypes.shape({pageCode: PropTypes.string, since: PropTypes.string })
      error: null, // expected type of PropTypes.string
      histogram: {}
    }, _this.fetchCounts = function (props) {
      var request = _this.props.since === null ? { pageCode: props.pageCode } : { pageCode: props.pageCode, since: props.since };
      _subscriber2.default.getHistogramByState(request).then(function (histogram) {
        if (_this.mounted) {
          _this.setState(function (prevState) {
            // Only update the state if the request in `state` is the request on which this function closes.
            if (prevState.request === request) {
              return { histogram: histogram };
            }
            return {};
          });
        }
      }).catch(function () {
        if (_this.mounted) {
          _this.setState(function (prevState) {
            // Same here: only update state if this request was the last request requested.
            if (prevState.request === request) {
              return { error: 'Failed to load subscriber counts. Please try again in a few minutes.', request: null };
            }
            return {};
          });
        }
      });

      // Set the error and request here to mark which request was last requested by the user.
      _this.setState({
        error: null,
        request: request
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubscriberCounts, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.mounted = true;
      this.fetchCounts(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.pageCode !== props.pageCode || this.props.since !== props.since || this.props.updatedAt !== props.updatedAt) {
        this.fetchCounts(props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // make sure we don't try to call setState on an unmounted component
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.error) {
        return _react2.default.createElement(_cpt_alert_box2.default, {
          type: 'error',
          header: 'An error occurred while trying to fulfill your request.',
          body: this.state.error });
      }
      return this.props.children(this.state.histogram);
    }
  }]);

  return SubscriberCounts;
}(_react2.default.Component);

SubscriberCounts.propTypes = {
  pageCode: _propTypes2.default.string.isRequired,
  since: _propTypes2.default.string,
  children: _propTypes2.default.func.isRequired,
  updatedAt: _propTypes2.default.string.isRequired
};
SubscriberCounts.defaultProps = {
  since: null
};
exports.default = SubscriberCounts;

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _cpt_alert_box = __webpack_require__(501);

var _cpt_alert_box2 = _interopRequireDefault(_cpt_alert_box);

var _checked_list = __webpack_require__(967);

var _checked_list2 = _interopRequireDefault(_checked_list);

var _notifications = __webpack_require__(256);

var _notifications2 = _interopRequireDefault(_notifications);

var _pagination_control = __webpack_require__(969);

var _pagination_control2 = _interopRequireDefault(_pagination_control);

var _pill = __webpack_require__(502);

var _pill2 = _interopRequireDefault(_pill);

var _pill_group = __webpack_require__(970);

var _pill_group2 = _interopRequireDefault(_pill_group);

var _sortable_list = __webpack_require__(971);

var _types = __webpack_require__(972);

var _notifications_subscriber_row = __webpack_require__(973);

var _notifications_subscriber_row2 = _interopRequireDefault(_notifications_subscriber_row);

var _subscriber_action = __webpack_require__(503);

var _subscriber_action2 = _interopRequireDefault(_subscriber_action);

var _subscriber_query = __webpack_require__(974);

var _subscriber_query2 = _interopRequireDefault(_subscriber_query);

var _inflection = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @constant {Array} The list of subscribers states of which the front-end is aware.
 */
var SUBSCRIBER_STATES = ['active', 'quarantined', 'unconfirmed'];

/**
 *  The interface to browse and search lists of email, sms, and web subscribers.
 */

var NotificationsSubscriberTypeManager = function (_Component) {
  _inherits(NotificationsSubscriberTypeManager, _Component);

  function NotificationsSubscriberTypeManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationsSubscriberTypeManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsSubscriberTypeManager.__proto__ || Object.getPrototypeOf(NotificationsSubscriberTypeManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      subscriberState: 'active',
      sortField: 'primary',
      sortDirection: 'asc',
      total: 0,
      page: 0,
      selection: _checked_list.SelectionState.clear(),
      confirmationModal: null
    }, _this._handleClearSelection = function (shouldTrack) {
      if (shouldTrack) {
        analytics.track('Notifications Page - Clear Selection', {
          source: 'Notifications Page',
          state: _this.state.subscriberState,
          type: _this.props.type
        });
      }
      _this.setState({ selection: _checked_list.SelectionState.clear() });
    }, _this._handleSelectAll = function () {
      analytics.track('Notifications Page - Select All', {
        source: 'Notifications Page',
        state: _this.state.subscriberState,
        type: _this.props.type
      });
      _this.setState({ selection: _checked_list.SelectionState.selectAll() });
    }, _this._removeSubscriber = function (e, subscriberCode, state) {
      e.preventDefault();

      var subscriberCodes = _this.state.selection.toJSON();
      if (Array.isArray(subscriberCode)) {
        subscriberCodes = subscriberCode;
      }

      var message = 'Are you sure you want to remove ' + (subscriberCodes.length === 1 ? 'this subscriber?' : 'these subscribers?');
      var params = {
        subscribers: subscriberCodes,
        type: _this.props.type,
        state: state
      };

      var confirmationModal = _react2.default.createElement(ConfirmModal, {
        id: 'remove-subscriber-' + _this.state.subscriberState,
        confirm_text: 'Confirm Removal',
        message: message,
        title: 'Confirm Remove Subscriber',
        confirmClass: 'style-status-critical',
        onConfirm: function onConfirm() {
          analytics.track('Notifications Page - Subscriber Unsubscribed', {
            source: 'Notifications Page',
            state: _this.state.subscriberState,
            type: _this.props.type,
            count: subscriberCodes === 'all' ? -1 : subscriberCodes.length
          });
          Subscriber.unsubscribeSubscribers(_this.props.pageCode, params).then(function () {
            HRB.utils.notify('Unsubscribe succeeded.');
            _this._handleClearSelection(false);
            _this.props.touch();
            _this.setState({ confirmationModal: null });
          }, function () {
            HRB.utils.notify('Unsubscribe failed.');
          });
        },
        onCancel: function onCancel() {
          return _this.setState({ confirmationModal: null });
        } });

      _this.setState({
        confirmationModal: confirmationModal
      });
    }, _this._reactivateSubscriber = function (e, subscriberCode) {
      e.preventDefault();

      var subscriberCodes = _this.state.selection.toJSON();
      if (Array.isArray(subscriberCode)) {
        subscriberCodes = subscriberCode;
      }

      var message = 'Are you sure you want to reactivate ' + (subscriberCodes.length === 1 ? 'this subscriber?' : 'these subscribers?');

      var confirmationModal = _react2.default.createElement(ConfirmModal, {
        id: 'reactivate-subscriber-' + _this.state.subscriberState,
        confirm_text: 'Confirm Reactivate',
        message: message,
        title: 'Confirm Reactivate Subscriber',
        onConfirm: function onConfirm() {
          analytics.track('Notifications Page - Subscriber Reactivated', {
            source: 'Notifications Page',
            state: _this.state.subscriberState,
            type: _this.props.type,
            count: subscriberCodes === 'all' ? -1 : subscriberCodes.length
          });
          Subscriber.reactivateSubscribers(_this.props.pageCode, { subscribers: subscriberCodes }).then(function () {
            HRB.utils.notify('Reactivate succeeded.');
            _this._handleClearSelection(false);
            _this.props.touch();
            _this.setState({ confirmationModal: null });
          }, function () {
            HRB.utils.notify('Reactivate failed.');
          });
        },
        onCancel: function onCancel() {
          return _this.setState({ confirmationModal: null });
        } });

      _this.setState({
        confirmationModal: confirmationModal
      });
    }, _this._resendConfirmationSubscriber = function (e, subscriberCode) {
      e.preventDefault();

      var subscriberCodes = _this.state.selection.toJSON();
      if (Array.isArray(subscriberCode)) {
        subscriberCodes = subscriberCode;
      }

      var message = 'Are you sure you want to resend a confirmation message to ' + (subscriberCodes.length === 1 ? 'this subscriber?' : 'these subscribers?');

      var successMessage = 'The confirmation email was successfully sent to the ' + (0, _inflection.inflect)('subscriber', subscriberCodes.length);

      var confirmationModal = _react2.default.createElement(ConfirmModal, {
        id: 'resend-confirmation-subscriber-' + _this.state.subscriberState,
        confirm_text: 'Confirm Resend',
        message: message,
        title: 'Confirm Resend Confirmation',
        onConfirm: function onConfirm() {
          Subscriber.resendConfirmationSubscribers(_this.props.pageCode, subscriberCodes).then(function () {
            analytics.track('Notifications Page - Subscriber Confirmation Resent', {
              source: 'Notifications Page',
              state: _this.state.subscriberState, // Should always be 'unconfirmed'.
              type: _this.props.type, // Should always be 'email'.
              count: subscriberCodes === 'all' ? -1 : subscriberCodes.length
            });
            HRB.utils.notify(successMessage);
            _this._handleClearSelection(false);
            _this.setState({ confirmationModal: null });
          }, function () {
            HRB.utils.notify('Resend confirmation failed.');
          });
        },
        onCancel: function onCancel() {
          return _this.setState({ confirmationModal: null });
        } });

      _this.setState({
        confirmationModal: confirmationModal
      });
    }, _this._changedSelectedState = function (state) {
      analytics.track('Notifications Page - Change Subscriber State Filter', {
        source: 'Notifications Page',
        state: state,
        type: _this.props.type
      });
      _this.setState({ subscriberState: state, page: 0, selection: _checked_list.SelectionState.clear() });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationsSubscriberTypeManager, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, oldState) {
      if (this.state.confirmationModal && oldState.confirmationModal !== this.state.confirmationModal) {
        (0, _jquery2.default)('#modal-confirmation-' + this.state.confirmationModal.props.id).modal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Compute the relevant histogram data.
      var allTimeTotal = this.props.allTimeHistogram[this.props.type] && this.props.allTimeHistogram[this.props.type].total;
      var addedThisMonth = this.props.thisMonthHistogram[this.props.type] && this.props.thisMonthHistogram[this.props.type].total;

      // Fetch the total for pagination purposes for this subscriber state.
      var paginationTotal = this.props.allTimeHistogram[this.props.type] && this.props.allTimeHistogram[this.props.type][this.state.subscriberState];

      var emptySubscriberType = allTimeTotal === 0;
      var emptySubscriberTypeInState = paginationTotal === 0;

      // The total label in the upper left of the tab pane.
      var pluralizedSubscribers = (0, _inflection.inflect)('subscriber', allTimeTotal);
      var subscriberCountLabel = allTimeTotal !== undefined && addedThisMonth !== undefined ? _react2.default.createElement(
        'div',
        { className: 'total-and-recent-subscriber-count' },
        'Total ',
        allTimeTotal,
        ' ',
        _notifications2.default.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[this.props.type],
        ' ',
        pluralizedSubscribers,
        ', ',
        addedThisMonth,
        ' added this month.'
      ) : _react2.default.createElement('div', { className: 'total-and-recent-subscriber-count' });

      // Here are the state pills at the top right of the tab pane.
      // Not all types have all states; we should generate them dynamically.
      var activePillCountString = this.props.allTimeHistogram[this.props.type] ? ' (' + this.props.allTimeHistogram[this.props.type].active + ')' : '';
      var unconfirmedPillCountString = this.props.allTimeHistogram[this.props.type] ? ' (' + this.props.allTimeHistogram[this.props.type].unconfirmed + ')' : '';
      var quarantinedPillCountString = this.props.allTimeHistogram[this.props.type] ? ' (' + this.props.allTimeHistogram[this.props.type].quarantined + ')' : '';
      var unconfirmedFilterState = this.props.type === 'email' ? _react2.default.createElement(
        _pill2.default,
        { className: 'red', value: 'unconfirmed' },
        'Unconfirmed',
        unconfirmedPillCountString
      ) : null;

      // Column headers.
      // Though we rely heavily on flex, we give base widths for columns.
      var createdAtHeaderSize = this.state.subscriberState === 'quarantined' ? 'created-at-small' : 'created-at-large';

      // Quarantine is only shown in the "quarantine" state.
      var quarantineHeader = this.state.subscriberState === 'quarantined' ? _react2.default.createElement(
        _sortable_list.SortableListHeader,
        { className: 'quarantined-at', field: 'quarantined_at', key: 'quarantined_at', tooltip: 'When a subscriber has not been reactivated in 90 days of quarantine, they will be automatically unsubscribed.' },
        'Date Quarantined',
        _react2.default.createElement(
          'span',
          { className: 'tooltip-base' },
          '?'
        )
      ) : null;

      var actionsHeaderSize = this.state.subscriberState === 'unconfirmed' ? 'actions-large' : 'actions-small';

      // Links to other subscriber states that are not empty.
      var otherStatesLinks = emptySubscriberTypeInState ? SUBSCRIBER_STATES.filter(function (ss) {
        return ss !== _this2.state.subscriberState && _this2.props.allTimeHistogram[_this2.props.type] && _this2.props.allTimeHistogram[_this2.props.type][ss];
      }).map(function (ss) {
        return _react2.default.createElement(
          'button',
          { type: 'button', className: 'other-subscriber-states-btn', key: ss, onClick: function onClick() {
              return _this2._changedSelectedState(ss);
            } },
          ss
        );
      }) : [];
      var otherStatesMessage = otherStatesLinks.length ? _react2.default.createElement(
        'span',
        null,
        'Check ',
        otherStatesLinks.reduce(function (prev, curr) {
          return [prev, ' or ', curr];
        }),
        ' subscribers.'
      ) : null;

      // These are actions suitable for the header.
      var selectedCount = this.state.selection.allSelected ? paginationTotal : this.state.selection.selectedSet.size;
      var selectedLabel = selectedCount === 0 ? null : _react2.default.createElement(
        'span',
        { className: 'subtle' },
        ' (',
        selectedCount,
        ')'
      );
      var actions = [_react2.default.createElement(
        _subscriber_action2.default,
        {
          className: 'remove',
          key: 'remove',
          onClick: this._removeSubscriber,
          subscriberState: this.state.subscriberState },
        'remove',
        selectedLabel
      )];
      if (this.state.subscriberState === 'quarantined') {
        actions = Array.concat(actions, _react2.default.createElement(
          _subscriber_action2.default,
          {
            className: 'reactivate',
            key: 'reactivate',
            onClick: this._reactivateSubscriber,
            subscriberState: this.state.subscriberState },
          'reactivate',
          selectedLabel
        ));
      }
      if (this.state.subscriberState === 'unconfirmed') {
        actions = Array.concat(actions, _react2.default.createElement(
          _subscriber_action2.default,
          {
            className: 'resend-confirmation',
            key: 'resend-confirmation',
            onClick: this._resendConfirmationSubscriber,
            subscriberState: this.state.subscriberState },
          'resend confirmation',
          selectedLabel
        ));
      }

      return _react2.default.createElement(
        'div',
        { className: 'notifications-subscriber-type-manager' },
        this.state.confirmationModal,
        emptySubscriberType ? null : _react2.default.createElement(
          'div',
          { className: 'pane-heading' },
          subscriberCountLabel,
          _react2.default.createElement(
            _pill_group2.default,
            {
              className: 'pull-right colored-filters',
              onChange: this._changedSelectedState,
              value: this.state.subscriberState },
            _react2.default.createElement(
              _pill2.default,
              { className: 'green', value: 'active' },
              'Active',
              activePillCountString
            ),
            _react2.default.createElement(
              _pill2.default,
              { className: 'red', value: 'quarantined' },
              'Quarantined',
              quarantinedPillCountString
            ),
            unconfirmedFilterState
          )
        ),
        _react2.default.createElement(
          _subscriber_query2.default,
          {
            pageCode: this.props.pageCode,
            limit: this.props.limit,
            page: this.state.page,
            sortField: this.state.sortField,
            sortDirection: this.state.sortDirection,
            subscriberType: this.props.type,
            subscriberState: this.state.subscriberState,
            updatedAt: this.props.updatedAt },
          function (subscribers, loading, error) {
            var subscriberTypeQualifier = emptySubscriberType ? '' : _this2.state.subscriberState;
            var emptyListState = subscribers.length !== 0 ? null : _react2.default.createElement(
              'div',
              { className: 'pane-header' },
              _react2.default.createElement(
                'div',
                { className: 'empty-state' },
                _react2.default.createElement(
                  'div',
                  { className: 'header' },
                  'You currently don\'t have any ',
                  subscriberTypeQualifier,
                  ' ',
                  _notifications2.default.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[_this2.props.type],
                  ' subscribers.'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'body' },
                  _react2.default.createElement(
                    'span',
                    null,
                    otherStatesMessage
                  )
                )
              )
            );

            // Construct the state for displaying any errors that occur inside the query component.
            var errorState = error ? _react2.default.createElement(_cpt_alert_box2.default, {
              type: 'error',
              header: 'An error occurred while trying to fulfill your request.',
              body: error }) : null;

            // Construct the list contents.
            var subscriberRows = subscribers.map(function (subscriber) {
              return _react2.default.createElement(
                _notifications_subscriber_row2.default,
                {
                  subscriber: subscriber,
                  pageCode: _this2.props.pageCode,
                  key: subscriber.id,
                  state: _this2.state.subscriberState,
                  href: '/pages/' + _this2.props.pageCode + '/subscribers/' + subscriber.id },
                _this2.state.selection.isClear() ? actions : null
              );
            });

            // And the headers.
            var headers = null;
            // If nothing is selected, the table header displays as column headers.
            if (_this2.state.selection.isClear()) {
              headers = [_react2.default.createElement(
                _sortable_list.SortableListHeader,
                { className: 'subscriber-title', field: 'primary', key: 'primary' },
                _react2.default.createElement(
                  'span',
                  null,
                  _notifications2.default.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[_this2.props.type],
                  ' Subscribers'
                )
              ), _react2.default.createElement(
                _sortable_list.SortableListHeader,
                {
                  className: (0, _classnames2.default)("created-at", createdAtHeaderSize),
                  field: 'created_at',
                  key: 'created_at' },
                'Date Added'
              ), quarantineHeader, _react2.default.createElement(
                _sortable_list.SortableListHeader,
                {
                  className: (0, _classnames2.default)('actions', actionsHeaderSize, _this2.state.selection.isClear() ? null : 'actions'),
                  key: 'actions' },
                _this2.state.selection.isClear() ? 'Actions' : actions
              )];
            } else {
              // If something is selected, the table header displays information and actions available
              // for the selected subscribers.
              //
              // 'All Are Selected' may be encoded in two different ways:
              // 1) by the symbolic selection state "all"
              // 2) by a list of <page size> selected ids when <page size> === paginationTotal.
              // allChecked is true for both of these cases, otherwise false.
              var allChecked = selectedCount === paginationTotal;
              var selectAllHeader = allChecked ? _react2.default.createElement(
                'div',
                { className: 'select-all-prompt', key: 'select-all-prompt' },
                'All ',
                selectedCount,
                ' subscribers are selected. ',
                _react2.default.createElement(
                  'button',
                  { className: 'link-like', onClick: function onClick() {
                      return _this2._handleClearSelection(true);
                    } },
                  'Clear selection.'
                )
              ) : _react2.default.createElement(
                'div',
                { className: 'select-all-prompt', key: 'select-all-prompt' },
                _react2.default.createElement(
                  'span',
                  null,
                  selectedCount,
                  ' selected. '
                ),
                _react2.default.createElement(
                  'button',
                  { className: 'link-like', onClick: _this2._handleSelectAll },
                  'Select all ',
                  paginationTotal,
                  ' ',
                  _this2.state.subscriberState,
                  ' subscribers.'
                )
              );
              headers = [selectAllHeader, _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)("actions", actionsHeaderSize), key: 'bulk-actions' },
                actions
              )];
            }

            // Render the list itself, specifying selection state, headers, and content.
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _checked_list2.default,
                {
                  selection: _this2.state.selection,
                  onSelect: function onSelect(selection) {
                    analytics.track('Notifications Page - Selected Subscribers', {
                      source: 'Notifications Page',
                      count: selection.getCount(),
                      state: _this2.state.subscriberState,
                      type: _this2.props.type
                    });
                    _this2.setState({ selection: selection });
                  },
                  total: paginationTotal || 0,
                  loading: loading,
                  error: errorState,
                  empty: emptyListState,
                  headers: _react2.default.createElement(
                    _sortable_list.SortableListHeaders,
                    {
                      field: _this2.state.sortField,
                      direction: _this2.state.sortDirection,
                      onClick: function onClick(sortField, sortDirection) {
                        analytics.track('Notifications Page - User Clicked Header', {
                          source: 'Notifications Page',
                          state: _this2.state.subscriberState,
                          type: _this2.props.type,
                          column: sortField,
                          direction: sortDirection
                        });
                        _this2.setState({
                          sortField: sortField,
                          sortDirection: sortDirection,
                          page: 0,
                          selection: _checked_list.SelectionState.clear()
                        });
                      } },
                    headers
                  ) },
                subscriberRows
              )
            );
          }
        ),
        paginationTotal === undefined || paginationTotal <= this.props.limit ? null : _react2.default.createElement(_pagination_control2.default, {
          page: this.state.page + 1,
          limit: this.props.limit,
          total: paginationTotal,
          onChange: function onChange(page) {
            analytics.track('Notifications Page - User Navigated To Page', {
              source: 'Notifications Page',
              state: _this2.state.subscriberState,
              type: _this2.props.type,
              page_number: page
            });
            _this2.setState({ page: page - 1 });
          } })
      );
    }
  }]);

  return NotificationsSubscriberTypeManager;
}(_react.Component);

NotificationsSubscriberTypeManager.propTypes = {
  pageCode: _propTypes2.default.string.isRequired, // The code of the page whose subscribers to list.
  limit: _propTypes2.default.number.isRequired, // The number of subscribers to display per-page.
  type: _propTypes2.default.oneOf(['email', 'sms', 'webhook']).isRequired,
  allTimeHistogram: _propTypes2.default.shape({
    email: _types.Histogram,
    sms: _types.Histogram,
    webhook: _types.Histogram
  }).isRequired,
  thisMonthHistogram: _propTypes2.default.shape({
    email: _types.Histogram,
    sms: _types.Histogram,
    webhook: _types.Histogram
  }).isRequired,
  touch: _propTypes2.default.func, // The function to call to indicate that the server should be re-queried.
  updatedAt: _propTypes2.default.string.isRequired
};
exports.default = NotificationsSubscriberTypeManager;


module.exports = NotificationsSubscriberTypeManager;

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loading = __webpack_require__(343);

var _loading2 = _interopRequireDefault(_loading);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _tri_state_checkbox = __webpack_require__(968);

var _tri_state_checkbox2 = _interopRequireDefault(_tri_state_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionState = exports.SelectionState = function () {
  function SelectionState(allSelected, items) {
    var _this = this;

    _classCallCheck(this, SelectionState);

    this.isChecked = function (item) {
      return _this.allSelected || _this.selectedSet.has(item);
    };

    this.isClear = function () {
      return !_this.allSelected && _this.selectedSet.size === 0;
    };

    this.toJSON = function () {
      return _this.allSelected ? 'all' : [].concat(_toConsumableArray(_this.selectedSet));
    };

    this.getCount = function () {
      return _this.allSelected ? 'all' : _this.selectedSet.size;
    };

    this.selectedSet = new Set(items);
    this.allSelected = allSelected;
  }

  _createClass(SelectionState, null, [{
    key: 'clear',
    value: function clear() {
      return new SelectionState(false, []);
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      return new SelectionState(true, []);
    }
  }, {
    key: 'selectExactly',
    value: function selectExactly(items) {
      return new SelectionState(false, items);
    }
  }]);

  return SelectionState;
}();

/**
 * This component displays a list: headers, content, and a checkbox next to every row. It also
 * implements the logic necessary to select either a subset of the current page, or "all", assuming
 * there are more pages.
 */


var CheckedList = function (_React$Component) {
  _inherits(CheckedList, _React$Component);

  function CheckedList() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, CheckedList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = CheckedList.__proto__ || Object.getPrototypeOf(CheckedList)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      keySet: new Set()
    }, _this2._handleBatchCheckbox = function () {
      var selectedKeySet = void 0;
      if (_this2.props.selection.selectedSet.size === 0 && !_this2.props.selection.allSelected) {
        selectedKeySet = new Set([].concat(_toConsumableArray(_this2.state.keySet)));
      } else {
        selectedKeySet = new Set([]);
      }
      _this2.props.onSelect(SelectionState.selectExactly(selectedKeySet));
    }, _this2._handleAnchorClick = function (e) {
      if (e.target.tagName == "INPUT") {
        // User actually clicked on a checkbox.
        // This is idiosyncratic Firefox behavior.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=62151
        e.preventDefault();
      }
    }, _this2._handleRowCheckbox = function (key) {
      // The setTimeout is a workaround for the Firefox checkbox workaround,
      // which causes React to not render the checkbox that was just clicked.
      // See: https://github.com/facebook/react/issues/3005
      window.setTimeout(function () {
        var selectedKeySet = void 0; // The working set of codes identifying selected rows.
        if (this.props.selection.allSelected) {
          // Visually, the "all" state is identical to all the visible rows selected.
          selectedKeySet = new Set([].concat(_toConsumableArray(this.state.keySet)));
        } else {
          selectedKeySet = new Set([].concat(_toConsumableArray(this.props.selection.selectedSet)));
        }

        // Update the row state itself from the computed visual display.
        if (selectedKeySet.has(key)) {
          selectedKeySet.delete(key);
        } else {
          selectedKeySet.add(key);
        }

        this.props.onSelect(SelectionState.selectExactly(selectedKeySet));
      }.bind(_this2), 0);
    }, _this2._countSelectionSize = function () {
      return _this2.props.selection.allSelected ? Number(_this2.props.total) : _this2.children.length;
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(CheckedList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.children !== this.props.children) {
        this.setState({
          keySet: new Set(props.children.map(function (child) {
            return child.key;
          }))
        });
      }
    }

    // Callback for clicking the batch checkbox.


    // Callback for clicking an individual row.


    // Callback for clicking an individual row checkbox.

  }, {
    key: '_batchCheckboxVisualState',


    /**
     * Helper function to determine visual state of batch checkbox:
     * @returns "unchecked" if no subscribers are selected, "indeterminate" if only some of the visible subscribers are
     *            checked, "checked" if either all the displayed subscribers are checked or "all" subscribers are checked,
     *            and "disabled" if the checkbox does not relate to the contents of the list.
     */
    value: function _batchCheckboxVisualState() {
      if (this.state.error || this.props.children.length === 0) {
        return 'disabled';
      }
      if (this.props.selection.allSelected || this.props.selection.selectedSet.size === this.props.children.length) {
        return 'checked';
      }
      if (this.props.selection.selectedSet.size > 0) {
        return 'indeterminate';
      }
      return 'unchecked';
    }
  }, {
    key: '_renderListContent',


    // Render everything below the header of the list--loading state, error state, empty state, or row display state.
    value: function _renderListContent() {
      var _this3 = this;

      var content = void 0;
      if (this.props.error) {
        content = this.props.error;
      } else if (this.props.empty) {
        content = this.props.empty;
      } else {
        var subscriberElements = _react2.default.Children.map(this.props.children, function (child) {
          return _react2.default.createElement(
            'a',
            {
              className: 'list-content-row',
              key: child.key,
              href: child.props.href ? child.props.href : '',
              onClick: function onClick(e) {
                return _this3._handleAnchorClick(e);
              } },
            _react2.default.createElement(
              'label',
              { className: 'checkbox-wrapper' },
              _react2.default.createElement('input', {
                type: 'checkbox',
                className: 'checked-list-checkbox list-content-row-checkbox',
                'data-list-item-code': child.key,
                onChange: function onChange() {
                  return _this3._handleRowCheckbox(child.key);
                },
                checked: _this3.props.selection.isChecked(child.key) })
            ),
            child
          );
        });
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'table-rows-container' },
            subscriberElements
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'list-content' },
        _react2.default.createElement(_loading2.default, { className: 'loading-overlay', loading: this.props.loading }),
        content
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'checked-table' },
          this.props.empty ? null : _react2.default.createElement(
            'div',
            { className: 'list-header' },
            _react2.default.createElement(
              'label',
              { className: 'checkbox-wrapper' },
              _react2.default.createElement(_tri_state_checkbox2.default, {
                className: 'checked-list-checkbox list-header-checkbox',
                onChange: this._handleBatchCheckbox,
                mode: this._batchCheckboxVisualState() })
            ),
            this.props.headers
          ),
          this._renderListContent()
        )
      );
    }
  }]);

  return CheckedList;
}(_react2.default.Component);

CheckedList.propTypes = {
  // Total number of items, including those on this page.
  // Used to figure out when selecting subscriber not on the page is possible, i.e. "select all"
  // functionality.
  total: _propTypes2.default.number.isRequired,

  // The list content.
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.element]))]).isRequired,

  // Whether or not to display the content, or whether to show a "loading" icon. TODO: Move out of this component.
  loading: _propTypes2.default.bool,

  // The header row.
  headers: _propTypes2.default.element.isRequired,

  // An error to display instead of the list.
  // Populate this field if you e.g. have a connection error while populating the list children.
  error: _propTypes2.default.element,

  // What to display when the list is empty.
  empty: _propTypes2.default.element,

  // A callback when the selection state changes.
  // The sole argument is a SelectionState instance, indicating the new selection state as a
  // result of user input.
  onSelect: _propTypes2.default.func,

  selection: _propTypes2.default.instanceOf(SelectionState).isRequired
};
CheckedList.defaultProps = {
  loading: false,
  error: null,
  empty: null,
  onSelect: function onSelect() {}
};
exports.default = CheckedList;

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TriStateCheckbox = function (_Component) {
  _inherits(TriStateCheckbox, _Component);

  function TriStateCheckbox() {
    _classCallCheck(this, TriStateCheckbox);

    return _possibleConstructorReturn(this, (TriStateCheckbox.__proto__ || Object.getPrototypeOf(TriStateCheckbox)).apply(this, arguments));
  }

  _createClass(TriStateCheckbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updateDOM();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mode !== this.props.mode) {
        this._updateDOM();
      }
    }
  }, {
    key: '_updateDOM',
    value: function _updateDOM() {
      switch (this.props.mode) {
        case 'indeterminate':
          this._checkbox.indeterminate = true;
          this._checkbox.checked = false;
          break;
        case 'checked':
          this._checkbox.indeterminate = false;
          this._checkbox.checked = true;
          break;
        case 'unchecked':
        case 'disabled':
        default:
          this._checkbox.indeterminate = false;
          this._checkbox.checked = false;
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('input', {
        className: this.props.className,
        type: 'checkbox',
        ref: function ref(checkbox) {
          _this2._checkbox = checkbox;
        },
        onChange: this.props.onChange,
        disabled: this.props.mode === 'disabled'
      });
    }
  }]);

  return TriStateCheckbox;
}(_react.Component);

exports.default = TriStateCheckbox;


TriStateCheckbox.defaultProps = {
  onChange: function onChange() {},
  className: ''
};

TriStateCheckbox.propTypes = {
  mode: _propTypes2.default.oneOf(['checked', 'unchecked', 'indeterminate', 'disabled']).isRequired,
  onChange: _propTypes2.default.func, // A callback when the user clicks the checkbox.
  className: _propTypes2.default.string // The className is passed on to the wrapping element.
};

module.exports = TriStateCheckbox;

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationControl = function (_Component) {
  _inherits(PaginationControl, _Component);

  function PaginationControl() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaginationControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationControl.__proto__ || Object.getPrototypeOf(PaginationControl)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      manualEntry: _this.props.page
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaginationControl, [{
    key: 'componentWillReceiveProps',


    // Update the text box if the prop changes.
    value: function componentWillReceiveProps(props) {
      this.setState({ manualEntry: props.page });
    }

    // An accessor for the total number of pages derived from props.

  }, {
    key: 'totalPages',
    value: function totalPages() {
      if (this.props.limit === 0) {
        return 0;
      }
      return Math.ceil(this.props.total / this.props.limit);
    }
  }, {
    key: 'prevButtonEnabled',
    value: function prevButtonEnabled() {
      return this.props.page !== 1;
    }
  }, {
    key: 'nextButtonEnabled',
    value: function nextButtonEnabled() {
      return this.props.page < this.totalPages();
    }

    // This intercepts an 'enter' keypress.
    // If the entered number is a valid page, notify the user of the component the page has changed.
    // If the entered numberis not a valid page, we go to the nearest valid page.
    // if the entered string is not a number, we reset the manual input to the current page.

  }, {
    key: 'handleManualEntryKeypress',
    value: function handleManualEntryKeypress(event) {
      if (event.key === 'Enter') {
        var page = Number(this.state.manualEntry);
        if (Number.isNaN(page)) {
          this.setState({ manualEntry: this.props.page });
        } else {
          if (page > this.totalPages()) {
            page = this.totalPages();
          }
          if (page < 1) {
            page = 1;
          }
          if (page !== this.props.page) {
            this.props.onChange(page);
          } else {
            this.setState({ manualEntry: page });
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'pagination-controls' },
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(['pagination-button', this.prevButtonEnabled() ? 'active' : 'inactive']),
            onClick: this.prevButtonEnabled() ? function () {
              return _this2.props.onChange(_this2.props.page - 1);
            } : null },
          _react2.default.createElement('span', { className: 'fa fa-caret-left', 'aria-hidden': 'true' })
        ),
        '\xA0',
        _react2.default.createElement(
          'div',
          { className: 'manual-entry-label' },
          'Page',
          _react2.default.createElement('input', {
            type: 'text',
            className: 'manual-entry',
            value: this.state.manualEntry,
            onChange: function onChange(event) {
              return _this2.setState({ manualEntry: event.target.value });
            },
            onKeyPress: function onKeyPress(event) {
              return _this2.handleManualEntryKeypress(event);
            } }),
          '/ ',
          this.totalPages()
        ),
        _react2.default.createElement(
          'div',
          { className: 'subscriber-range-label' },
          'Subscriber No. ',
          (this.props.page - 1) * this.props.limit + 1,
          '\u2013',
          Math.min(this.props.page * this.props.limit, this.props.total)
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(['pagination-button', this.nextButtonEnabled() ? 'active' : 'inactive']),
            onClick: this.nextButtonEnabled() ? function () {
              return _this2.props.onChange(_this2.props.page + 1);
            } : null },
          _react2.default.createElement('span', { className: 'fa fa-caret-right', 'aria-hidden': 'true' })
        )
      );
    }
  }]);

  return PaginationControl;
}(_react.Component);

PaginationControl.propTypes = {
  total: _propTypes2.default.number.isRequired,
  page: _propTypes2.default.number.isRequired,
  limit: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func
};
PaginationControl.defaultProps = {
  onChange: function onChange() {}
};
exports.default = PaginationControl;


module.exports = PaginationControl;

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(21);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _pill = __webpack_require__(502);

var _pill2 = _interopRequireDefault(_pill);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A group of pill controls. See PropTypes below class definition for documentation on accepted props.
 */
var PillGroup = function (_Component) {
  _inherits(PillGroup, _Component);

  function PillGroup() {
    _classCallCheck(this, PillGroup);

    return _possibleConstructorReturn(this, (PillGroup.__proto__ || Object.getPrototypeOf(PillGroup)).apply(this, arguments));
  }

  _createClass(PillGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = _lodash2.default.map(this.props.children, function (child, index) {
        return child && child.type === _pill2.default ? _react2.default.cloneElement(child, {
          onClick: function onClick(value) {
            return _this2.props.onChange(value);
          },
          active: child.props.value === _this2.props.value,
          key: index
        }) : child;
      });
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('cpt-pill-group', this.props.className) },
        children
      );
    }
  }]);

  return PillGroup;
}(_react.Component);

PillGroup.propTypes = {
  /** @callback {PillChangedCallback} onChange - called when a pill has been clicked with the clicked value. */
  onChange: _propTypes2.default.func.isRequired,
  /** The value of the pill */
  value: _propTypes2.default.string.isRequired,
  /** The pill definitions themselves, and any other dom element. */
  children: _propTypes2.default.arrayOf(_propTypes2.default.element).isRequired,
  className: _propTypes2.default.string
};
PillGroup.defaultProps = {
  className: ''
};
exports.default = PillGroup;


module.exports = PillGroup;

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableListHeaders = exports.SortableListHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CARET_TYPE_BY_DIRECTION = {
  none: 'fa-unsorted',
  asc: 'fa-sort-asc',
  desc: 'fa-sort-desc'
};

// This is a single column header.
// It is sortable/clickable if you specify a 'field' parameter on the header.
// If not, it's just text.
// If `field` is specified, `direction` will specify the icon to the right of the header.

var SortableListHeader = exports.SortableListHeader = function (_Component) {
  _inherits(SortableListHeader, _Component);

  function SortableListHeader() {
    _classCallCheck(this, SortableListHeader);

    return _possibleConstructorReturn(this, (SortableListHeader.__proto__ || Object.getPrototypeOf(SortableListHeader)).apply(this, arguments));
  }

  _createClass(SortableListHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.wrapperDiv && this.props.tooltip) {
        (0, _jquery2.default)(this.wrapperDiv).tooltip();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.wrapperDiv && this.props.tooltip) {
        (0, _jquery2.default)(this.wrapperDiv).tooltip();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sortCaretFaClass = this.props.field ? CARET_TYPE_BY_DIRECTION[this.props.direction] : null;
      var sortCaret = sortCaretFaClass ? _react2.default.createElement('span', { className: (0, _classnames2.default)('sort-icon', 'fa', sortCaretFaClass), 'aria-hidden': 'true' }) : null;
      var headerColumnContent = this.props.field ? _react2.default.createElement(
        'button',
        { onClick: function onClick() {
            return _this2.props.onClick(_this2.props.field);
          } },
        this.props.children,
        sortCaret
      ) : _react2.default.createElement(
        'div',
        null,
        this.props.children,
        sortCaret
      );
      var tooltipProps = this.props.tooltip ? {
        'data-toggle': 'tooltip',
        'data-placement': 'bottom',
        'data-js-hook': 'tooltip',
        'data-original-title': this.props.tooltip
      } : {};

      return _react2.default.createElement(
        'div',
        _extends({
          ref: function ref(div) {
            _this2.wrapperDiv = div;
          },
          className: (0, _classnames2.default)('sortable-list-header', this.props.className, this.props.field ? 'sortable' : 'unsortable', this.props.field && this.props.direction !== 'none' ? 'sorting' : 'unsorted')
        }, tooltipProps),
        headerColumnContent
      );
    }
  }]);

  return SortableListHeader;
}(_react.Component);

SortableListHeader.propTypes = {
  className: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['none', 'asc', 'desc']),
  field: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]))]).isRequired,
  tooltip: _propTypes2.default.string
};

SortableListHeader.defaultProps = {
  className: '',
  direction: 'none',
  onClick: function onClick() {},
  field: null,
  tooltip: null
};

var REVERSE_SORT_DIRECTION = {
  asc: 'desc',
  desc: 'asc'
};

var SortableListHeaders = exports.SortableListHeaders = function (_Component2) {
  _inherits(SortableListHeaders, _Component2);

  function SortableListHeaders() {
    _classCallCheck(this, SortableListHeaders);

    return _possibleConstructorReturn(this, (SortableListHeaders.__proto__ || Object.getPrototypeOf(SortableListHeaders)).apply(this, arguments));
  }

  _createClass(SortableListHeaders, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      // We want to add on callbacks to propagate the click callback up.
      // It also tells the header in question what its visual state is.
      var children = _react2.default.Children.map(this.props.children, function (element) {
        if (element && element.type && element.type === SortableListHeader && element.props && element.props.field) {
          if (element.props.field === _this4.props.field) {
            return _react2.default.cloneElement(element, {
              direction: _this4.props.direction,
              onClick: function onClick() {
                return _this4.props.onClick(_this4.props.field, REVERSE_SORT_DIRECTION[_this4.props.direction]);
              }
            });
          }
          return _react2.default.cloneElement(element, {
            direction: 'none',
            onClick: function onClick() {
              return _this4.props.onClick(element.props.field, SortableListHeaders.defaultProps.direction);
            }
          });
        }
        return element;
      });
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('sortable-list-headers', this.props.className) },
        children
      );
    }
  }]);

  return SortableListHeaders;
}(_react.Component);

SortableListHeaders.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.oneOf([null])])),
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func, // passed with (sortField, sortDirection)
  field: _propTypes2.default.string.isRequired,
  direction: _propTypes2.default.oneOf(['none', 'asc', 'desc']).isRequired
};

SortableListHeaders.defaultProps = {
  children: [],
  className: '',
  onClick: function onClick() {},
  direction: 'asc'
};

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Histogram = undefined;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Histogram = _propTypes2.default.shape({
  active: _propTypes2.default.number.isRequired,
  unconfirmed: _propTypes2.default.number.isRequired,
  quarantined: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired
});

var NOTIFICATION_TYPES = ['email', 'sms', 'webhook'];

exports.Histogram = Histogram; // eslint-disable-line import/prefer-default-export

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _notifications = __webpack_require__(256);

var _notifications2 = _interopRequireDefault(_notifications);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _subscriber_action = __webpack_require__(503);

var _subscriber_action2 = _interopRequireDefault(_subscriber_action);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component represents a single row in the notifications subscriber list.
 */
var NotificationsSubscriberRow = function (_React$Component) {
  _inherits(NotificationsSubscriberRow, _React$Component);

  function NotificationsSubscriberRow() {
    _classCallCheck(this, NotificationsSubscriberRow);

    return _possibleConstructorReturn(this, (NotificationsSubscriberRow.__proto__ || Object.getPrototypeOf(NotificationsSubscriberRow)).apply(this, arguments));
  }

  _createClass(NotificationsSubscriberRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var childrenWithBoundCallbacks = _react2.default.Children.map(this.props.children, function (child) {
        if (child && child.type === _subscriber_action2.default) {
          // This onClick is the one for links that *do not* rely on the current selection.
          return _react2.default.cloneElement(child, {
            onClick: function onClick(e) {
              return child.props.onClick(e, [_this2.props.subscriber.id], child.props.subscriberState);
            }
          });
        }
        return child;
      });

      var createdAtColumnSize = this.props.state === 'quarantined' ? 'created-at-small' : 'created-at-large';
      var quarantineColumn = this.props.state === 'quarantined' ? _react2.default.createElement(
        'div',
        { className: 'subscriber-content-column quarantined-at' },
        (0, _moment2.default)(this.props.subscriber.quarantined_at).format('ll'),
        '\xA0/\xA0',
        (0, _moment2.default)(this.props.subscriber.purge_at).format('ll')
      ) : null;
      var actionsColumnSize = this.props.state === 'unconfirmed' ? 'actions-large' : 'actions-small';

      return _react2.default.createElement(
        'div',
        { className: 'subscriber-content-columns' },
        _react2.default.createElement(
          'div',
          { className: 'subscriber-content-column subscriber-title' },
          this.props.subscriber[_notifications2.default.SUBSCRIBER_DISPLAY_FIELD_BY_TYPE[this.props.subscriber.mode]]
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('subscriber-content-column', 'created-at', createdAtColumnSize) },
          (0, _moment2.default)(this.props.subscriber.created_at).format('ll')
        ),
        quarantineColumn,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('subscriber-content-column', 'actions', actionsColumnSize) },
          childrenWithBoundCallbacks
        )
      );
    }
  }]);

  return NotificationsSubscriberRow;
}(_react2.default.Component);

NotificationsSubscriberRow.propTypes = {
  // The expected subscriber shape from the api.
  subscriber: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    created_at: _propTypes2.default.string.isRequired,
    quarantined_at: _propTypes2.default.string,
    purge_at: _propTypes2.default.string,
    mode: _propTypes2.default.oneOf(['email', 'sms', 'webhook']).isRequired,
    email: _propTypes2.default.string,
    endpoint: _propTypes2.default.string,
    phone_number: _propTypes2.default.string
  }).isRequired,
  state: _propTypes2.default.oneOf(['active', 'unconfirmed', 'quarantined']).isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]))]),
  href: _propTypes2.default.string
};
NotificationsSubscriberRow.defaultProps = {
  children: null,
  href: null
};
exports.default = NotificationsSubscriberRow;

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriber = __webpack_require__(113);

var _subscriber2 = _interopRequireDefault(_subscriber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriberQuery = function (_Component) {
  _inherits(SubscriberQuery, _Component);

  function SubscriberQuery() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubscriberQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscriberQuery.__proto__ || Object.getPrototypeOf(SubscriberQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      subscribers: [],
      request: null,
      error: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubscriberQuery, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.mounted = true;
      this._fetchSubscribers(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.pageCode !== this.props.pageCode || props.limit !== this.props.limit || props.updatedAt !== this.props.updatedAt || props.page !== this.props.page || props.sortDirection !== this.props.sortDirection || props.sortField !== this.props.sortField || props.subscriberType !== this.props.subscriberType || props.subscriberState !== this.props.subscriberState) {
        this._fetchSubscribers(props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // make sure we don't try to call setState on an unmounted component
      this.mounted = false;
    }
  }, {
    key: '_fetchSubscribers',
    value: function _fetchSubscribers(propsAtFetchTime) {
      var _this2 = this;

      // Store the request promise to identify THIS instance of fetching subscribers.
      var request = _subscriber2.default.getPage({
        pageCode: propsAtFetchTime.pageCode,
        page: propsAtFetchTime.page,
        limit: propsAtFetchTime.limit,
        sort_direction: propsAtFetchTime.sortDirection,
        sort_field: propsAtFetchTime.sortField,
        type: propsAtFetchTime.subscriberType,
        state: propsAtFetchTime.subscriberState
      }).then(function (subscribers) {
        if (_this2.mounted) {
          _this2.setState(function (prevState) {
            try {
              var newState = {
                subscribers: subscribers,
                request: null,
                error: null
              };

              // Only update the state if the request in `state` is the request on which this function closes.
              if (prevState.request === request) {
                return newState;
              }

              // Otherwise update nothing.
              return {};
            } catch (e) {
              return { error: 'Please try again in a few minutes.', request: null };
            }
          });
        }
      }).catch(function () {
        if (_this2.mounted) {
          _this2.setState(function (prevState) {
            // Same here: only update state if this request was the last request requested.
            if (prevState.request === request) {
              return { error: 'Please try again in a few minutes.', request: null };
            }
            return {};
          });
        }
      });

      // Set the error and request here to mark which request was last requested by the user.
      this.setState({
        error: null,
        request: request
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.state.subscribers, this.state.request !== null, this.state.error);
    }
  }]);

  return SubscriberQuery;
}(_react.Component);

SubscriberQuery.propTypes = {
  pageCode: _propTypes2.default.string.isRequired,
  limit: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.func.isRequired,
  updatedAt: _propTypes2.default.string.isRequired,

  page: _propTypes2.default.number,
  sortDirection: _propTypes2.default.oneOf(['asc', 'desc']),
  sortField: _propTypes2.default.oneOf(['primary', 'created_at', 'quarantined_at']),
  subscriberType: _propTypes2.default.oneOf(['email', 'sms', 'webhook']),
  subscriberState: _propTypes2.default.oneOf(['active', 'unconfirmed', 'quarantined'])
};
SubscriberQuery.defaultProps = {
  page: 0,
  sortDirection: 'asc',
  sortField: 'primary',
  subscriberType: 'email',
  subscriberState: 'active'
};
exports.default = SubscriberQuery;


module.exports = SubscriberQuery;

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriber = __webpack_require__(113);

var _subscriber2 = _interopRequireDefault(_subscriber);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResendConfirmationLink = function (_React$Component) {
  _inherits(ResendConfirmationLink, _React$Component);

  function ResendConfirmationLink() {
    _classCallCheck(this, ResendConfirmationLink);

    return _possibleConstructorReturn(this, (ResendConfirmationLink.__proto__ || Object.getPrototypeOf(ResendConfirmationLink)).apply(this, arguments));
  }

  _createClass(ResendConfirmationLink, [{
    key: '_success',
    value: function _success() {
      HRB.utils.notify('Sent confirmation link to: ' + this.props.email + '.');
    }
  }, {
    key: '_failure',
    value: function _failure() {
      HRB.utils.notify('Unable to send confirmation link. Try again soon.');
    }
  }, {
    key: '_resendSubscriberConfirmation',
    value: function _resendSubscriberConfirmation() {
      if (this.props.destination === 'manage') {
        _subscriber2.default.resendConfirmation(this.props.pageCode, this.props.subscriberCode).then(this._success.bind(this), this._failure);
      } else {
        _jquery2.default.post('/resend_confirmation/' + this.props.subscriberCode).done(this._success.bind(this)).fail(this._failure);
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'a',
        { href: '#',
          onClick: function onClick() {
            return _this2._resendSubscriberConfirmation();
          },
          ref: 'anchor' },
        this.props.text
      );
    }
  }]);

  return ResendConfirmationLink;
}(_react2.default.Component);

ResendConfirmationLink.propTypes = {
  pageCode: _propTypes2.default.string.isRequired, // Page of the subscriber
  subscriberCode: _propTypes2.default.string.isRequired, // The subscriber code itself
  text: _propTypes2.default.string.isRequired, // The text to display with the link
  email: _propTypes2.default.string.isRequired, // The email to display in the success prompt
  destination: _propTypes2.default.oneOf(['status', 'manage']).isRequired // There are two API endpoints to simplify calling from admin and subscriber contexts.
};

module.exports = ResendConfirmationLink;

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(58);

var _confirm2 = _interopRequireDefault(_confirm);

var _form = __webpack_require__(134);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(171),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);

var Input = __webpack_require__(42);
var TextArea = __webpack_require__(140);

var DELETE_MODAL = 'delete-provider';
var DELETE_MODAL_TRIGGER = MODAL_PREFIX + DELETE_MODAL;

var SAVE_MODAL = 'save-provider';
var SAVE_MODAL_TRIGGER = MODAL_PREFIX + SAVE_MODAL;

var SingleSignOnForm = function (_React$Component) {
  _inherits(SingleSignOnForm, _React$Component);

  function SingleSignOnForm() {
    _classCallCheck(this, SingleSignOnForm);

    return _possibleConstructorReturn(this, (SingleSignOnForm.__proto__ || Object.getPrototypeOf(SingleSignOnForm)).apply(this, arguments));
  }

  _createClass(SingleSignOnForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      HRB.utils.djshook('tooltip').tooltip();
    }
  }, {
    key: '_entityId',
    value: function _entityId() {
      return 'https://' + this.props.entity_uuid + '.' + this.props.domain + '/';
    }
  }, {
    key: '_emailNodeField',
    value: function _emailNodeField() {
      if (this.props.access_controlled_page) {
        return React.createElement(
          'div',
          { className: 'span12' },
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: 'Page Access User Email Node',
            name: 'email_node_name',
            placeholder: 'Page Access User Email Node',
            defaultValue: this.props.provider.email_node_name,
            helpBlockText: 'This is the attribute we\'ll use to set an email address for your Page Access Users. We suggest you use \'email\'' })
        );
      }
    }
  }, {
    key: '_handleDelete',
    value: function _handleDelete() {
      $.ajax({
        type: 'DELETE',
        url: this.props.path,
        dataType: 'JSON',
        success: function success(data, textStatus, xhr) {
          window.location.reload(true);
        },
        error: function error(xhr, textStatus, errorThrown) {
          HRB.utils.notify("Sorry, it looks like deleting your SSO configuration failed", { cssClass: 'error' });
        }
      });
    }
  }, {
    key: '_deleteButton',
    value: function _deleteButton() {
      if (this.props.ownerHasRestriction) {
        return React.createElement(
          'a',
          { href: '#', method: 'DELETE', onClick: this._triggerModal.bind(this, DELETE_MODAL_TRIGGER), className: 'small' },
          'Remove SSO Restriction'
        );
      }
    }
  }, {
    key: '_triggerModal',
    value: function _triggerModal(modalId, e) {
      e.preventDefault();
      e.stopPropagation();
      $(ReactDOM.findDOMNode(this)).find('#' + modalId).modal();
    }
  }, {
    key: '_submitForm',
    value: function _submitForm() {
      $(ReactDOM.findDOMNode(this)).find('#sso-idp-form').submit();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'h5',
          { className: 'step-header' },
          'Step 1: Add The Statuspage Application In Your Identity Provider'
        ),
        React.createElement(
          'table',
          { className: 'cpt-tabular-table' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'ACS URL / Consumer URL ',
                React.createElement(
                  'span',
                  { className: 'tooltip-base', 'data-js-hook': 'tooltip', 'data-original-title': 'This is the URL is where your Identity Provider will send SAML assertions, and will be required in your Identity Provider\'s admin when setting up a Statuspage app.' },
                  '?'
                )
              ),
              React.createElement(
                'th',
                null,
                'EntityID / Audience URI ',
                React.createElement(
                  'span',
                  { className: 'tooltip-base', 'data-js-hook': 'tooltip', 'data-original-title': 'This is the value you\'ll need to enter in the \'Entity ID\' field in your Identity Provider\'s configuration. This may also be referred to as \'Audience Restriction\' or \'Audience URI\'.' },
                  '?'
                )
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { className: 'consumeURL' },
                ' ',
                this.props.sso_saml_consume_url,
                ' '
              ),
              React.createElement(
                'td',
                { className: 'entityID' },
                ' ',
                this._entityId(),
                ' '
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'align-center', style: { marginTop: '8px' } },
          React.createElement(
            'small',
            null,
            'You can also view the entire ',
            React.createElement(
              'a',
              { href: this.props.metadata_path, target: '_blank' },
              'service provider metadata XML file for this ',
              this.props.ownerType
            )
          )
        ),
        React.createElement(
          'h5',
          { className: 'step-header' },
          'Step 2: Paste In The SSO Target URL And Certificate Returned By Your IDP'
        ),
        React.createElement(
          _form2.default,
          { 'for': 'SsoIdentityProvider', id: 'sso-idp-form', onSubmit: this._triggerModal.bind(this, SAVE_MODAL_TRIGGER), method: this.props.ownerHasRestriction ? 'PUT' : 'POST', action: this.props.path },
          React.createElement('input', { type: 'hidden', name: 'entity_uuid', value: this.props.entity_uuid }),
          React.createElement('input', { type: 'hidden', name: 'owner_type', value: this.props.ownerType }),
          React.createElement('input', { type: 'hidden', name: 'owner_id', value: this.props.owner.id }),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'span12' },
              React.createElement(Input, { type: 'text',
                inputClass: 'full-width',
                label: 'SSO Target URL',
                name: 'sso_target_url_text',
                placeholder: 'SSO Target URL',
                defaultValue: this.props.provider.sso_target_url_text,
                helpBlockText: 'ACS URL used to log in to your SSO provider.' })
            ),
            this._emailNodeField(),
            React.createElement(
              'div',
              { className: 'span12 text-area-container' },
              React.createElement(TextArea, { inputClass: 'full-width',
                label: 'Certificate',
                name: 'certificate',
                placeholder: 'Paste in x.509 encoded certificate exactly as it\'s given by your Identity Provider, including the header and footer line.',
                defaultValue: this.props.provider.certificate,
                textareaStyle: { height: 460 } })
            )
          ),
          React.createElement(
            'div',
            { className: 'form-actions' },
            React.createElement(
              'button',
              { type: 'submit', className: 'cpt-button style-primary size-small' },
              this.props.ownerHasRestriction ? 'Update' : 'Save',
              ' SSO Configuration'
            ),
            React.createElement(
              'span',
              { className: 'remove-link' },
              this._deleteButton()
            )
          )
        ),
        React.createElement(_confirm2.default, { id: SAVE_MODAL,
          title: 'Hey! Just so you know...',
          message: 'By saving this record, you\'re making changes to your authentication flow, and the way your users can access our site. Just in case something is wrong, we\'ll still allow you to login with your username and password until we see a successful SAML authentication request. After that, you\'ll only be able to authenticate via SAML until you change your record again.',
          onConfirm: this._submitForm.bind(this),
          confirm_text: 'Got it, save the record.' }),
        React.createElement(_confirm2.default, { id: DELETE_MODAL,
          title: 'Hey! Just so you know...',
          message: 'Warning! This will cause your SSO configuration to be completely removed. This will force your users to login using Statuspage credentials only. This action is permanent and cannot be undone.',
          onConfirm: this._handleDelete.bind(this),
          confirm_text: 'Permanently delete',
          cancel_text: 'Don\'t Delete' })
      );
    }
  }]);

  return SingleSignOnForm;
}(React.Component);

module.exports = SingleSignOnForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SsoMetrics = function (_Component) {
  _inherits(SsoMetrics, _Component);

  function SsoMetrics() {
    _classCallCheck(this, SsoMetrics);

    return _possibleConstructorReturn(this, (SsoMetrics.__proto__ || Object.getPrototypeOf(SsoMetrics)).apply(this, arguments));
  }

  _createClass(SsoMetrics, [{
    key: "_failureRreasons",
    value: function _failureRreasons() {
      if (this.props.presenter.has_failures) {
        return _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement(
            "h6",
            null,
            "Reason for last Failure:"
          ),
          _react2.default.createElement(
            "span",
            null,
            this.props.presenter.reason_for_last_failure
          )
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Total Unique Visitors: ",
              this.props.presenter.total_unique_visitors
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Admin Visitors: ",
              this.props.presenter.admin_visitors_count
            ),
            _react2.default.createElement(
              "p",
              null,
              this.props.presenter.admin_visitors
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Page Visitors: ",
              this.props.presenter.page_visitors_count
            ),
            _react2.default.createElement(
              "p",
              null,
              this.props.presenter.page_visitors
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Issuing Sources"
            ),
            _react2.default.createElement(
              "p",
              null,
              this.props.presenter.issuing_sources
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Successful Auth Attempts: ",
              this.props.presenter.success_count
            ),
            _react2.default.createElement(
              "h6",
              null,
              "Failed Auth Attempts: ",
              this.props.presenter.fail_count
            ),
            this._failureRreasons()
          )
        )
      );
    }
  }]);

  return SsoMetrics;
}(_react.Component);

module.exports = SsoMetrics;

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrideConversationListItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StrideConversationListItem = exports.StrideConversationListItem = function StrideConversationListItem(_ref) {
  var name = _ref.name,
      cloudId = _ref.cloudId,
      conversationId = _ref.conversationId;
  return _react2.default.createElement(
    'div',
    { className: 'table-row' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'name' },
        name
      ),
      _react2.default.createElement(
        'span',
        { className: 'actions' },
        _react2.default.createElement(
          'a',
          { href: 'https://app.stride.com/' + cloudId + '/chat/' + conversationId },
          'Manage'
        )
      )
    )
  );
};

StrideConversationListItem.propTypes = {
  name: _propTypes2.default.string.isRequired,
  cloudId: _propTypes2.default.string.isRequired,
  conversationId: _propTypes2.default.string.isRequired,
  code: _propTypes2.default.string.isRequired
};

var StrideConversations = function StrideConversations(_ref2) {
  var conversations = _ref2.conversations;
  return _react2.default.createElement(
    'div',
    { className: 'cpt-table standard-two-row' },
    _react2.default.createElement(
      'div',
      { id: 'stride-conversations', className: 'stride-conversations content' },
      _react2.default.createElement(
        'div',
        { className: 'header' },
        'Connected conversations'
      ),
      conversations.map(function (conversation) {
        return _react2.default.createElement(StrideConversationListItem, _extends({ key: conversation.code, id: conversation.code }, conversation));
      })
    )
  );
};

StrideConversations.propTypes = {
  conversations: _propTypes2.default.arrayOf(_propTypes2.default.shape(StrideConversationListItem.propTypes)).isRequired
};

exports.default = StrideConversations;

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrideConversationListItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StrideConversationListItem = exports.StrideConversationListItem = function StrideConversationListItem(_ref) {
  var name = _ref.name,
      cloudId = _ref.cloudId,
      conversationId = _ref.conversationId;
  return _react2.default.createElement(
    'div',
    { className: 'table-row' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'name' },
        name
      ),
      _react2.default.createElement(
        'span',
        { className: 'actions' },
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { scope: 'col' },
                'Cloud ID'
              ),
              _react2.default.createElement(
                'td',
                null,
                cloudId
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { scope: 'col' },
                'Conversation ID'
              ),
              _react2.default.createElement(
                'td',
                null,
                conversationId
              )
            )
          )
        )
      )
    )
  );
};

StrideConversationListItem.propTypes = {
  name: _propTypes2.default.string.isRequired,
  cloudId: _propTypes2.default.string.isRequired,
  conversationId: _propTypes2.default.string.isRequired,
  code: _propTypes2.default.string.isRequired
};

var StrideConversationsAdminInfo = function StrideConversationsAdminInfo(_ref2) {
  var conversations = _ref2.conversations;
  return _react2.default.createElement(
    'div',
    { className: 'cpt-admin-callout' },
    _react2.default.createElement(
      'div',
      { className: 'cpt-admin-callout-title' },
      _react2.default.createElement('i', { className: 'fa fa-info-circle' }),
      ' Admin Info'
    ),
    _react2.default.createElement(
      'div',
      { className: 'cpt-admin-callout-display' },
      _react2.default.createElement(
        'div',
        { className: 'cpt-table standard-two-row' },
        _react2.default.createElement(
          'div',
          { id: 'stride-conversations', className: 'stride-conversations content admin-info' },
          _react2.default.createElement(
            'div',
            { className: 'table-row-group' },
            conversations.map(function (conversation) {
              return _react2.default.createElement(StrideConversationListItem, _extends({ key: conversation.code }, conversation));
            })
          )
        )
      )
    )
  );
};

StrideConversationsAdminInfo.propTypes = {
  conversations: _propTypes2.default.arrayOf(_propTypes2.default.shape(StrideConversationListItem.propTypes)).isRequired
};

exports.default = StrideConversationsAdminInfo;

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _server = __webpack_require__(172);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ESSearchField = __webpack_require__(237);
var moment = __webpack_require__(2);

var Subscriber = __webpack_require__(113);

var SubscribersSearchField = function (_React$Component) {
  _inherits(SubscribersSearchField, _React$Component);

  function SubscribersSearchField() {
    _classCallCheck(this, SubscribersSearchField);

    return _possibleConstructorReturn(this, (SubscribersSearchField.__proto__ || Object.getPrototypeOf(SubscribersSearchField)).apply(this, arguments));
  }

  _createClass(SubscribersSearchField, [{
    key: '_template',

    // Get HTML string for how a typeahead item should be rendered
    value: function _template(suggestion) {
      var view = React.createElement(SubscriberTypeaheadView, { suggestion: suggestion });
      return _server2.default.renderToString(view);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var searchRoute = ApiRoutes.page_subscribers_url({ pageCode: this.props.page.id });
      var mapResultToUiRoute = function mapResultToUiRoute(suggestion) {
        return Routes.page_subscriber_url(_this2.props.page, suggestion.id, { domain: null, subdomain: null });
      };
      return React.createElement(
        'div',
        { className: 'subscriber-search-field-wrapper' },
        React.createElement(ESSearchField, { queryUrl: searchRoute + '?limit=10&state=all&q=%QUERY',
          pluralizedResultName: "subscribers",
          loadResults: Subscriber.search,
          mapResultToUiUrl: mapResultToUiRoute,
          template: this._template.bind(this)
        })
      );
    }
  }]);

  return SubscribersSearchField;
}(React.Component);

var SubscriberTypeaheadView = function (_React$Component2) {
  _inherits(SubscriberTypeaheadView, _React$Component2);

  function SubscriberTypeaheadView() {
    _classCallCheck(this, SubscriberTypeaheadView);

    return _possibleConstructorReturn(this, (SubscriberTypeaheadView.__proto__ || Object.getPrototypeOf(SubscriberTypeaheadView)).apply(this, arguments));
  }

  _createClass(SubscriberTypeaheadView, [{
    key: '_determineType',
    value: function _determineType(suggestion) {

      if (suggestion.hasOwnProperty('endpoint')) {
        return {
          iconClass: 'fa-share-alt',
          matchValue: suggestion.endpoint
        };
      } else if (suggestion.hasOwnProperty('email')) {
        return {
          iconClass: 'fa-envelope',
          matchValue: suggestion.email
        };
      } else if (suggestion.hasOwnProperty('phone_number')) {
        return {
          iconClass: 'fa-phone',
          matchValue: suggestion.phone_display
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var suggestion = this.props.suggestion;
      var subscriberData = this._determineType(suggestion);

      var itemClasses = "item search-result es-results";
      if (suggestion.quarantined_at) {
        itemClasses = itemClasses + " es-result-quarantined-subscriber";
      }

      return React.createElement(
        'div',
        { className: itemClasses },
        React.createElement(
          'div',
          { className: 'icon-container' },
          React.createElement('i', { className: 'fa ' + subscriberData.iconClass })
        ),
        React.createElement(
          'div',
          { className: 'result-text-container' },
          subscriberData.matchValue
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return SubscriberTypeaheadView;
}(React.Component);

module.exports = SubscribersSearchField;

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(4);

var UnsubscribeButton = function (_React$Component) {
  _inherits(UnsubscribeButton, _React$Component);

  function UnsubscribeButton() {
    _classCallCheck(this, UnsubscribeButton);

    return _possibleConstructorReturn(this, (UnsubscribeButton.__proto__ || Object.getPrototypeOf(UnsubscribeButton)).apply(this, arguments));
  }

  _createClass(UnsubscribeButton, [{
    key: '_unsubscribe',
    value: function _unsubscribe() {
      var _this2 = this;

      $.ajax({
        type: "DELETE",
        url: Routes.page_deactivate_subscribers_url(this.props.page, this.props.subscriber)
      }).success(function (msg) {
        HRB.utils.notify('Subscriber successfully unsubscribed.', { method: 'deferred' });
        window.location = Routes.notifications_page_url(_this2.props.page, { domain: null, subdomain: null });
      }).fail(function () {
        HRB.utils.basicFailAndReload();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'a',
        { className: 'cpt-button style-primary size-small pull-right',
          onClick: this._unsubscribe.bind(this) },
        'UNSUBSCRIBE'
      );
    }
  }]);

  return UnsubscribeButton;
}(React.Component);

module.exports = UnsubscribeButton;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tooltip__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_resources_types__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__unsubscribe_confirmation_modal__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_notify__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__heading__ = __webpack_require__(984);








var tooltipTitle = function (subscriber, page) {
    return "This page allows you to fine-tune which components matter to you. You will receive " + __WEBPACK_IMPORTED_MODULE_4_resources_types__["a" /* Subscriber */].displayMode(subscriber) + " notifications when " + page.name + " is having an issue that affects any of the selected components.";
};
var unsubscribe = function (page, subscriber) {
    $('#modal-confirmation-confirmationModalId').modal();
};
var onConfirmUnsubscribe = function (page, subscriber) {
    $.ajax({
        url: "/unsubscribe/" + subscriber.id + ".json",
        type: 'DELETE',
        dataType: 'json',
        complete: function (response) {
            Object(__WEBPACK_IMPORTED_MODULE_6_utils_notify__["b" /* default */])('You have been unsubscribed!', { method: __WEBPACK_IMPORTED_MODULE_6_utils_notify__["a" /* Method */].DEFERRED });
            window.location.href = window.location.origin;
        },
        error: function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_6_utils_notify__["b" /* default */])('You could not be unsubscribed. Contact support if this problem persists.', { method: __WEBPACK_IMPORTED_MODULE_6_utils_notify__["a" /* Method */].SHOW });
            console.error('Failed to unsubscribe subscriber.', error);
        },
    });
};
var ManageSubscription = function (_a) {
    var page = _a.page, subscriber = _a.subscriber, components = _a.components, selectedComponentIds = _a.selectedComponentIds;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__heading__["a" /* default */], { subscriber: subscriber, onUnsubscribe: function () { return unsubscribe(page, subscriber); } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_form__["default"], { action: window.Routes.manage_path(subscriber.id), method: "PATCH" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Components"),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                        "(",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", style: { cursor: 'pointer' }, "data-js-hook": "toggle-all", id: "component-selector-toggle" }, "Toggle all"),
                        ")")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_tooltip__["a" /* default */], { title: tooltipTitle(subscriber, page) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "What's this?"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector__, { className: "inline", items: components, preselectedItemIds: selectedComponentIds, showHeader: false, showFooter: false, hiddenFieldName: "subscriber[component_ids]", toggleAllclickTargetId: "component-selector-toggle" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "flat-button", type: "submit" }, "Update Preferences"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__unsubscribe_confirmation_modal__["a" /* default */], { page: page, subscriber: subscriber, onConfirm: function () { return onConfirmUnsubscribe(page, subscriber); } })));
};
/* harmony default export */ __webpack_exports__["default"] = (ManageSubscription);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resources_types__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_confirm__ = __webpack_require__(58);



var UnsubscribeConfirmationModal = function (_a) {
    var page = _a.page, subscriber = _a.subscriber, onConfirm = _a.onConfirm;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_confirm__["default"], { id: "confirmationModalId", title: "Confirm Unsubscribe", onConfirm: onConfirm, confirm_text: "Unsubscribe from updates", confirmClass: "style-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { padding: '1em' } },
            "Click the confirm button below to unsubscribe",
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, __WEBPACK_IMPORTED_MODULE_1_resources_types__["a" /* Subscriber */].identifier(subscriber)),
            " from all",
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, page.name),
            " updates.")));
};
/* harmony default export */ __webpack_exports__["a"] = (UnsubscribeConfirmationModal);


/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resources_types__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_page_colors__ = __webpack_require__(258);



var pageColors = new __WEBPACK_IMPORTED_MODULE_2_page_colors__["default"](window.pageColorData);
var styles = __webpack_require__(985);
var Header = function (_a) {
    var children = _a.children;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: pageColors.font.hex } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, children));
};
var Heading = function (_a) {
    var subscriber = _a.subscriber, onUnsubscribe = _a.onUnsubscribe;
    var mode = __WEBPACK_IMPORTED_MODULE_1_resources_types__["a" /* Subscriber */].displayMode(subscriber);
    var identifier = __WEBPACK_IMPORTED_MODULE_1_resources_types__["a" /* Subscriber */].identifier(subscriber);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.subscriberHeading },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header, null, "Subscriber"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.border, style: { borderColor: pageColors.border.hex } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: styles.mode, style: { color: pageColors.font.hex } }, mode),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: styles.identifier, style: { color: pageColors.font.hex } }, identifier),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: styles.unsubscribeButton, style: { color: pageColors.red.hex }, onClick: onUnsubscribe }, "Cancel Subscription"))));
};
/* harmony default export */ __webpack_exports__["a"] = (Heading);


/***/ }),

/***/ 985:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"border":"_1d5QtSwZOwprVdjPssPV8u","mode":"_33zOGaZ4e38U43m3lIR4bD","identifier":"_1g2BQlJ4RmQzO7sH0D5AxW","unsubscribeButton":"_3JWHwui2MHYxH82VbMXz43"};

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_time_picker__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_date_picker__ = __webpack_require__(114);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DateTimePicker = /** @class */ (function (_super) {
    __extends(DateTimePicker, _super);
    function DateTimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDate = function (date) {
            _this.setState({ date: date.tz(_this.props.timezone) });
        };
        var now = __WEBPACK_IMPORTED_MODULE_1_moment_timezone__().tz(props.timezone);
        _this.state = { date: now };
        return _this;
    }
    DateTimePicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "date-time-picker row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "backfill-date-picker span6" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_date_picker__["a" /* default */], { onChange: this.updateDate, selectedDate: this.state.date, disabled: false })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "backfill-time-picker span6" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_time_picker__["a" /* default */], { onChange: this.updateDate, selectedDate: this.state.date, disabled: false })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: "incident[backfill_date]", value: this.state.date.toISOString() })));
    };
    DateTimePicker.defaultProps = {
        timezone: 'UTC',
        timezoneDisplay: 'UTC',
    };
    return DateTimePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["default"] = (DateTimePicker);


/***/ })

},[834]);


// WEBPACK FOOTER //
// components-92f85cba40cb712f7c73.js